import { createI18n } from 'vue-i18n/index';

const messages = {
  en: {
    signInTitle: 'Sign In to AlHisba Admin',
    signInAppraiser: 'Sign In Appraisers',
    signInBanks: 'Sign In Banks',
    email: 'Email',
    emailAddress: 'Email Address',
    password: 'Password',
    continue: 'Continue',
    alternativeLocale: 'AlHisba is also offered in: {0}',
    alternativeLocaleVal: 'العربية',
    pleaseWait: 'Please wait...',
    tryAgainExcl: 'Try again!',
    searchAdmins: 'Search Admins',
    addNewAdmin: 'Add New Admin',
    addNewAuction: 'Add New Auction',
    addNewAppraiser: 'Add New Appraiser',
    addNewBank: 'Add New Bank',
    addNewAnswer: 'Add New Answer',
    addNewLandSizeOption: 'Add New Land Size Option',
    addNewDirectionOption: 'Add New Direction Option',
    addNewSabahCitySpecsOption: 'Add New Sabah City Specs Option',
    addNewLocationSpecsOption: 'Add New Location Specs Option',
    addNewStreetOption: 'Add New Street Option',
    addNewLocationOption: 'Add New Location Option',
    addNewBuildingAgeOption: 'Add New Building Age Option',
    addNewFinishingQualityOption: 'Add New Finishing Quality Option',
    addNewFloorsOption: 'Add New Floors option',
    addNewCurbOption: 'Add New Curb Option',
    addNewPlotSpecsOption: 'Add New Plot Specs Option',
    addNewOrganizer: 'Add New Organizer',
    addNewLocation: 'Add New Location',
    addNewRole: 'Add New Role',
    addNewQualityRangeOption: 'Add New Quality Range Option',
    addNewAdType: 'Add New Ad Type',
    addNewProperty: 'Add New Property',
    addNewIveValue: 'Add New IVE Value',
    updateIreValue: 'Update  Ire Value',
    UpdateExistingValues: 'Update Existing Values',
    addNewFaq: 'Add New FAQ',
    addNewArea: 'Add New Area',
    addNewIVEAreaValue: 'Add New IVE Area Value',
    addNewPropertyTypes: 'Add New Property Type',
    addNewAuctionLocation: 'Add New Auction Location',
    addNewAuctionDescription: 'Add New Auction Description',
    addNewPropertyCategory: 'Add New Property Category',
    addNewFacingOption: 'Add New Facing Option',
    addNewBanner: 'Add New Banner',
    addNewBlog: 'Add New Blog',
    addNewBankRate: 'Add New Bank Rate',
    addNewQualityGroup: 'Add New Quality Group',
    addNewGroupQuestion: 'Add New Group Question',
    addNewIreArea: 'Add New Ire Area',
    addNewIreType: 'Add New Ire Type',
    addNewIreSize: 'Add New Ire Size',
    addNewIreFactorBathrooms: 'Add New Ire Factor Bathroom',
    addNewIreFactorsOptions: 'Add New Ire Factor Option',
    addNewIreFactorsQualitys: 'Add New Ire Factor Quality',
    addNewIreFactorsLocationSpecs: 'Add New Ire Factor Location Specs',
    addNewIreFactorGeneralspecs: 'Add New Ire Factor General specs',
    addNewIreFactorsPropertyService: 'Add New Ire Factor Propert Service',
    INVALID_EMAIL_PASSWORD: 'The username or password you entered is incorrect',
    INVALID_LONGITUDE: 'Longitude value is not valid',
    INVALID_LATITUDE: 'Latitude value is not valid',
    EMAIL_NOT_VALID: 'Email must be a valid email',
    EMAIL_IS_REQUIRED_FIELD: 'Email is a required field',
    PASSWORD_IS_REQUIRED_FIELD: 'Password is a required field',
    VERIFY_PASSWORD_IS_REQUIRED_FIELD: 'Verify Password is a required field',
    PASSWORDS_MUST_MATCH: 'Passwords must match',
    FULL_NAME_IS_REQUIRED_FIELD: 'Full Name is a required field',
    APPRAISER_NAME_IS_REQUIRED_FIELD: 'Appraiser Name is a required field',
    PHONE_IS_REQUIRED_FIELD: 'Phone is a required field',
    PHONE_NUMBER_IS_REQUIRED_FIELD: 'Phone Number is a required field',
    LOGO_IS_REQUIRED_FIELD: 'Logo is a required field',
    BANK_DETAILS_IS_REQUIRED_FIELD: 'Bank Account Details is a required field',
    PERSON_NAME_IS_REQUIRED_FIELD: 'Contact Person Name is a required field',
    PERSON_PHONE_IS_REQUIRED_FIELD: 'Contact Person Phone is a required field',
    EN_NAME_IS_REQUIRED_FIELD: 'English Name is a required field',
    EN_SIZE_IS_REQUIRED_FIELD: 'English Size is a required field',
    AR_SIZE_IS_REQUIRED_FIELD: 'Arabic Size is a required field',
    AR_NAME_IS_REQUIRED_FIELD: 'Arabic Name is a required field',
    SCORE_IS_REQUIRED_FIELD: 'Score is a required field',
    EN_VALUE_IS_REQUIRED_FIELD: 'English Value is a required field',
    AR_VALUE_IS_REQUIRED_FIELD: 'Arabic Value is a required field',
    FROM_RANGE_IS_REQUIRED_FIELD: 'From range is a required field',
    TO_RANGE_IS_REQUIRED_FIELD: 'To range is a required field',
    AR_QUESTION_IS_REQUIRED_FIELD: 'Arabic Question is a required field',
    AR_TITLE_IS_REQUIRED_FIELD: 'Arabic title is a required field',
    IMAGE_URL_IS_REQUIRED_FIELD: 'Image URL is a required field',
    URL_IS_REQUIRED_FIELD: 'URL is a required field',
    AR_ANSWER_IS_REQUIRED_FIELD: 'Arabic Answer is a required field',
    EN_QUESTION_IS_REQUIRED_FIELD: 'English Question is a required field',
    EN_ANSWER_IS_REQUIRED_FIELD: 'English Answer is a required field',
    EN_VENUE_IS_REQUIRED_FIELD: 'English Venue  is a required field',
    EN_TITLE_IS_REQUIRED_FIELD: 'English  title is a required field',
    LATITUDE_IS_REQUIRED_FIELD: 'Latitude is a required field',
    LONGITUDE_IS_REQUIRED_FIELD: 'Longitude  is a required field',
    AR_VENUE_IS_REQUIRED_FIELD: 'Arabic Venue  is a required field',
    AREA_VALUE_IS_REQUIRED_FIELD: 'Area Value is a required field',
    PRICE_VALUE_IS_REQUIRED_FIELD: 'Price Value is a required field',
    ACTIVE_STATUS_IS_REQUIRED_FIELD: 'Active Status is a required field',
    REJECTION_NOTE_IS_REQUIRED_FIELD: 'Rejection note is a required field',
    AUCTION_STATUS_IS_REQUIRED_FIELD: 'Auction Status is a required field',
    REQUEST_STATUS_IS_REQUIRED_FIELD: 'Request Status is a required field',
    DESCRIPTION_IS_REQUIRED_FIELD: 'Description is is a required field',
    ROLE_GROUP_IS_REQUIRED_FIELD: 'Role group is a required field',
    WEIGHT_IS_REQUIRED_FIELD: 'Weight is a required field',
    GROUP_ID_IS_REQUIRED_FIELD: 'Group id is a required field',
    SORT_IS_REQUIRED_FIELD: 'Sort is a required field',
    ORGANIZER_IS_REQUIRED_FIELD: 'Organizer is a required field',
    EVENT_DATE_TIME_IS_REQUIRED_FIELD:
      'Event Date and Time is a required field',
    ORGANIZER_LOCATION__IS_REQUIRED_FIELD:
      'Organizer Location is a required field',
    BANNER_TYPE_IS_REQUIRED_FIELD: 'Banner Type is a required field',
    SCREEN_BANNER_IS_REQUIRED_FIELD: 'Screen banner is a required field',
    ACTION_BANNER_IS_REQUIRED_FIELD: 'Action banner is a required field',
    EXTERNAL_LINK_IS_REQUIRED_FIELD: 'External link is a required field',
    EXTERNAL_LINK_EN_IS_REQUIRED_FIELD: 'External link En is a required field',
    EXTERNAL_LINK_AR_IS_REQUIRED_FIELD: 'External link Ar is a required field',
    EXTERNAL_LINK_WEB_EN_IS_REQUIRED_FIELD:
      'External link Web En is a required field',
    EXTERNAL_LINK_WEB_AR_IS_REQUIRED_FIELD:
      'External link WebAr is a required field',
    ENTITY_ID_IS_REQUIRED_FIELD: 'Entity id is a required field',
    MERCHANT_IS_REQUIRED_FIELD: 'Merchant is a required field',
    ROLE_IS_REQUIRED_FIELD: 'Role is a required field',
    ROLE_NAME_IS_REQUIRED_FIELD: 'Role name  is a required field',
    NON_CLIENT_PERCENTAGE_IS_REQUIRED_FIELD:
      'Non client Percentage is a required field',
    BASE_PRICE_IS_REQUIRED_FIELD: 'Base price is a required field',
    ELECTRICITY_IS_REQUIRED_FIELD: 'electricity is a required field',
    PERCENT_IS_REQUIRED_FIELD: 'Percent is a required field',
    PASSWORD_AT_LEAST_ONE_NUMBER: 'Password must contain at least one number',
    PASSWORD_AT_LEAST_ONE_LOWER:
      'Password must contain at least one lowercase character',
    PASSWORD_AT_LEAST_ONE_UPPER:
      'Password must contain at least one uppercase character',
    PASSWORD_AT_LEAST_ONE_SPECIAL:
      'Password must contain at least one special character',
    SUCCESSFULLY_CREATED_ADMIN: 'Successfully created a new admin!',
    SUCCESSFULLY_CREATED_LOCATION: 'Successfully created a new location!',
    SUCCESSFULLY_CREATED_APPRAISER: 'Successfully created a new appraiser!',
    SUCCESSFULLY_CREATED_AD_PACKAGE: 'Successfully created a new ad package!',
    SUCCESSFULLY_CREATED_AUCTION: 'Successfully created a new auction!',
    SUCCESSFULLY_CREATED_ADS_SERVICE: 'Successfully created a new ads service!',
    SUCCESSFULLY_CREATED_IRE_AREA: 'Successfully created a new Ire area!',
    SUCCESSFULLY_CREATED_IRE_VALUE: 'Successfully created a new Ire Value',
    SUCCESSFULLY_UPDATED_APPRAISER: 'Successfully updated appraiser!',
    SUCCESSFULLY_UPDATED_AUCTION: 'Successfully updated auction!',
    SUCCESSFULLY_UPDATED_ADS_PACKAGE: 'Successfully updated ad package',
    SUCCESSFULLY_ADDED_AD_SERVICE: 'Successfully Added a new ad service',
    SUCCESSFULLY_UPDATED_BANNER: 'Successfully updated banner!',
    SUCCESSFULLY_ADDED_APPRAISER_BANKS: 'Successfully added appraiser banks!',
    SUCCESSFULLY_ADDED_AD_PACKAGE_SERVICES:
      'Successfully added ad package services!',
    SUCCESSFULLY_UPLOADED_AUCTION_VIDEO: 'Successfully uploaded auction video!',
    SUCCESSFULLY_UPLOAD_BANK_RATES: 'Successfully upload bank rates',
    SUCCESSFULLY_UPDATED_APPRAISER_BANKS:
      'Successfully updated appraiser banks!',
    SUCCESSFULLY_ADDED_APPRAISER_PRICES: 'Successfully added appraiser prices!',
    SUCCESSFULLY_CREATED_BANK: 'Successfully created a new bank!',
    SUCCESSFULLY_CREATED_ANSWER: 'Successfully created a new answer!',
    SUCCESSFULLY_CREATED_IVE_VALUE: 'Successfully created a new IVE value!',
    SUCCESSFULLY_UPDATED_GROUP_QUESTION: 'Successfully updated group question!',
    SUCCESSFULLY_UPDATED_STREET_OPTION: 'Successfully updated street option!',
    SUCCESSFULLY_CREATED_GROUP_QUESTION:
      'Successfully created a new group question!',
    SUCCESSFULLY_CREATED_STREET_OPTION:
      'Successfully created a new street option!',
    SUCCESSFULLY_CREATED_LAND_SIZE_OPTION:
      'Successfully created a new land size option!',
    SUCCESSFULLY_CREATED_PLOT_SPECS_OPTION:
      'Successfully created a new plot specs option!',
    SUCCESSFULLY_CREATED_LOCATION_SPECS_OPTION:
      'Successfully created a new location specs option!',
    SUCCESSFULLY_CREATED_DIRECTION_OPTION:
      'Successfully created a new direction option!',
    SUCCESSFULLY_CREATED_SABAH_CITY_SPECS_OPTION:
      'Successfully created a new sabah city specs option!',
    SUCCESSFULLY_CREATED_FACING_OPTION:
      'Successfully created a new facing option!',
    SUCCESSFULLY_CREATED_BUILDING_AGE_OPTION:
      'Successfully created a new building age option!',
    SUCCESSFULLY_CREATED_FLOOR_OPTION:
      'Successfully created a new floor option!',
    SUCCESSFULLY_CREATED_ORGANIZER: 'Successfully created a new organizer!',
    SUCCESSFULLY_CREATED_BANNER: 'Successfully created a new banner!',
    SUCCESSFULLY_CREATED_ROLE: 'Successfully created a new role!',
    SUCCESSFULLY_CREATED_BANK_RATE: 'Successfully created a new bank rate!',
    SUCCESSFULLY_CREATED_AD_TYPE: 'Successfully created a new ad type!',
    SUCCESSFULLY_CREATED_PROPERTY: 'Successfully created a new property!',
    SUCCESSFULLY_CREATED_FAQ: 'Successfully created a new FAQ!',
    SUCCESSFULLY_CREATED_AREA: 'Successfully created a new area!',
    SUCCESSFULLY_PULLED_DATA: 'Successfully pulled data!',
    SUCCESSFULLY_CREATED_NEWS: 'Successfully created a new news!',
    SUCCESSFULLY_CREATED_PROPERTY_TYPE:
      'Successfully created a new property type!',
    SUCCESSFULLY_CREATED_AUCTION_LOCATION:
      'Successfully created a new auction location!',
    SUCCESSFULLY_CREATED_AUCTION_DESCRIPTION:
      'Successfully created a new auction description!',
    SUCCESSFULLY_CREATED_LOCATION_OPTION:
      'Successfully created a new location option!',
    SUCCESSFULLY_CREATED_CURB_OPTION: 'Successfully created a new curb!',
    SUCCESSFULLY_CREATED_FINISHING_QUALITY_OPTION:
      'Successfully created a new finishing quality option!',
    SUCCESSFULLY_CREATED_IRE_TYPE: 'Successfully created a new Ire Type',
    SUCCESSFULLY_CREATED_IRE_SIZE: 'Successfully created a new Ire Size',
    SUCCESSFULLY_CREATED_IRE_FACTOR_OPTIONS:
      'Successfully created a new Ire Options',
    SUCCESSFULLY_CREATED_IRE_FACTOR_QUALITY:
      'Successfully created a new Ire Quality',
    SUCCESSFULLY_CREATED_IRE_FACTOR_BATHROOMS:
      'Successfully created a new Ire Bathrooms',
    SUCCESSFULLY_CREATED_IRE_FACTOR_GENERAL_specs:
      'Successfully created a new Ire General specs',
    SUCCESSFULLY_CREATED_IRE_FACTOR_LOACATION_specs:
      'Successfully created a new Ire Location specs',
    SUCCESSFULLY_CREATED_IRE_FACTOR_PROPERTY_SERVICE:
      'Successfully created a new Ire Property Service',

    SUCCESSFULLY_CREATED_QUALITY_RANGE_OPTION:
      'Successfully created a new quality range option!',
    SUCCESSFULLY_CREATED_QUALITY_GROUP:
      'Successfully created a new quality group!',
    SUCCESSFULLY_UPDATED_QUALITY_GROUP: 'Successfully updated quality group!',
    SUCCESSFULLY_UPDATED_QUALITY_RANGE_OPTION:
      'Successfully updated quality range option!',
    SUCCESSFULLY_UPDATED_FLOOR_OPTION: 'uccessfully updated floor option!',
    SUCCESSFULLY_UPDATED_SEA_FRONT_OPTION:
      'Successfully updated sea front option!',
    SUCCESSFULLY_UPDATED_BACK_STREET_OPTION:
      'Successfully updated back street option!',
    SUCCESSFULLY_UPDATED_BANK_RATE_SETTINGS:
      'Successfully updated bank rate settings!',
    SUCCESSFULLY_UPDATED_BUILDING_AGE_OPTION:
      'Successfully updated building age option!',
    SUCCESSFULLY_UPDATED_FINISHING_QUALITY_OPTION:
      'Successfully updated finishing quality option!',
    SUCCESSFULLY_UPDATED_BANK_RATE: 'Successfully updated bank rate!',
    SUCCESSFULLY_UPDATED_ADMIN: 'Successfully updated admin!',
    SUCCESSFULLY_UPDATED_BANK: 'Successfully updated bank!',
    SUCCESSFULLY_UPDATED_ANSWER: 'Successfully updated answer!',
    SUCCESSFULLY_UPDATED_ORGANIZER: 'Successfully updated organizer!',
    SUCCESSFULLY_UPDATED_LOCATION: 'Successfully updated location!',
    SUCCESSFULLY_UPDATED_AD_TYPE: 'Successfully updated ad type!',
    SUCCESSFULLY_UPDATED_PROPERTY: 'Successfully updated property!',
    SUCCESSFULLY_UPDATED_FAQ: 'Successfully updated FAQ!',
    SUCCESSFULLY_UPDATED_AREA: 'Successfully updated area!',
    SUCCESSFULLY_UPDATED_PROPERTY_TYPE: 'Successfully updated property type!',
    SUCCESSFULLY_UPDATED_ABOUT_US: 'Successfully updated about us!',
    SUCCESSFULLY_UPDATED_TERMS_AND_CONDITIONS:
      'Successfully updated Terms and Conditions!',
    SUCCESSFULLY_UPDATED_GROUPS_WEIGHT: 'Successfully updated groups weight!',
    SUCCESSFULLY_UPDATED_QUESTIONS_WEIGHT:
      'Successfully updated questions weight!',
    SUCCESSFULLY_UPDATED_APPRAISAL_REQUEST:
      'Successfully updated appraisal request!',
    SUCCESSFULLY_UPDATED_ROLE: 'Successfully updated role!',
    SUCCESSFULLY_UPDATED_LAND_SIZE_OPTION:
      'Successfully updated land size option!',
    SUCCESSFULLY_UPDATED_DIRECTION_OPTION:
      'Successfully updated direction option!',
    SUCCESSFULLY_UPDATED_PLOT_SPECS_OPTION:
      'Successfully updated plot specs option!',
    SUCCESSFULLY_UPDATED_LOCATION_SPECS_OPTION:
      'Successfully updated location specs option!',
    SUCCESSFULLY_UPDATED_AS_DEFAULT: 'Successfully set as default!',
    SUCCESSFULLY_UPDATED_SABAH_CITY_SPECS_OPTION:
      'Successfully updated sabah city specs option!',
    SUCCESSFULLY_UPDATED_LOCATION_OPTION:
      'Successfully updated location option!',
    SUCCESSFULLY_UPDATED_ADS_PACKAGE_SERVICES:
      'Successfully updated ads package services',
    SUCCESSFULLY_UPDATED_AD_SERVICE: 'Successfully updated ad service',
    SUCCESSFULLY_UPDATED_HEADER_DESCRIPTION:
      'Successfully updated header description',
    SUCCESSFULLY_UPDATED_DISCLAIMER_DESCRIPTION:
      'Successfully updated disclaimer description',
    SUCCESSFULLY_ACTIVEATED: 'Successfully Activated',
    SUCCESSFULLY_INACTIVATED: 'Successfully Inactivated',
    SUCCESSFULLY_UPDATED_CURB_OPTION: 'Successfully updated curb option!',
    SUCCESSFULLY_UPDATED_IRE_TYPE: 'Successfully updated ire type!',
    SUCCESSFULLY_UPDATED_IRE_SIZE: 'Successfully updated ire size!',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_BATHROOM:
      'Successfully updated ire Bathroom',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_OPTION: 'Successfully updated ire Option',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_QUALITY: 'Successfully updated ire Quality',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_GENERAL_SPECS:
      'Successfully updated ire General specs',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_LOCATION_SPECS:
      'Successfully updated ire Location specs',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_PROPERTY_SERVICES:
      'Successfully updated ire Property Services',
    SUCCESSFULLY_UPDATED_IRE_VALUE: 'Successfully updated ire value!',
    SUCCESSFULLY_SENT_NEWSLETTER: 'Successfully sent newsletter to subscribers',
    SUCCESSFULLY_APPROVED_NEWSLETTER: 'Successfully approved newsletter',
    SUCCESSFULLY_UPDATED_METATAGS: 'Successfully updated metatags',
    SUCCESSFULLY_CREATED_METATAG: 'Successfully created metatag',
    SUCCESSFULLY_UPDATED_SUBSCRIPTION: 'Successfully updated subscription',
    SUCCESSFULLY_ADDED_PROMOTION: 'Successfully added promotion',
    SUCCESSFULLY_ADDED_PACKAGE: 'Successfully added package',
    SUCCESSFULLY_UPDATED_SEO_CONFIGURATION:
      'Successfully updated SEO configuration',
    SUCCESSFULLY_CLONED_REGISTERED_TRADE_SCRAPING:
      'Successfully cloned registered trade scraping',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE_BLOCK:
      'Successfully updated registered trade block',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADES_GROUPING:
      'Successfully updated registered trades grouping',
    SUCCESSFULLY_CREATED_REGISTERED_TRADE_GROUPING:
      'Successfully created registered trade grouping',
    SUCCESSFULLY_UPDATED_INFLUENCER: 'Successfully updated influencer',
    SUCCESSFULLY_CREATED_INFLUENCER: 'Successfully created influencer',
    SUCCESSFULLY_CREATED_ADS_PROPERTY_GROUPING:
      'Successfully created ads property grouping',
    SUCCESSFULLY_UPDATED_ADS_PROPERTY_GROUPING:
      'Successfully updated ads property grouping',
    SUCCESSFULLY_CREATED_BADGE: 'Successfully created badge',
    SUCCESSFULLY_UPDATED_BADGE: 'Successfully updated badge',
    SUCCESSFULLY_UPDATED_HOME_SERVICE: 'Successfully updated home service',
    SUCCESSFULLY_CREATED_NEWSLETTER_SECTION:
      'Successfully created newsletter section',
    SUCCESSFULLY_UPDATED_NEWSLETTER_SECTION:
      'Successfully updated newsletter section',
    SUCCESSFULLY_CREATED_REGISTRATION_REASON:
      'Successfully created registration reason',
    SUCCESSFULLY_UPDATED_REGISTRATION_REASON:
      'Successfully updated registration reason',
    SUCCESSFULLY_UPDATED_AUCTION_LOCATION:
      'Successfully updated auction location!',
    SUCCESSFULLY_CREATED_AUCTION_STATUS: 'Successfully created auction status!',
    SUCCESSFULLY_UPDATED_AUCTION_STATUS: 'Successfully updated auction status!',
    SUCCESSFULLY_CREATED_BLOG_CATEGORIE: 'Successfully created blog categorie!',
    SUCCESSFULLY_UPDATED_BLOG_CATEGORY: 'Successfully updated blog category!',
    SUCCESSFULLY_ADDED_BLOG: 'Successfully added blog!',
    SUCCESSFULLY_CREATED_BLOG_TAG: 'Successfully created blog tag!',
    SUCCESSFULLY_UPDATED_BLOG_TAG: 'Successfully updated blog tag!',
    SUCCESSFULLY_ADDED_SHOP_CONFIG: 'Successfully added shop config!',
    SUCCESSFULLY_UPDATED_STREET: 'Successfully updated street!',
    PLEASE_SAVE_BEFORE_CREATING_CLONES: 'Please save before creating clones',
    PASSWORD_MIN_4: 'Password minimum length is 4 characters',
    PASSWORD_MAX_20: 'Password maximum length is 20 characters',
    SESSION_EXPIRED: 'Session Expired',
    SESSION_EXPIRED_TEXT:
      'Your session has expired. You will be redirected to the login page',
    selectPermissions: 'Select Permissions',
    permissionsCount: 'Up to {count} resources',
    attachmentsCount: '{count} attachments are available',
    permission: 'Permission',
    read: 'Read',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    price: 'Price',
    originalPrice: 'Original Price',
    images: 'Images',
    image: 'Image',
    civilId: 'Civil ID',
    allowedFileTypes: 'Allowed file types: png, jpg, jpeg.',
    appraisalPropertyStatus: 'Property Status',
    appraisalPropertyTypes: 'Property Type',
    remarks: 'Remarks',
    selectGroup: 'Select a Group...',
    selectOrganizer: 'Organizer',
    selectPropertyType: 'Property Type',
    selectAuctionLocation: 'Select Auction Location...',
    selectAuctionDescription: 'Select Auction Description...',
    selectLocation: 'Select a Location...',
    selectRole: 'Select a Role...',
    selectBanks: 'Select Banks...',
    selectFactorOptions: 'Select Factor Options...',
    selectServices: 'Select Services...',
    selectAreas: 'Areas',
    selectArea: 'Area',
    selectStatus: 'Status',
    selectAuctionStatus: 'Auction Status',
    selectAdsPackage: 'Select an Ads Package',
    selectAdTypes: 'Ad Type',
    SelectScreen: 'Select a Screen',
    selectDirection: 'Select a Direction',
    selectType: 'Select a Type',
    selectBannerType: 'select a banner type',
    selectpropertyStatus: 'Select a Property Status',
    selectRelatedBlogs: 'Select related blogs',
    selectRelatedIds: 'Select related IDs',
    roleGroupTooltip:
      'Available permissions vary based on the selected role group',
    clearAll: 'Clear All',
    basicInfo: 'Basic Info',
    propertyInfo: 'Property Info',
    backToList: 'Back to List',
    appraisalStatus0: 'Request Received',
    appraisalStatus1: 'In Review',
    appraisalStatus2: 'Rejected by Appraiser',
    appraisalStatus3: 'Accepted by Appraiser',
    appraisalStatus4: 'Report Delivered',
    appraisalRequestStatus: 'Request Status',
    idColumn: 'S.NO',
    venueEn: 'Venue Name - English',
    venueAr: 'Venue Name - Arabic',
    bankNameEn: 'Bank Name - English',
    streetNameEn: 'Street Name - English',
    organizerNameAr: 'Organizer Name - Arabic',
    organizerDescAr: 'Organizer Description - Arabic',
    organizerInfo: 'Organizer Information',
    bankNameEnLang: 'Bank Name in English Language',
    answerEnLang: 'Answer in English Language',
    answerScore: 'Answer Score',
    streetNameEnLang: 'Street Name in English Language',
    bankNameArLang: 'Bank Name in Arabic Language',
    answerArLang: 'Answer in Arabic Language',
    streetNameArLang: 'Street Name in Arabic Language',
    organizerPhone: 'Organizer Phone Number',
    organizerNameArLang: 'Organizer Name in Arabic Language',
    organizerNameEnLang: 'Organizer Name in English Language',
    organizerDescArLang: 'Organizer Description in Arabic Language',
    organizerDescEnLang: 'Organizer Description in English Language',
    venueNameArLang: 'Venue Name in Arabic Language',
    venueNameEnLang: 'Venue Name in English Language',
    bankNameAr: 'Bank Name - Arabic',
    streetNameAr: 'Street Name - Arabic',
    adTypeNameArLang: 'Ad Type Name in Arabic Language',
    adTypeNameEnLang: 'Ad Type Name in English Language',
    adTypeNameEn: 'Ad Type Name - English',
    adTypeNameAr: 'Ad Type Name - Arabic',
    propertyNameEn: 'Property Name - English',
    propertyNameAr: 'Property Name - Arabic',
    propertyTypeNameEn: 'Property Type Name - English',
    propertyTypeNameAr: 'Property Type Name - Arabic',
    auctionLocationNameEn: 'Auction Location Name - English',
    auctionLocationNameAr: 'Auction Location Name - Arabic',
    auctionDescriptionNameEn: 'Auction Description Name - English',
    auctionDescriptionNameAr: 'Auction Description Name - Arabic',
    auctionDescription: 'Auction Description',
    propertyCategoryNameEn: 'Property Category Name - English',
    propertyCategoryNameAr: 'Property Category Name - Arabic',
    propertyNameArLang: 'Property Name in Arabic Language',
    propertyNameEnLang: 'Property Name in English Language',
    propertyCategoryNameArLang: 'Property Category Name in Arabic Language',
    propertyCategoryNameEnLang: 'Property Category Name in English Language',
    questionEnLang: 'Question in English Language',
    questionArLang: 'Question in Arabic Language',
    locationSpecsNameEn: 'Location Specs Name - English',
    locationSpecsNameAr: 'Location Specs Name - Arabic',
    locationSpecsOptionNameEnLang: 'Location Specs Name in English Language',
    locationSpecsOptionNameArLang: 'Location Specs Name in Arabic Language',
    facingNameEn: 'Facing Name - English',
    facingNameAr: 'Facing Name - Arabic',
    facingOptionNameEnLang: 'Facing Option Name in English Language',
    facingOptionNameArLang: 'Facing Option Name in Arabic Language',
    locationNameEn: 'Location Name - English',
    locationNameAr: 'Location Name - Arabic',
    locationOptionNameEnLang: 'Location Name Option in English Language',
    locationOptionNameArLang: 'Location Name Option in Arabic Language',
    curbNameEn: 'Curb Name - English',
    curbNameAr: 'Curb Name - Arabic',
    curbOptionNameEnLang: 'Curb OPtion Name in English Language',
    curbOptionNameArLang: 'Curb Option Name in Arabic  Language',
    faqQuestionEn: 'Question - English',
    faqAnswerEn: 'Answer - English',
    faqQuestionAr: 'Question - Arabic',
    faqAnswerAr: 'Answer - Arabic',
    areaNameEn: 'Area Name - English',
    areaNameAr: 'Area Name - Arabic',
    areaNameEnLang: 'Area Name in English Language',
    areaNameArLang: 'Area Name in Arabic Language',
    propertyTypeNameArLang: 'Property Type Name in Arabic Language',
    propertyTypeNameEnLang: 'Property Type Name in English Language',
    auctionLocationNameArLang: 'Auction Location Name in English Language',
    auctionLocationNameEnLang: 'Auction Location Name in Arabic Language',
    auctionDescriptionNameArLang:
      'Auction Description Name in English Language',
    auctionDescriptionNameEnLang: 'Auction Description Name in Arabic Language',
    landSizeNameEnLang: 'Land Size in English Language',
    landSizeNameArLang: 'Land Size in Arabic Language',
    plotSpecsNameEnLang: 'Plot Specs Name in English Language',
    plotSpecsNameArLang: 'Plot Specs Name in Arabic Language',
    landSizeValue: 'Land Size - Value',
    plotSpecsNameEn: 'Plot Specs Name - English',
    plotSpecsNameAr: 'Plot Specs Name - Arabic',
    sabahSeaSpecsNameEn: 'Sabah City Specs - English',
    sabahSeaSpecsNameAr: 'Sabah City Specs - Arabic',
    sabahSeaSpecsNameEnLang: 'Sabah City Specs Name in English Lanuage',
    sabahSeaSpecsNameArLang: 'Sabah City Specs Name in Arabic Language',
    directionNameEn: 'Direction Name - English',
    directionNameAr: 'Direction Name - Arabic',
    directionOptionNameArLang: 'Direction Option Name in Arabic Language',
    directionOptionNameEnLang: 'Direction Option Name in English Language',
    buildingAgeValueEn: 'Building Age Value - English',
    buildingAgeValueAr: 'Building Age Value - Arabiic',
    buildingAgeOptionValueEnLang:
      'Building Age Option Value in English Language',
    buildingAgeOptionValueArLang:
      'Building Age Option Value in Arabic Language',
    quality: 'Quality',
    qualityValue: 'Quality Value',
    floorNameEn: 'Floor Name - English',
    floorNameAr: 'Floor Name - Arabic',
    floorOptionNameEnLang: 'Floor Option Name in English Language',
    floorOptionNameArLang: 'Floor Option Name in Arabic Language',
    seaFrontNameEn: 'Sea Front Name - English',
    seaFrontNameAr: 'Sea Front Name - Arabic',
    seaFrontOptionNameArLang: 'Sea Front Name Option in Arabic Language',
    seaFronOptionNameEnLang: 'Sea Front Name Option in English Language',
    backStreetNameEn: 'Back Street Name - English',
    backStreetNameAr: 'Back Street Name - Arabic',
    backStreetOptionNameEnLang: 'Back Street Option Name in English Language',
    backStreetOptionNameArLang: 'Back Street Option Name in Arabic Language',
    qualityNameEn: 'Quality Name - English',
    qualityNameAr: 'Quality Name - Arabic',
    qualityRangeNameOptionArLang:
      'Quality Range Name Option in Arabic Language',
    qualityRangeNameOptionEnLang:
      'Quality Range Name Option in English Language',
    qualityGroupNameEnLang: 'Quality Group Name in English Language',
    qualityGroupNameArLang: 'Quality Group Name in Arabic Language',
    questionNameEnLang: 'Question Name in English Language',
    questionNameArLang: 'Question Name in Arabic Language',
    imageUrl: 'Image URL',
    multiplicationFactors: 'Multiplication Factor',
    multiCurb: 'Multi Curb',
    multiSelection: 'Multi Selection',
    isSeaView: 'Sea View',
    customUpdatedAt: 'Custom Updated Date',
    pullData: 'Pull Data',
    url: 'URL',
    from: 'From',
    to: 'To',
    weight: 'Weight',
    appraisalRequestOverview: 'Appraisal Request Overview',
    adminUsersListing: 'Admin Users Listing',
    auctionsListing: 'Auctions Listing',
    appraisersUsersListing: 'Appraisers Users Listing',
    appraisersListing: 'Appraisers Listing',
    usersListing: 'Users Listing',
    officesListing: 'Offices Listing',
    banksListing: 'Banks Listing',
    answersListing: 'Answers Listing',
    bannerList: 'Banner Listing',
    ireAreasListing: 'Ire Areas Listing',
    ireTypesListing: 'Ire Types Listing',
    ireSizesListing: 'Ire Size Listing',
    IreFactorsBathroomsListing: 'Ire Factors Bathroom Listing',
    IreFactorsOptionsListing: 'Ire Factor Options Listing',
    IreFactorsQualitysListing: 'Ire Factor Qualitys Listing',
    IreFactorsGeneralspecsListing: 'Ire Factors General specs Listing',
    ireFactorsLocationSpecsListing: 'Ire Factors Location Specs Listing',
    IreFactorsPropertySeriveListing: 'Ire Factors Property Service Listing',
    streetFactorOptions: 'Street Factor Options',
    streetOptionsUpdating: 'Street Option Updating',
    facingFactorOptions: 'Facing Factor Options',
    facingOptionCreating: 'Facing Option Creating',
    facingOptionUpdating: 'Facing Option Updating',
    sabahCityFactorOptions: 'Sabah City Factor Options',
    sabahCityOptionCreating: 'Sabah City Option Creating',
    sabahCityOptionUpdating: 'Sabah City Option Updating',
    locationFactorOptions: 'Location Factor Options',
    locationOptionUpdating: 'Location Option Updating',
    locationOptionCreating: 'Location Option Creating',
    curbFactorOptions: 'Curb Factor Options',
    curbOptionUpdating: 'Curb Option Updating',
    curbOptionCreating: 'Curb Option Creating',
    buildingAgeFactorOptions: 'Building Age Factor Options',
    buildingAgeOptionUpdating: 'Building Age Option Updating',
    buildingAgeOptionCreating: 'Building Age Option Creating',
    finishingQualityFactorOptions: 'Finishing Quality Factor Options',
    finishingQualityOptionUpdating: 'Finishing Quality Option Updating',
    finishingQualityOptionCreating: 'Finishing Quality Option Creating',
    floorFactorOptions: 'Floor Factor Options',
    floorOptionsCreating: 'Floor Options Creating',
    floorOptionsUpdating: 'Floor Options Updating',
    seaFrontLenghsFactorOptions: 'Sea Front Lengths Factors Options',
    seaFrontLengthOptionUpdating: 'Sea Front Length Option Updating',
    backStreetLenghsFactorOptions: 'Back Street Lengths Factors Options',
    backStreetLengthOptionUpdating: 'Back Street Length Option Updating',
    organizersListing: 'Organizers Listing',
    locationsListing: 'Locations Listing',
    contactusListing: 'Contact us Listing',
    finishingqualityEn: 'Finishing Quality - English',
    finishingqualityAr: 'Finishing Quality - Arabic',
    finishingQualityOptionNameArLang:
      'Finishing Quality Option Name in Arabic Language',
    finishingQualityOptionNameEnLang:
      'Finishing Quality Option Name in English Language',
    appraisalsRequestsListing: 'Appraisals Requests Listing',
    appraisalsRequestsUpdating: 'Appraisals Requests Updating',
    appraiserName: 'Appraiser Name',
    adminUsersCreating: 'Admin Users Creating',
    appraisersUsersCreating: 'Appraisers Users Creating',
    auctionsCreating: 'Auctions Creating',
    bannerCreating: 'Add Banner Creating',
    auctionsEditing: 'Auctions Editing',
    appraisersUsersEditing: 'Appraisers Users Editing',
    savingPricesNote:
      'Saving appraiser details is required before proceeding to adding his prices.',
    savingBanksNote:
      'Saving appraiser details is required before proceeding to adding his banks.',
    savingAuctionAttachmentNote:
      'Saving auction details is required before proceeding to adding its attachments.',
    savingAuctionPropertiesNote:
      'Saving auction details is required before proceeding to adding its properties.',
    savingServiceNote:
      'Saving package details is required before proceeding to adding its services.',
    banksCreating: 'Banks Creating',
    answersCreating: 'Answers Creating',
    streetOptionsCreating: 'Street Options Creating',
    organizersCreating: 'Organizers Creating',
    locationsCreating: 'Locations Creating',
    adminUsersUpdating: 'Admin Users Updating',
    banksUpdating: 'Banks Updating',
    answersUpdating: 'Answers Updating',
    organizersUpdating: 'Organizers Updating',
    locationUpdating: 'Location Updating',
    appraisalRequestUpdating: 'Appraisal Request Updating',
    roleUpdating: 'Role Updating',
    rolesListing: 'Roles Listing',
    rolesCreating: 'Roles Creating',
    rolesUpdating: 'Roles Updating',
    adTypesListing: 'Ad Type Listing',
    adTypesUpdating: 'Ad Type Updating',
    adTypesCreating: 'Ad Type Creating',
    propertiesListing: 'Properties Listing',
    propertiesCreating: 'Properties Creating',
    propertiesUpdating: 'Properties Updating',
    bankRateUpdating: 'Bank Rate Updating',
    bankRatesListing: 'Bank Rates Listing',
    bankRateCreating: 'Bank Rate Creating',
    bankRatesLogReportsListing: 'bank Rates Log Reports Listing',
    importBankRate: 'Import Bank Rate',
    logReports: 'Log Reports',
    ireTypesUpdating: 'Ire Type Updating',
    ireSizesCreating: 'Ire Size Creating',
    ireFactorsOptionsCreating: 'Ire Factors Option Creating',
    ireFactorsGeneralspecsCreating: 'Ire Factors General specs Creating',
    ireFactorsLocationspecsCreating: 'Ire Factors Location specs Creating',
    ireFactorsBathroomCreating: 'Ire Factors Bathroom specs Creating',
    ireSizeUpdating: 'Ire Size Updating',
    ireFactorsbathroomsUpdating: 'Ire Factors Bathrooms Updating',
    ireFactorsPropertyServiceUpdating: 'Ire Factors Property Service Updating',
    ireFactorsOptionssUpdating: 'Ire Factors Options Updating',
    ireFactorGeneralspecsUpdating: 'Ire Factors General specs Updating',
    ireFActorsLocationspecsUpdating: 'Ire Factors Location specs Updating',
    faqsListing: 'FAQs Listing',
    faqsCreating: 'FAQs Creating',
    faqsUpdating: 'FAQs Updating',
    areasListing: 'Areas Listing',
    areasCreating: 'Areas Creating',
    areasUpdating: 'Areas Updating',
    areasIveValuesListing: 'Areas IVE Values Listing',
    areasIveValuesCreating: 'Areas IVE Values Creating',
    areasIveValuesUpdating: 'Areas IVE Valus Updating',
    newsCreating: 'News Creating',
    newsListing: 'News Listing',
    newsUpdating: 'News Updating',
    landSizeFactorOptions: 'Land Size Factor Options',
    PlotSpecsFactorOptions: 'Plot Specs Factor Options',
    landSizeOptionsUpdating: 'Land Size Options Updating',
    landSizeOptionsCreating: 'Land Size Options Creating',
    plotSpecsOptionsCreating: 'Plot Specs Options Creating',
    directionFactorOptions: 'Direction Factor Options',
    directionOptionsCreating: 'Direction Options Creating',
    directionOptionsUpdating: 'Direction Options Updating',
    propertyTypesListing: 'Property Types Listing',
    auctionsLocationsListing: 'Auctions Locations Listing',
    auctionsDescriptionsListing: 'Auctions Descriptions Listing',
    propertyTypesCreating: 'Property Types Creating',
    propertyTypesUpdating: 'Property Types Updating',
    auctionsLocationsCreating: 'Auctions Locations Creating',
    auctionsDescriptionsCreating: 'Auctions Descriptions Creating',
    auctionsLocationsUpdating: 'Auctions Locations Updating',
    auctionsDescriptionsUpdating: 'Auctions Descriptions Updating',
    propertyCategoryCreating: 'Property Category Creating',
    propertyCategoryUpdating: 'Property Category Updating',
    propertyCategoriesListing: 'Property Categories Listing',
    propertyCategoriesCreating: 'Property Categories Creating',
    propertyCategoriesUpdating: 'Property Categories Updating',
    locationSpecsFactorOptions: ' Ire Location Specs Factor Options',
    locationSpecsOptionsCreating: 'Ire Factor Location Specs Options Creating',
    ireTypesCreating: 'Ire Types Creating',
    ireFactorsbathroomsCreating: 'Ire Factor Bathrooms Creating',
    ireFactorsQualitysCreating: 'Ire Factor Quality Creating ',
    ireFactorsPropertyServiceCreating: 'Ire Factor Property Service Creating',
    locationSpecsOptionsUpdating: 'Location Specs Options Updating',
    rangesFinishingQuality: 'Ranges Finishing Quality',
    qualityRangeOptionCreating: 'Quality Range Option Creating',
    qualityRangeOptionUpdating: 'Quality Range Option Updating',
    qualitygroupOptionCreating: 'Quality Group Option Creating',
    GroupsWeightUpdating: 'Groups Weight Updating',
    QuestionsWeightUpdating: 'Questions Weight Updating',
    aboutUs: 'About Us',
    about: 'About - (Privacy)',
    updateIreInvestmentAbout: 'Update IRE Investment About',
    ireInvestmentAboutUpdating: 'IRE Investment About Updating',
    updateLoanCalculatorAbout: 'Update Loan Calculator About',
    loanCalculatorAboutUpdating: 'Loan Calculator About Updating',
    updateAppPrivacyAbout: 'Update App Privacy About - Mobile',
    updateAppPrivacyAboutWeb: 'Update App Privacy About - Web',
    appPrivacyAboutUpdating: 'App Privacy About Updating',
    aboutUsUpdating: 'About Us Updating',
    updateAboutUsWeb: 'Update About Us - Web',
    termsAndConditions: 'Terms and Conditions',
    termsAndConditionsUpdating: 'Terms and Conditions Updating',
    description: 'Description',
    name: 'Name',
    roleName: 'Role Name',
    roleGroup: 'Role Group',
    shortDescription: 'Short Description',
    status: 'Status',
    actions: 'Actions',
    members: 'Members',
    auctions: 'Auctions',
    appraisals: 'Appraisals',
    ive: 'IVE',
    ire: 'IRE',
    assets: 'Assets',
    ads: 'Ads',
    active: 'Active',
    inactive: 'Inactive',
    mcpAccess: 'MCP',
    confirmEnableMcp:
      'Allow this member to connect an external AI assistant (MCP)?',
    confirmDisableMcp: "Revoke this member's MCP access?",
    MCP_ENABLED: 'MCP access activated',
    MCP_DISABLED: 'MCP access deactivated',
    createNewAdmin: 'Create New Admin',
    appraiserDetails: 'Appraiser Details',
    auctionDetails: 'Auction Details',
    auctionAttachments: 'Auction Attachments',
    createNewAppraiser: 'Create New Appraiser',
    createNewBank: 'Create New Bank',
    createNewAnswer: 'Create New Answer',
    createNewStreetOption: 'Create New Street Option',
    createNewGroup: 'Create New Group',
    createNewBuildingAgeOption: 'Create New Building Age Option',
    createNewFinishingQualityOption: 'Create New Finishing Quality Option',
    createNewFloorOption: 'Create New Floor Option',
    createNewLandSizeOption: 'Create New Land Size Option',
    createNewDirectionOption: 'Create New Direction Option',
    createNewSabahCitySpecsOption: 'Create New Sabah City Specs Option',
    createNewFacingOption: 'Create New Facing Optoin',
    createNewPlotSpecsOption: 'Create New Plot Specs Option',
    createNewLocationSpecsOption: 'Create New Location Specs Option',
    createNewOrganizer: 'Create New Organizer',
    createNewLocation: 'Create New Location',
    createNewAdType: 'Create New Ad Type',
    creatNewAdType: 'Create New Ad Type',
    createNewRole: 'Create New Role',
    createNewProperty: 'Create New Property',
    createNewPropertyCategory: 'Create New Property Category',
    createNewFaq: 'Create New FAQs',
    createNewArea: 'Create New Area',
    createNewIveValue: 'Create New IVE Value',
    createNewPropertyType: 'Create New Property Type',
    createNewAuctionLocation: 'Create New Auction Location',
    createNewAuctionDescription: 'Create New Auction Description',
    createNewLocationOption: 'Create New Location Option',
    createNewCurbOption: 'Create New Curb Option',
    createNewQualityRangeOption: 'Create New Quality Range Option',
    createNewIreArea: 'Create New Ire Area',
    createNewIreType: 'Create New Ire Type',
    createNewIreSize: 'Create New Ire Size',
    createNewIreFactorBathrooms: 'Create New Ire Factor Bathrooms',
    createNewIreFactorOptions: 'Create New Ire Factor Options',
    createNewIreFactorGeneralspecs: 'Create New Ire Factor General specs',
    createNewIreFactorsLocationspecs: 'Create New Ire Factor Location specs',
    createNewIreFactorsQualitys: 'Create New Ire Factor Quality',
    createNewIreFactorsPropertyService:
      'Create New Ire Factor Property Service',
    createNewBankRate: 'Create New Bank Rate',
    createNewNews: 'Create New News',
    createNewIreStreet: 'Create New Ire Street',
    street: 'Street',
    propertyStreet: 'Property Street',
    fullName: 'Full Name',
    fullAdminName: 'Full Admin Name',
    adminEmail: 'Admin Email',
    newPassword: 'New Password',
    verifyPassword: 'Verify Password',
    discard: 'Discard',
    saveChanges: 'Save Changes',
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    updateAdmin: 'Update Admin',
    updateBank: 'Update Bank',
    updateAnswer: 'Update Answer',
    updateStreetOption: 'Update Street Option',
    updateBuildingAgeOption: 'Update Building Age Option',
    updateFinishingQualityOption: 'Update Finishing Quality Option',
    updateFloorOption: 'Update Floor Option',
    updateSeaFrontLengthOption: 'Update Sea Front Length Option',
    updateBackStreetLengthOption: 'Update Back Street Length Option',
    updateLocationOption: 'Update Location Option',
    updateCurbOption: 'Update Curb Option',
    updateOrganizer: 'Update Organizer',
    updateLocation: 'Update Location',
    updateAdType: 'Update Ad Type',
    updateRole: 'Update Role',
    updateProperty: 'Update Property',
    updateFaq: 'Update FAQs',
    contactUsOverview: 'Contact Us Overview',
    updateArea: 'Update Area',
    updateIveAreaValue: 'Update IVE Area Value',
    updatePropertyType: 'Update Property Type',
    updateAuctionLocation: 'Update Auction Location',
    updateAuctionDescription: 'Update Auction Description',
    updateAboutUs: 'Update About Us - Mobile',
    updateTermsAndConditions: 'Update Terms and Conditions - Mobile',
    updateTermsAndConditionsWeb: 'Updat Terms and Conditions - Web',
    updateLandSizeOption: 'Update Land Size Option',
    updateLocationSpecsOption: 'Update Location Specs Option',
    updatePlotSpecsOption: 'Update Plot Specs Option',
    UpdateloansFundsRequest: 'Update Loans Fund Request',
    updateGroupQuestion: 'Update Group Question',
    updateDirectionOption: 'Update Direction Option',
    updateSabahCitySpecsOption: 'Update Sabah City Specs Option',
    updateFacingOption: 'Update Facing Option',
    updateQualityRangeOption: 'Update Quality Range Option',
    updateQualityGroup: 'Update Quality Group',
    updateGroup: 'Update Group',
    updateIreType: 'Update Ire Type',
    updateIreFactorBathroom: 'Update Ire Factor Bathroom',
    updateIreFactorsOptions: 'Update Ire Factor Option',
    updateIreFactorsQualitys: 'Update Ire Factor Quality',
    updateIreLocationSpecs: 'Update Ire Location specs',
    updateIreFactorGeneralspecs: 'Update Ire Factor General specs',
    updateIreFactorsPropertyService: 'Update Ire Factor Property Service',
    updateBankRate: 'Update Bank Rate',
    updateQuestionsWeight: 'Update Questions Weight',
    updateGroupsWeight: 'Update Groups Weight',
    updatenews: 'Update News',
    bankRatesOverview: 'Bank Rates Overview',
    areYouSureQ: 'Are you sure?',
    youCantRevert: "You won't be able to revert this!",
    createdDate: 'Created Date',
    createdBy: 'Created By',
    confirm: 'Confirm',
    confirmDelete: 'Confirm delete',
    confirmInActive: ' Are you sure you want to inactivate it ?',
    confirmActive: 'Are you sure you want to activate it',
    confirmUserBlock: 'Yes, block user!',
    applicantInfo: 'Applicant Info',
    areaName: 'Area Name',
    basePrice: 'Basic Price',
    attachments: 'Attachments',
    baseSize: 'Basic Size',
    documents: 'Documents',
    other: 'Other',
    appraisalDetails: 'Appraisal Details',
    applicantName: 'Applicant Name',
    applicantEmail: 'Applicant Email',
    applicantMobile: 'Applicant Mobile',
    appraiserMobile: 'Appraiser Mobile',
    appraiserEmail: 'Appraiser Email',
    changeStatus: 'Change Status',
    changeAppraisalRequestStatus: 'Change Appraisal Request Status',
    additionalDetails: 'Additional Details',
    address: 'Address',
    bankAppraisal: 'Bank Appraisal',
    applicantType: 'Applicant Type',
    bankName: 'Bank Name',
    activeStatus: 'Active Status',
    rejectionNote: 'Rejection Note',
    areaSize: 'Area Size',
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    arabicValue: 'Arabic Value',
    englishValue: 'English Value',
    arabicSize: 'Arabic Size',
    englishSize: 'English Size',
    englishQuestion: 'English Question',
    englishAnswer: 'English Answer',
    arabicQuestion: 'Arabic Question',
    arabicAnswer: 'Arabic Answer',
    textInArabic: 'Text in Arabic',
    textInEnglish: 'Text in English',
    phoneNumber: 'Phone Number',
    ppmNotificationLevel: 'PPM Notification Level',
    ppmNotificationLevelHint:
      'Level 1 is notified as soon as a price is pending review. Level 2 only if it is still pending after the escalation window.',
    ppmLevelNone: 'Not assigned',
    ppmLevelImmediate: 'Level 1 — Immediate',
    ppmLevelEscalation: 'Level 2 — Escalation',
    PHONE_NOT_VALID:
      'Phone must be digits including the country code, e.g. 96567645991',
    phone: 'Phone',
    accountType: 'Account Type',
    appraiserPhone: 'Appraiser Phone',
    cancel: 'Cancel',
    role: 'Role',
    approved: 'Approved',
    rejected: 'Rejected',
    contactPersonName: 'Contact Person Name',
    contactPersonPhone: 'Contact Person Phone',
    contactPerson: 'Contact Person',
    contactPhone: 'Contact Phone',
    bankAccountDetails: 'Bank Account Details',
    appraiserBanks: 'Appraiser Banks',
    appraiserPrices: 'Appraiser Prices',
    auctionProperties: 'Auction Properties',
    banks: 'Banks',
    noResultsFound: 'No results found',
    propertyType: 'Property Type',
    auctionLocation: 'Auction Location',
    building: 'Building',
    percentage: 'Percentage',
    nonCustumerPercentage: 'Non Custumer Percentage',
    repaymentPeriod: 'Repament Period',
    nonBoubyanCustomer: 'Non Boubyan Customer',
    boubyanCustomer: 'Boubyan Customer',
    nonBoubyanCustomerPercentage: 'Non Boubyan Customer',
    boubyanCustomerPercentage: 'Boubyan Customer',
    land: 'Land',
    organiserName: 'Organizer Name',
    date: 'Date',
    time: 'Time',
    venue: 'Venue',
    type: 'Type',
    filterOptions: 'Filter Options',
    today: 'Today',
    historical: 'Historical',
    upcoming: 'Upcoming',
    reset: 'Reset',
    apply: 'Apply',
    filter: 'Filter',
    organizer: 'Organizer',
    dateAndTime: 'Date and Time',
    eventDateAndTime: 'Event Date and Time',
    location: 'Location',
    loanRequest: 'Loan Request',
    certifiedCheckRequest: 'Certified Check Request',
    block: 'Block',
    size: 'Size',
    propertyBlock: 'Property Block',
    propertyPlot: 'Property Plot',
    percentagePremiumPaid: 'Premium % Paid',
    propertySize: 'Property Size',
    propertyVenue: 'Property Venue',
    startingPrice: 'Starting Price',
    salePrice: 'Sale Price',
    salePercentage: 'Sale Percentage',
    additionalInfoEn: 'Additional Information (EN)',
    exportIveArea: 'Export Ive Area',
    additionalInfoInEn: 'Additional Information in English',
    factorOptionIve: 'Factor Option Instant Value',
    additionalInfoInAr: 'Additional Information in Arabic',
    propertyAttachments: 'Property Attachments',
    additionalInfoAr: 'Additional Information (AR)',
    startingPricePerSqm: 'Starting Price/SQ. M.',
    startingPricePerSquareMeter: 'Starting Price Per Square Meter',
    salePricePerSqm: 'Sale Price/SQ. M.',
    salePricePerSquareMeter: 'Sale Price Per Square Meter',
    propertyStatus: 'Property Status',
    area: 'Area',
    plot: 'Plot',
    video: 'Video',
    auctionVideo: 'Auction Video',
    organizerLogo: 'Organizer Logo',
    logo: 'Logo',
    coordinates: 'Coordinates',
    latitude: 'Latitude',
    longitude: 'Longitude',
    loansFundsRequest: 'Loans Funds Request',
    loanFundsRequestOverview: 'Loans Funds Request Overview',
    propertyValue: 'Property Value',
    loanDuration: 'Loan Duration',
    annualProfit: 'AnnualProfit',
    totalPurchasePrice: 'Total Purchase Price',
    bankProfit: 'Bank Profit',
    downPayment: 'Down Payment',
    gracePeriod: 'Grace Period',
    priceFrom: 'Price From',
    priceTo: 'Price To',
    residentials: 'residentials',
    commercial: 'commercial ',
    propertySoldStatus: 'Property Sold Status',
    note: 'Note',
    paciNo: 'PACI',
    noFactorOptionsLeft:
      'There are no options left for this factor to be added.',
    adsServices: 'Ads services',
    createNewAdService: 'Create new Ads Service',
    adsDuration: 'Ads duration',
    adsDurationDay: 'Ads duration (days)',
    packDurationDay: 'Package Expiry Duration (days)',
    specialAdDurationDay: 'Special Ads duration (days)',
    arabicTitle: 'Arabic title',
    englishTitle: 'English title',
    arabicDescription: 'Arabic description',
    englishDescription: 'English description',
    auctionStatusNameEn: 'Auction Status Name English',
    auctionStatusNameAr: 'Auction Status Name Arabic',
    auctionStatusNameEnLang: 'Auction Status Name - EN',
    auctionStatusNameArLang: 'Auction Status Name - AR',
    addNewAuctionStatus: 'Add New Auction Status',
    auctionsStatusesListing: 'Auctions Statuses List',
    auctionsStatusesCreating: 'Auctions Statuses Creating',
    auctionsStatusesUpdating: 'Auctions Statuses Updating',
    createNewAuctionStatus: 'Create New Auction Status',
    updateAuctionStatus: 'Update Auction Status',
    score: 'Score',
    adServiceTitleArlang: 'Ads service title-Arabic ',
    adServiceTitleEnlang: 'Ads service title - English',
    adsServiceUpdating: 'Update Ads Service',
    adsCreating: 'Ad Service Creating',
    adsUpdate: 'Ad Service Update',
    adPackageAdsCreating: 'Package Ad Creating',
    adPackagesDetails: 'Package Details',
    promotionDetails: 'Promotion Details',
    adPackageTitleArlang: 'Package title - Arabic ',
    adPackageTitleEnlang: 'Package title - English ',
    adsPackagesUpdating: 'Update Ads Package',
    bannerUpdating: 'Banner Updating',
    adsPackages: 'Ads packages',
    createNewAdPackage: 'Create New Ads Package',
    createNewBanners: 'Create New Banner',
    packageServices: 'Package Services',
    bannerLocation: 'Banner Location',
    bannerAction: 'Banner Action',
    externalLink: 'External Link',
    externalLinkEn: 'External Link En ',
    externalLinkAr: 'External Link AR',
    externalLinkWebEn: 'External Web Link En',
    externalLinkWebAr: 'External Web Link Ar',
    bannerType: 'Banner Type',
    merchant: 'Merchant',
    entityId: 'Entity ID',
    bannerUrl: 'Banner URL',
    bannerUrlEn: 'Banner URL En',
    bannerUrlAr: 'Banner URL Ar',
    bannerUrlWebEn: 'Banner URL Web En',
    bannerUrlWebAr: 'Banner URL Web Ar',
    bannerImage: 'Banner Image',
    bannerImageWeb: 'Banner Image Web',
    bannerInfo: 'Banner Info',
    auctionStatus: 'Auction Status',
    appartmentSize: 'Appartment Size',
    ireSizesValues: 'Ire Sizes Values',
    Generalspecs: 'General specs',
    Locationspecs: 'Location specs',
    propertyService: 'Property Service',
    freeAd: 'Standard AD',
    paidAd: 'Paid AD',
    isSpecial: 'Featured AD',
    displayOnHomepage: 'Display on Home Page',
    onHomepage: 'Homepage AD',
    upgradeToFeaturedAd: 'Upgrade to Featured Ad',
    numRooms: 'Number of Room',
    numBathrooms: 'Number of Bathrooms',
    adsPackagesTitle: 'Ad Package',
    additionalInfo: 'Additional Info',
    headerDescription: 'Header Description',
    headerDescriptionUpdating: 'Header Description Updating',
    disclaimer: 'Disclaimer',
    disclaimerUpdating: 'Disclaimer Updating',
    adminAccess: 'Admin access',
    actionDescription: 'Action description',
    timeStamp: 'Time stamp',
    exportLogsReports: 'Export Logs Reports',

    '-----------------': '-----------------',
    dashboard: 'Dashboard',
    layoutBuilder: 'Layout builder',
    craft: 'Crafted',
    pages: 'Pages',
    profile: 'Profile',
    profileOverview: 'Overview',
    projects: 'Projects',
    campaigns: 'Campaigns',
    connections: 'Connections',
    wizards: 'Wizards',
    horizontal: 'Horizontal',
    vertical: 'Vertical',
    account: 'Account',
    accountOverview: 'Overview',
    settings: 'Settings',
    Settings: 'Settings',
    authentication: 'Authentication',
    basicFlow: 'Basic Flow',
    signIn: 'Sign-in',
    signUp: 'Sign-up',
    passwordReset: 'Password Reset',
    error404: 'Error 404',
    error500: 'Error 500',
    apps: 'Apps',
    chat: 'Chat',
    privateChat: 'Private Chat',
    groupChat: 'Group Chat',
    drawerChat: 'Drawer Chat',
    widgets: 'Widgets',
    widgetsLists: 'Lists',
    widgetsStatistics: 'Statistics',
    widgetsCharts: 'Charts',
    widgetsMixed: 'Mixed',
    widgetsTables: 'Tables',
    widgetsFeeds: 'Feeds',
    changelog: 'Changelog',
    docsAndComponents: 'Docs & Components',
    megaMenu: 'Mega Menu',
    exampleLink: 'Example link',
    modals: 'Modals',
    general: 'General',
    inviteFriends: 'Invite Friends',
    viewUsers: 'View Users',
    upgradePlan: 'Upgrade Plan',
    shareAndEarn: 'Share & Earn',
    forms: 'Forms',
    newTarget: 'New Target',
    newCard: 'New Card',
    newAddress: 'New Address',
    createAPIKey: 'Create API Key',
    twoFactorAuth: 'Two Factor Auth',
    createApp: 'Create App',
    createAccount: 'Create Account',
    documentation: 'Documentation',
    components: 'Components',
    resources: 'Resources',
    activity: 'Activity',
    customers: 'Customers',
    gettingStarted: 'Getting Started',
    customersListing: 'Customers Listing',
    customerDetails: 'Customers Details',
    calendarApp: 'Calendar',
    subscriptions: 'Subscriptions',
    getStarted: 'Getting Started',
    subscriptionList: 'Subscription List',
    addSubscription: 'Add Subscription',
    viewSubscription: 'View Subscription',
    sorting: 'Sorting',
    numberOfProperties: '# of Properties',
    updateCceGroup: 'Update CCE Group',
    createNewCceGroup: 'create New CCE Group',
    addNewCceGroup: 'Add New CCE Group',
    CceGroupsList: 'CCE Groups List',
    titleAr: 'Title Ar',
    titleEn: 'Title En',
    updateCceCategorie: 'Update CCE Categorie',
    createNewCceCategorie: 'create New CCE Categorie',
    addNewCceCategorie: 'Add New CCE Categorie',
    CceCategorieList: 'CCE Categories List',
    isDependQuality: 'is Depend Quality',
    savingSubCategoryOptionsNote:
      'Saving CCE sub Categorie details is required before proceeding to adding his Options.',
    cceCategory: 'CCE Category',
    cceCategoryTooltip: 'cce Category Tooltip',
    selectCceCategory: 'Select Cce Category',
    multiplier: 'Multiplier',
    defaultPrice: 'Default Price',
    sort: 'Sort',
    subCategoriesOptions: 'Sub Categories Options',
    updateCceSubCategorie: 'Update Cce Sub Categorie',
    CceSubCategoriesList: 'CCE Sub Categories List',
    addNewCceSubCategorie: 'Add New CCE Sub Categorie',
    categoryName: 'Category Name',
    SUCCESSFULLY_CREATED_CCE_GROUP: 'Successfully created a CCE group!',
    cceGroupsCreating: 'CCE Group Creating',
    SUCCESSFULLY_UPDATED_CCE_GROUP: 'Successfully update a CCE group!',
    cceGroupsListing: 'CCE Groups Listing',
    cceGroup: 'CCE Group',
    cceGroupTooltip: 'CCE Group Tooltip',
    selectCceGroup: 'Select Cce Group',
    SUCCESSFULLY_CREATED_CCE_CATEGORIE: 'Successfully created a CCE Categorie!',
    cceCategoriesCreating: 'CCE Categories Creating',
    cceCategoriesUpdating: 'CCE Categories Updating',
    SUCCESSFULLY_UPDATED_CCE_CATEGORIE: 'Successfully updated a CCE Categorie!',
    CceCategoriesList: 'CCE Categories List',
    cceCategoriesListing: 'CCE Categories Listing',
    groupName: 'Group Name',
    cceCategories: 'CCE Categories',
    cceCategoriesTooltip: 'CCE Categories Tooltip',
    cceSubCategoriesCreating: 'CCE Sub Categories Creating',
    cceSubCategoriesUpdating: 'CCE Sub Categories Updating',
    cceSubCategoriesListing: 'CCE Sub Categories Listing',
    cceGroups: 'CCE Groups',
    cceSubCategories: 'CCE Sub Categories',
    RegisteredTrades: 'Registered Trades',
    createNewRegisteredTrades: 'Create New Registered Trades',
    updateRegisteredTrades: 'Update Registered Trades',
    RegisteredTradesListing: 'Registered Trades Listing',
    pricePerM2: 'Price Per M2',
    notes: 'Notes',
    noteAr: 'Note Arabic',
    noteEn: 'Note English',
    transactionDate: 'Transaction Date',
    RegisteredTradesScraping: 'Registered Trades Scraping',
    transactionNumber: 'Transaction Number',
    areas: 'Areas',
    descriptionAr: 'Description Arabic',
    descriptionEn: 'Description English',
    notesAr: 'Notes Arabic',
    notesEn: 'Notes English',
    registeredTradesUpdating: 'Registered Trades Updating',
    TRANSACTION_NUMBER_IS_REQUIRED_FIELD:
      'transaction number is required field',
    SIZE_IS_REQUIRED_FIELD: 'Size is required field',
    FACTOR_OPTION_IVE_IS_REQUIRED_FIELD:
      'Factor option value is required field',
    PRICE_IS_REQUIRED_FIELD: 'Price is required field',
    PRICE_PER_M2_IS_REQUIRED_FIELD: 'Price per m2 is required field',
    AREA_IS_REQUIRED_FIELD: 'Area is required field',
    STARTING_PRICE_IS_REQUIRED_FIELD: 'Starting price is required field',
    STARTING_PRICE_PER_SM_IS_REQUIRED_FIELD:
      'Starting price per square meter is required field',
    PROPERTY_TYPE_IS_REQUIRED_FIELD: 'Property type is required field',
    AUCTION_LOCATION_IS_REQUIRED_FIELD: 'Auction location is required field',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE:
      'Successfully updated registered trade',
    SUCCESSFULLY_CREATED_REGISTERED_TRADE:
      'Successfully created registered trade',
    pulleRegisteredTradesScraping: 'Pull Registered Trades Scraping',
    selectDate: 'Select Date',
    SUCCESSFULLY_PULL_REGISTERED_TRADE_SCRAPING:
      'Successfully pull registered trade scraping',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE_SCRAPING:
      'Successfully updated registered trade scraping',
    SUCCESSFULLY_UPDATED_LOAN_FUNDS_REQUEST:
      'Successfully updated loan fund request',
    adsListing: 'Ads Listing',
    thumbnail: 'Thumbnail',
    id: 'S.NO',
    publishName: 'Publish Name',
    publishMobile: 'Publish Mobile',
    adsType: 'Ads Type',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    publishedAt: 'Published At',
    isPaid: 'Paid',
    attachmentImages: 'Ads Images',
    attachmentVideos: 'Ads Video',
    attachmentVideosAuction: 'Auction Video',
    docAttachment: 'Ads Documents',
    adsDetails: 'Ads Details',
    adOverview: 'Ad Overview',
    changeAdsRequestStatus: 'Change Ads Status',
    adsUpdating: 'Ads Updating',
    SUCCESSFULLY_UPDATED_ADS_REQUEST: 'Successfully Updated Ads Status',
    instantValueEstimatorPanel: 'Instant Value Estimator Panel',
    instantValueCloningPanel: 'Instant Value Cloning Panel',
    ValueSizePanel: ' Value Size Panel',
    ValueFactorBathroomPanel: ' Value Factor Bathroom Panel',
    ValueFactorOptionPanel: ' Value Factor Option Panel',
    ValueFactorGeneralspecsPanel: ' Value Factor General specs Panel',
    ValueFactorLocationspecsPanel: ' Value Factor Location specs Panel',
    ValueFactorQualityPanel: ' Value Factor Quality Panel',
    ValueFactorPropertyServicePanel: ' Value Factor Property Service Panel',
    qualityGroupsPanel: 'Quality Groups Panel',
    factors: 'Factors',
    totalValues: 'Total Values',
    factorOption: 'Factor Option',
    value: 'Value',
    addNewValue: 'Add New Value',
    addNewQuestion: 'Add New Question',
    landingEstimator: 'Land Estimator',
    landingEstimatorClone: 'Land Estimator Clone',
    FactorsBathroomValues: 'Factors Bathroom Values',
    FactorsOptionValues: 'Factors Option Values',
    factorQualitysValues: 'Factors Quality Values',
    areaCompare: 'Area Compare',
    areaClone: 'Area Clone',
    startComparingAreas: 'Start Comparing Areas',
    PHONE_MIN_8: 'minimum length is 8 Number',
    PHONE_MAX_11: 'maximum length is 11 Number',
    currentVideoUrl: 'Current Video URL',
    qualityGroupsLisitng: 'Quality Groups Listing',
    selected: 'Selected',
    approveSelected: 'Approve Selected',
    anotherCompare: 'Another Compare',
    setAsDefault: 'Set As Default',
    approveAllAds: 'Approve All Ads',
    confirmApproveAll: 'Are you sure you want to approve all items?',
    bulkUpdate: 'Bulk Update',
    deactivate: 'Deactivate',
    login: 'Login',
    logout: 'Logout',
    success: 'Success',
    failed: 'Failed',
    selectAction: 'Select a Action',
    expiryBanner: 'Expiry Banner',
    settingBankRate: 'settings Bank Rate',
    enableGracePeriod: 'Enable Grace Period',
    disableGracePeriod: 'Disable Grace Period',
    isRegisteredTrades: 'Registered Trades',
    isAd: 'Ads',
    isAuction: 'Auctions',
    SUCCESSFULLY_UPDATED_PROPERTY_CATEGORY:
      'Successfully Updated Property Category',
    SUCCESSFULLY_CREATED_PROPERTY_CATEGORY:
      'Successfully Created Property Category',
    selectPropertyCategory: 'Select Property Category',
    propertyCategory: 'Property Category',
    PROPERTY_CATEGORY_IS_REQUIRED_FIELD: 'Property Category is required field',
    SUCCESSFULLY_ADDED_IRE_SIZE_OPTIONS: 'Successfully Added IRE Size Options',
    SUCCESSFULLY_ADDED_IRE_PROPERTY_AGE_OPTIONS:
      'Successfully Added IRE Property Age Options',
    savingIreAvailableSizesNote: 'Saving IRE Available Sizes',
    isBaseSize: 'Is Base Size',
    IrePropertyAge: 'IRE Property Age',
    savingIreAvailablePropertyAgeNote: 'Saving IRE Available Property Age',
    ireAreasCreating: 'IRE Areas Creating',
    areasIreValuesUpdating: 'Areas IRE Values Updating',
    updateIreAreaValue: 'Update IRE Area Value',
    IreAvailableSizes: 'IRE Available Sizes',
    MUST_ADDED_IRE_BASE_SIZE_OPTIONS: 'Please Select IRE Base Size',
    ONE_IRE_BASE_SIZE_OPTIONS: 'Please Select Only One IRE Base Size',
    UserInfo: 'User Information',
    firstIncreasePercentage: 'First Increase Percentage',
    firstIncreasePercentageToolTip:
      'First Increase Percentage For GOOD Quality',
    secondIncreasePercentage: 'Second Increase Percentage',
    secondIncreasePercentageToolTip:
      'Second Increase Percentage For VERY GOOD Quality',
    decreasedPercentage: 'First Decreased Percentage',
    firstDecreasedPercentageToolTip:
      'First Decreased Percentage For 10-19 Property Age',
    secondDecreasedPercentage: 'Second Decreased Percentage',
    secondDecreasedPercentageToolTip:
      'Second Decreased Percentage For 20-30 Property Age',
    AREA_FIRST_INCR_IS_REQUIRED_FIELD: 'Area First Increment Is Required Field',
    AREA_SECOND_INCR_IS_REQUIRED_FIELD:
      'Area Second Increment Is Required Field',
    AREA_FIRST_DESC_IS_REQUIRED_FIELD:
      'Area First Decreasedcrement Is Required Field',
    AREA_SECOND_DESC_IS_REQUIRED_FIELD:
      'Area Second Decreasedcrement Is Required Field',
    SUCCESSFULLY_CREATED: 'Successfully Created',
    SUCCESSFULLY_UPDATED: 'Successfully Updated',
    updateIreQualities: 'Update Ire Qualities',
    ireQualitiesListing: 'Ire Qualities Listing',
    irePropertyTypeListing: 'ire Property Type Listing',
    updateIrePropertyType: 'update Ire Property Type',
    ireInvestmentPropertyAgeListing: 'ire Property Age',
    updateIrePropertyAge: 'update Ire Property Age',
    ireLocationsListing: 'ire Locations Listing',
    updateIreLocations: 'update Ire Locations',
    ireInvestmentConfigListing: 'Ire Investment Config Listing',
    updateIreInvestmentConfig: 'update Ire Investment Config',
    PERCENTAGE_IS_REQUIRED_FIELD: 'Percentage is required',
    NumOfRegisteredTrades: 'Number Of Registered Trades : ',
    askSeller: 'Ask Seller',
    priceNotAvailable: 'Price Not Available',
    adDetails: 'Ad Details',
    addNewAds: 'Create New Ad',
    AdInfo: 'Ad Information',
    AD_TYPE__IS_REQUIRED_FIELD: 'Ad Type Is Required Field',
    PUBLISH_NAME_IS_REQUIRED_FIELD: 'Publish Name Is Required Field',
    PACKAGE_IS_REQUIRED_FIELD: 'Package Is Required Field',
    adImagesAttachments: 'Ad Images',
    savingAdAttachmentNote: 'Saving Ad Attachment After Craete Ad',
    adVideoAttachments: 'Ad Video',
    adDocAttachments: 'Ad Document',
    SUCCESSFULLY_UPDATED_AD: 'Successfully Updated Ad',
    SUCCESSFULLY_UPLOADED_AD_IMAGES: 'Successfully Upload Ad Images',
    SUCCESSFULLY_UPLOADED_AD_VIDEO: 'Successfully Upload Ad Video',
    SUCCESSFULLY_UPLOADED_AD_DOC: 'Successfully Upload Ad Document',
    SUCCESSFULLY_REMOVE_AD_IMAGE: 'Successfully Remove Ad Image',
    updateAd: 'Update Ad',
    editAd: 'Edit Ad',
    baseValue: 'Base Value',
    fourthDecreasedPercentage: 'Fourth Decreased Percentage',
    thirdDecreasedPercentageToolTip: 'Third Percent',
    fourthDecreasedPercentageToolTip: 'Fourth Percent',
    FIRST_DESC_IS_REQUIRED_FIELD: 'First Decreased Is Required Field',
    SECOND_DESC_IS_REQUIRED_FIELD: 'Second Decreased Is Required Field',
    THIRD_DESC_IS_REQUIRED_FIELD: 'Third Decreased Is Required Field',
    FOURTH_DESC_IS_REQUIRED_FIELD: 'Fourth Decreased Is Required Field',
    FIRST_BASE_VAL_IS_REQUIRED_FIELD: 'First Base Value Is Required Field',
    SECOND_BASE_VAL_IS_REQUIRED_FIELD: 'Second Base Value Is Required Field',
    THIRD_BASE_VAL_IS_REQUIRED_FIELD: 'Third Base Value Is Required Field',
    FOURTH_BASE_VAL_IS_REQUIRED_FIELD: 'Fourth Base Value Is Required Field',
    firstBaseValue: 'First Base Value',
    secondBaseValue: 'Second Base Value',
    thirdBaseValue: 'Third Base Value',
    fourthBaseValue: 'Fourth Base Value',
    selectePropertyCategory: 'Select Property Category',
    sizeQualityConfig: 'Size Quality Config',
    LeadID: 'Lead Id *From BBYN',
    isSent: 'Sent To BBYN',
    FinanceFundsRequest: 'Finance Funds Requests',
    financesFundsRequest: 'Finance Funds Requests',
    financeFundsRequestOverview: 'finance Funds Request Overview',
    siteUrl: 'Alhisba Site URL',
    resStatus: 'response Status *From BBYN',
    resStatusText: 'response Status Text *From BBYN',
    leadCode: 'lead Code *From BBYN',
    adsCount: 'AD Count',
    memberType: 'Member Type',
    officeName: 'Office Name',
    borkerEmail: 'Broker Email',
    borkerPhone: 'Broker Phone',
    basicInfoBorker: 'Basic Info Broker',
    basicInfoUser: 'Basic Info User',
    mostpublished: 'Most published',
    mostAdArea: 'Area',
    mostAdType: 'Ad Type',
    mostAdsPropertyCategory: 'Property Category',
    mostAdsPropertyType: 'Property Type',
    UnSelectAreas: 'Excluded Area',
    areasIncludePrecedenceWarning:
      'When areas are selected, excluded areas will be ignored',
    registeredTradesTopAreasReports: 'Trades Top Areas Reports',
    registeredTradesReports: 'Registered Trades Reports',
    AdsPerQuarterReports: 'Ads Per Quarter Reports',
    registeredTradesTopsReports: 'Registered Trades Tops Reports',
    NumOfLowestRegisteredTrades: 'Num Of Lowest Trades',
    NumOfTopRegisteredTrades: 'Num Of Top Trades',
    registeredTradesPerQuarterReports: 'Registered Trades Per Quarter Reports',
    RegisteredTradesTotalsReports: 'Registered Trades Gov Totals Reports',
    auctionsReport: 'Auctions Report',
    auctionPropertiesReport: 'Auction Properties Report',
    activeAdsSummaryReport: 'Active Ads Summary Report',
    minPrice: 'Min Price',
    maxPrice: 'Max Price',
    total: 'Total',
    propertyCategories: 'Property Categories',
    selectPropertyCategories: 'Select Property Categories',
    organizers: 'Organizers',
    selectOrganizers: 'Select Organizers',
    onlyFullySold: 'Only 100% Sold',
    excludeAreas: 'Exclude Areas',
    selectExcludeAreas: 'Select Areas to Exclude',
    excludeTypes: 'Exclude Property Types',
    selectExcludeTypes: 'Select Types to Exclude',
    excludeCategories: 'Exclude Categories',
    selectExcludeCategories: 'Select Categories to Exclude',
    dateRangeRequired: 'Date range is required',
    dateToMustBeAfterDateFrom: 'End date must be after start date',
    noDataFound: 'No data found',
    SUCCESSFULLY_GET_REPORTS_DATA: 'SUCCESSFULLY GET REPORTS DATA',
    pullRegisteredTrades: 'Pull Registered Trades',
    importRegisteredTrades: 'Import Registered Trades',
    SUCCESSFULLY_UPLOAD_REGISTERED_TRADE:
      'Successfully Upload Registered Trades',
    rejectSelected: 'Reject Selected',
    accountStatus: 'Account Status',
    verificationStatus: 'Verification Status',
    officeType: 'Office Type',
    individualAccount: 'Individual Account',
    businessAccount: 'Business Account',
    officeOverview: 'Office Overview',
    officeDetails: 'Office Details',
    statusInfo: 'Status Info',
    supplyPercentage: 'Supply Percentage',
    isHighQuality: ' Home AD',
    adQuality: 'High Quality Ad',
    updateOrganizerDescriptions: 'Update Organizer Descriptions - Mobile',
    updateOrganizerDescriptionsWeb: 'Update Organizer Descriptions - Web',
    organizerDescriptionsUpdating: 'Organizer Descriptions Updating',
    SUCCESSFULLY_UPDATED_ORGANIZER_DESCRIPTIONS:
      'Successfully Updated Organizer Descriptions',
    componentType: 'Component Type',
    selectComponentType: 'Select Component Type',
    dropdown: 'Dropdown',
    list: 'List',
    checkbox: 'Checkbox',
    companyName: 'Company Name',
    website: 'Website',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram',
    twitter: 'Twitter',
    registrationNumber: 'Registration Number',
    registrationExpiryDate: 'Registration Expiry Date',
    mapUrl: 'Map URL',
    officesCreating: 'Offices Creating',
    officesUpdating: 'Offices Updating',
    addNewOffice: 'Add New Office',
    updateOffice: 'Update Office',
    employees: 'Employees',
    linkedAccounts: 'Linked Accounts',
    noEmployeesFound: 'No Employees Found',
    mediaInfo: 'Media Info',
    registrationReasonsListing: 'Registration Reasons Listing',
    registrationReasonsUpdating: 'Registration Reasons Updating',
    updateRegistrationReason: 'Update Registration Reasons',
    registrationReasonsCreating: 'Registration Reasons Creating',
    addNewRegistrationReason: 'Add New Registration Reason',
    createNewRegistrationReason: 'Create New Registration Reason',
    registrationReasonNameArLang: 'Registration Reason Name - Arabic',
    registrationReasonNameEnLang: 'Registration Reason Name - English',
    packages: 'Packages',
    createNewPackage: 'Create New Package',
    updatePackage: 'Update Package',
    packageCreating: 'Package Creating',
    packageUpdating: 'Package Updating',
    packageNameArLang: 'Package Name - Arabic',
    packageNameEnLang: 'Package Name - English',
    discountPercentage: 'Discount Percentage',
    offeredPrice: 'Offered Price',
    iveCredits: 'IVE Credits',
    adsCredits: 'Ads Credits',
    daysCovered: 'Days Covered',
    validity: 'Validity',
    color: 'Color',
    realtedTypeSlug: 'Related Type Slug',
    promotions: 'Promotions',
    createNewPromotion: 'Create New Promotion',
    updatePromotion: 'Update Promotion',
    promotionCreating: 'Promotion Creating',
    promotionUpdating: 'Promotion Updating',
    promotionNameArLang: 'Promotion Name - Arabic',
    promotionNameEnLang: 'Promotion Name - English',
    promoCode: 'Promo Code',
    packageId: 'Package ID',
    influencerId: 'Influencer ID',
    selectPackage: 'Select Package',
    allowedUsage: 'Allowed Usage',
    actualUsage: 'Actual Usage',
    duration: 'Duration',
    addNewSector: 'Add New Sector',
    sectorNameEn: 'Sector Name - EN',
    sectorNameAr: 'Sector Name - AR',
    sectorsListing: 'Sectors Listing',
    sectorCreating: 'Sector Creating',
    sectorUpdating: 'Sector Updating',
    createNewSector: 'Create New Sector',
    updateSector: 'Update Sector',
    addNewBadge: 'Add New Badge',
    badgeNameEn: 'Badge Name - EN',
    badgeNameAr: 'Badge Name - AR',
    badgesListing: 'Badges Listing',
    badgeCreating: 'Badge Creating',
    badgeUpdating: 'Badge Updating',
    createNewBadge: 'Create New Badge',
    updateBadge: 'Update Badge',
    auctionsPropertyGroupingListing: 'Auctions Property Grouping Listing',
    addNewAuctionPropertyGrouping: 'Add Auction Property Grouping',
    auctionPropertyGroupingAr: 'Auction Property Grouping Name - AR',
    auctionPropertyGroupingEn: 'Auction Property Grouping Name - EN',
    auctionsPropertyGroupingCreate: 'Auctions Property Grouping Creating',
    auctionPropertyGroupingUpdate: 'Auction Property Grouping Updating',
    createNewAuctionsPropertyGroup: 'Create New Auctions Property Grouping',
    updateAuctionPropertyGrouping: 'Update Auction Property Grouping',
    registeredTradesGroupingListing: 'Registered Trades Grouping Listing',
    addNewRegisteredTradesGrouping: 'Add Registered Trades Grouping',
    registeredTradesGroupingAr: 'Registered Trades Grouping Name - AR',
    registeredTradesGroupingEn: 'Registered Trades Grouping Name - EN',
    registeredTradesGroupingCreate: 'Registered Trades Grouping Creating',
    registeredTradesGroupingUpdate: 'Registered Trades Grouping Updating',
    createNewRegisteredTradesGroup: 'Create New Registered Trades Grouping',
    updateRegisteredTradesGrouping: 'Update Registered Trades Grouping',
    relatedIds: 'Related IDs',
    updateAbout: 'Update About',
    updateIveAbout: 'Update IVE About',
    updateIveAboutWeb: 'Update IVE About - Web',
    updateIveAboutMobile: 'Update IVE About - Mobile',
    iveAboutUpdating: 'IVE About Updating',
    updateIreAbout: 'Update IRE About - Mobile',
    updateIreAboutWeb: 'Update IRE About - Web',
    ireAboutUpdating: 'IRE About Updating',
    updateCceAbout: 'Update CCE About - Mobile',
    updateCceAboutWeb: 'Update CCE About - Web',
    cceAboutUpdating: 'CCE About Updating',
    appraisalsAboutUpdating: 'Appraisals About Updating',
    updateAppraisalsAbout: 'Update Appraisals About - Mobile',
    updateAppraisalsAboutWeb: 'Update Appraisals About - Web',
    author: 'Author',
    authorLink: 'Author Link',
    slug: 'Slug',
    metaTitle: 'Meta Title',
    metaDescription: 'Meta Description',
    ogTitle: 'OG Title',
    canonicalUrl: 'Canonical URL',
    ogImage: 'OG Image',
    blogs: 'Blogs',
    createBlog: 'Create Blog',
    createNewBlog: 'Create New Blog',
    blogCreating: 'Blog Creating',
    blogsUpdating: 'Blogs Updating',
    blogContentUpdating: 'Blog Content Updating',
    updateBlogContent: 'Update Blog Content',
    draft: 'DRAFT',
    published: 'PUBLISH',
    archive: 'ARCHIVE',
    relatedBlogs: 'Related Blogs',
    updateContent: 'Update Blog Content',
    selectTags: 'Select Tags',
    tags: 'Tags',
    blogTagsListing: 'Blog Tags Listing',
    blogTagsUpdating: 'Blog Tags Updating',
    blogTagsCreating: 'Blog Tags Creating',
    createNewBlogTag: 'Create New Blog Tag',
    addNewBlogTag: 'Add New Blog Tag',
    authorName: 'Author Name',
    isHomepage: 'Is on Homepage',
    isFeatured: 'Featured',
    addToTestimonials: 'Add to testimonials',
    sourceName: 'Source Name',
    sourceLink: 'Source Link',
    schedule: 'Schedule',
    scheduled: 'SCHEDULED',
    scheduledAt: 'Schedule Date',
    blogPublishedAtHint:
      'Filled from the link when it states a publish date. You can change it; when empty on a new blog, the save time is used.',
    propertyDescriptionsListing: 'Property Descriptions Listing',
    propertyDescriptionsCreating: 'Property Descriptions Creating',
    propertyDescriptionsUpdating: 'Property Descriptions Updating',
    addNewPropertyDescription: 'Add New Property Description',
    updatePropertyDescription: 'Update Property Description',
    createNewPropertyDescription: 'Create New Property Description',
    propertyDescriptionNameArLang: 'Property Description Name - Arabic',
    propertyDescriptionNameEnLang: 'Property Description Name - English',
    paymentLogs: 'Payment Logs',
    blogCategoriesList: 'Blog Categories List',
    blogCategorysListing: 'Blog Categories Listing',
    addNewBlogCategory: 'Add New Blog Category',
    createNewBlogCategory: 'Create New Blog Category',
    blogCategoriesCreating: 'Blog Categories Creating',
    blogCategories: 'Blog Categories',
    blogCategoryUpdating: 'Blog Category Updating',
    updateBlogCategories: 'Update Blog Category',
    newsletterSectionsListing: 'Newsletter Sections Listing',
    addNewNewsletterSection: 'Add New Newsletter Section',
    newslettersSectionCreating: 'Newsletter Sections Creating',
    newslettersSectionUpdating: 'Newsletter Sections Updating',
    createNewNewsletterSection: 'Create New Newsletter Section',
    updateNewsletterSection: 'Update Newsletter Section',
    htmlContent: 'HTML Content',
    variables: 'Variables',
    pullFirstArticle: 'Pull First Article',
    pullSecondArticle: 'Pull Second Article',
    referenceLink: 'Reference Link',
    titleFirstLine: 'Title First Line',
    titleSecondLine: 'Title Second Line',
    valuationType: 'Valuation Type',
    heroImageUrl: 'Hero Image URL',
    subtitle: 'Subtitle',
    paragraph2: 'Second Paragraph',
    autoGeneratedNote:
      'Note: Total deals, change %, market direction, and first paragraph are auto-generated from live data. Only the fields below need manual input.',
    buttonText: 'Button Text',
    trustText: 'Trust Text',
    link: 'Link',
    ctaBannerContent: 'CTA Banner Content',
    marketActivityContent: 'Market Activity Content',
    backgroundImage: 'Background Image',
    htmlPreview: 'HTML Preview',
    newsletterSenderPreview: 'Newsletter Sender Preview',
    newsletterPreview: 'Newsletter Preview',
    newsletterSubscribers: 'Newsletter Subscribers',
    subscribedAt: 'Subscribed At',
    approveNewsletter: 'Approve Newsletter',
    approveAndPreview: 'Approve and Preview Newsletter',
    sendToMail: 'Send to Mail',
    sendToWhatsApp: 'Send to WhatsApp',
    previewNewsletter: 'Preview Newsletter',
    externalReference: 'External Reference',
    categories: 'Categories',
    category: 'Category',
    selectCategories: 'Select Categories',
    selectCategory: 'Select Category',
    seoConfiguration: 'SEO Configuration',
    seoTitleEn: 'SEO Title - EN',
    seoTitleAr: 'SEO Title - AR',
    seoDescriptionEn: 'SEO Description - EN',
    seoDescriptionAr: 'SEO Description - AR',
    seoKeywordsEn: 'SEO Keywords - EN',
    seoKeywordsAr: 'SEO Keywords - AR',
    seoSlugEn: 'SEO Slug - EN',
    seoSlugAr: 'SEO Slug - AR',
    seoImageAlt: 'SEO Image Alt',
    seoNoIndex: 'SEO No Index',
    seoNoFollow: 'SEO No Follow',
    englishSeo: 'English SEO',
    arabicSeo: 'Arabic SEO',
    seoCanonicalUrl: 'SEO Canonical URL',
    archivedNewsletterPreview: 'Archived Newsletter Preview',
    approve: 'Approve',
    hisbaPartner: 'Hisba Partner',
    influencerNameArLang: 'Influencer Name - Arabic',
    influencerNameEnLang: 'Influencer Name - English',
    influencersCreating: 'Influencers Creating',
    influencersUpdating: 'Influencers Updating',
    influencersListing: 'Influencers Listing',
    addNewInfluencer: 'Add New Influencer',
    influencerNameEn: 'Influencer Name - EN',
    influencerNameAr: 'Influencer Name - AR',
    createNewInfluencer: 'Create New Influencer',
    updateInfluencer: 'Update Influencer',
    selectInfluencer: 'Select Influencer',
    usageSummary: 'Usage Summary',
    usedCount: 'Used Count',
    remainingUses: 'Remaining Uses',
    promotionHistory: 'Promotion History',
    adDetailsLang: 'Ad Details',
    selectUsers: 'Select Users',
    selectAdType: 'Select Ad Type',
    adType: 'Ad Type',
    users: 'Users',
    selectPropertyTypes: 'Property Types',
    propertyTypes: 'Property Types',
    badgeImage: 'Badge Image',
    adsPropertyGroupingListing: 'Property Types Grouping',
    addNewPropertyTypeGrouping: 'Add Property Type Grouping',
    adsPropertyGroupingCreating: 'Ads Property Type Grouping Creating',
    createNewAdsPropertyGrouping: 'Create New Ads Property Type Grouping',
    adsPropertyGroupingAr: 'Ads Property Grouping Name - AR',
    adsPropertyGroupingEn: 'Ads Property Grouping Name - EN',
    adsPropertyGroupingUpdate: 'Ads Property Grouping Updating',
    updateAdsPropertyGrouping: 'Update Ads Property Grouping',
    approvedBy: 'Approved By',
    approvedAt: 'Approved At',
    homeServiceUpdating: 'Home Service Updating',
    homeServiceList: 'Home Services Listing',
    webIcon: 'Web Icon',
    webIconAr: 'Web Icon - Arabic',
    imageAr: 'Image - Arabic',
    uploadIconsLocalized: 'Upload Icon(s) - Localized',
    uploadWebIconsLocalized: 'Upload Web Icon(s) - Localized',
    descAr: 'Description - Arabic',
    descEn: 'Description - English',
    isHome: 'Is Home',
    searchBanners: 'Search Banners',
    sentPreviously: 'Sent Previously?',
    paymentMethod: 'Payment Method',
    chargeId: 'Charge ID',
    orderId: 'Order ID',
    customerId: 'Customer ID',
    packageName: 'Package Name',
    notificationStatus: 'Notification Status',
    changeNotified: 'Change Notified',
    notified: 'Notified',
    notificationNotSent: 'Notification Not Sent',
    brokerAccount: 'Broker Account',
    adOptions: 'Ad Options',
    realEstateAboutUpdating: 'Real Estate About Updating',
    updateRealEstateFundAbout: 'Update Real Estate Fund About - Mobile',
    updateRealEstateFundAboutWeb: 'Update Real Estate Fund About - Web',
    statusNotes: 'Status Notes',
    selectStatusNotes: 'Status Note',
    selectGovernment: 'Select Government',
    selectPropertyStatus: 'Property Status',
    services: 'Services',
    selectPropertyGroupingType: 'Property Group',
    selectPropertyGrouping: 'Property Group',
    registeredTradesCreating: 'Registered Trades Creating',
    selectDescription: 'Select Description',
    RegisteredTradesScrapingListing: 'Registered Trades Scraping Listing',
    createBlocks: 'Create Blocks',
    creatingBlocks: 'Creating Blocks',
    registeredTradesBlocksListing: 'Registered Trades Blocks Listing',
    registeredTradesBlocks: 'Registered Trades Blocks',
    registeredTradesBlocksUpdating: 'Registered Trades Blocks Updating',
    registeredTrades: 'Registered Trades',
    updateRegisteredTradesBlocks: 'Update Registered Trades Blocks',
    returnToRegisteredTradesListing: 'Return to Registered Trades Listing',
    showBlocksListing: 'Show Blocks',
    blockCount: 'Block Count',
    isBlockTrade: 'Is Block Trade',
    sizeFrom: 'Size From',
    sizeTo: 'Size To',
    governorate: 'Governorate',
    resultsPreview: 'Results Preview',
    dateAndRangeFilters: 'Date & Range Filters',
    propertyFilters: 'Property Filters',
    statusFilters: 'Status Filters',
    resetFilters: 'Reset Filters',
    showOriginalTrade: 'Show Original Trade',
    createBlocksCopy: 'Copy Blocks Copy',
    creatingBlocksCopy: 'Creating Blocks Copy',
    featuredAd: 'Featured Ad (Special)',
    totalPrices: 'Total Prices',
    totalBlocks: 'Total Blocks',
    totalItems: 'Total Items',
    metatagssListing: 'Meta Tags Listing',
    addNewMetatags: 'Add New Meta Tags',
    ogTitleAr: 'OG Title - AR',
    ogTitleEn: 'OG Title - EN',
    ogDescriptionAr: 'OG Description - AR',
    ogDescriptionEn: 'OG Description - EN',
    ogImageAltAr: 'OG Image Alt - AR',
    ogImageAltEn: 'OG Image Alt - EN',
    twitterTitleAr: 'Twitter Title - AR',
    twitterTitleEn: 'Twitter Title - EN',
    twitterDescriptionAr: 'Twitter Description - AR',
    twitterDescriptionEn: 'Twitter Description - EN',
    schemaData: 'Schema Data',
    viewColor: 'View Color',
    priceColor: 'Price Color',
    isMostPopular: 'Is Most Popular',
    singleUse: 'Single Use',
    ogUrl: 'OG Url',
    robots: 'Robots',
    remainingAds: 'Remaining Ads',
    totalAds: 'Total Ads',
    generateOtp: 'Generate OTP',
    screen: 'Screen',
    readTime: 'Read Time',
    ireStreetsListing: 'IRE Streets Listing',
    ireFloorTypeListing: 'IRE Floor Type Listing',
    ireDirectionListing: 'IRE Direction Listing',
    ireLiteralQualityListing: 'IRE Literal Quality Listing',
    IreLiteralFactorsPropertySeriveListing:
      'IRE Literal Factors Property Service Listing',
    ireCommercialQualityListing: 'IRE Commercial Quality Listing',
    ireCommercialPropertyAgeListing: 'IRE Commercial Property Age Listing',
    IreCommercialFactorsPropertySeriveListing:
      'IRE Commercial Factors Property Service Listing',
    ireIndustailPropertyAgeListing: 'IRE Industrial Property Age Listing',
    ireIndustrailQualityListing: 'IRE Industrial Quality Listing',
    IreIndustrailFactorsPropertySeriveListing:
      'IRE Industrial Factors Property Service Listing',
    ireIndustrailPropertyAgeListing: 'IRE Industrial Property Age Listing',
    ireLiteralPropertyAgeListing: 'IRE Literal Property Age Listing',
    UnSelectPropertyType: 'Excluded Property Type',
    selectedPropertyType: 'Selected Property Type',
    expiryAt: 'Expiry At',
    isActive: 'Is Active',
    influencers: 'Influencers',
    exportFinanceFunds: 'Export Finance Funds',
    NumOfData: 'Number of data',
    lastMonth: 'Last Month',
    currentYear: 'Current Year',
    yesterday: 'Yesterday',
    registeredAccounts: 'Registered Accounts',
    totalRegisteredAccounts: 'Total Registered Accounts',
    adsSummary: 'Ads Summary',
    totalRegularsAdsCount: 'Total Regular Ads Count',
    totalSpecialAdsCount: 'Total Special Ads Count',
    brokersAccounts: 'Brokers Accounts',
    totalBrokersAccounts: 'Total Brokers Accounts',
    brokerAdsPackagesReport: 'Broker Ads Packages Report',
    hisbaRealtyMapPackages: 'Hisba Realty - Map Packages',
    hisbaStats: 'Hisba Statistics',
    hisbaRealtyStats: 'Hisba Realty Statistics',
    marketeers: 'Marketeers',
    otherServicesStats: 'Other Services Statistics',
    subscriptionsReport: 'Subscriptions Report',
    totalSubscriptions: 'Total Subscriptions',
    subscription: 'Subscription',
    details: 'Details',
    revenues: 'Revenues',
    numberOfSubscriptions: 'No. of Subscriptions',
    purchaseLogOverview: 'Purchase Log Overview',
    purchaseLogs: 'Purchase Logs',
    customerName: 'Customer Name',
    amount: 'Amount',
    purchaseDateTime: 'Purchase Date & Time',
    platform: 'Platform',
    transactionInfo: 'Transaction Info',
    transactionStatus: 'Transaction Status',
    creditsAndUsage: 'Credits & Usage',
    totalIveCredits: 'Total IVE Credits',
    usedIveCredits: 'Used IVE Credits',
    remainingIve: 'Remaining IVE Credits',
    usedAds: 'Used Ads',
    advertisements: 'Advertisements',
    remainingDays: 'Remaining Days',
    transactionId: 'Transaction ID',
    purchaseLogDetails: 'Purchase Log Details',
    purchasedFrom: 'Purchased From',
    purchasedTo: 'Purchased To',
    expiresAt: 'Expires At',
    paidAmount: 'Paid Amount',
    uniqueIdentifier: 'Unique Identifier',
    propertyId: 'Property ID',
    pricingInfo: 'Pricing Info',
    startingPricePerSqrM: 'Starting Price per Sqr Meter',
    salePricePerSqrM: 'Sale Price per Sqr Meter',
    paidPercentage: 'Paid Percentage',
    premiumPaid: 'Premium Paid',
    propertyOverview: 'Property Overview',
    properyEditing: 'Property Editing',
    editProperty: 'Edit Property',
    propertyDescription: 'Property Description',
    notRequired: 'Not Required',
    notAvailable: 'Not Available',
    selectSource: 'source',
    private: 'Private',
    government: 'Government',
    mapLogo: 'Map Logo',
    customDescriptionEn: 'Custom Description English',
    customDescriptionAr: 'Custom Description Arabic',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    auctionsSummary: 'Auctions',
    tradesSummary: 'Deals',
    totalAdminTrades: 'Total Entered Deals',
    totalMOJTrades: 'Total Deals',
    totalAdminAuctions: 'Total Entered Auctions',
    totalScheduledAuctions: 'Scheduled Auctions',
    adsBreakdown: 'Ads Breakdown',
    customRange: 'Custom Range',
    auditLogs: 'Audit Logs',
    entityType: 'Entity Type',
    areaId: 'Area ID',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    enterEntityId: 'Enter Entity ID',
    enterAreaId: 'Enter Area ID',
    action: 'Action',
    selectEntityType: 'Select Entity Type',
    changedFields: 'Changed Fields',
    auditLogDetails: 'Audit Log Details',
    basicInformation: 'Basic Information',
    userInformation: 'User Information',
    userName: 'User Name',
    userEmail: 'User Email',
    timestamp: 'Timestamp',
    userId: 'User ID',
    ipAddress: 'IP Address',
    userAgent: 'User Agent',
    valueComparison: 'Value Comparison',
    oldValues: 'Old Values',
    newValues: 'New Values',
    testimonials: 'Testimonials',
    testimonialsListing: 'Testimonials Listing',
    testimonialsCreating: 'Testimonials Creating',
    testimonialsEditing: 'Testimonials Editing',
    editTestimonial: 'Edit Testimonial',
    contentEnglish: 'Content - English',
    contentArabic: 'Content - Arabic',
    likesCount: 'Likes Count',
    okayCount: 'Okay Count',
    nameEn: 'Name - EN',
    nameAr: 'Name - AR',
    addNewTestimonial: 'Add New Testimonial',
    createNewTestimonial: 'Create New Testimonial',
    publishDate: 'Publish Date',
    addNewAdsBrokerage: 'Create New Ads Brokerage',
    adsBrokerageListing: 'Ads Brokerage Listing',
    adsBrokerageCreating: 'Ads Brokerage Creating',
    adsBrokerageEditing: 'Ads Brokerage Editing',
    groupLabel: 'Group Label',
    groupSlug: 'Group Slug',
    priceRange: 'Price Range',
    createNewAdsBrokerage: 'Create New Ads Brokerage',
    endingPrice: 'Ending Price',
    sizes: 'Sizes',
    selectSizes: 'Sizes',
    selectSizesHint: 'Select from predefined sizes',
    adsBrokerageUpdate: 'Ads Brokerage Updating',
    updateAdsBrokerage: 'Update Ads Brokerage',
    adsBrokerageConfigListing: 'General Configuration Listing',
    addNewAdsBrokerageConfig: 'Add New Ads Brokerage Configuration',
    brokerName: 'Broker Name',
    agentName: 'Agent Name',
    config: 'Configuration Template',
    selectConfig: 'Select Configuration',
    updateAdsBrokerageConfig: 'Update Ads Brokerage Configuration',
    adsBrokerageConfigUpdate: 'Ads Broker Configuration Update',
    createNewAdsBrokerageConfig: 'Create New Ads Brokerage Configuration',
    adsBrokerageConfigCreating: 'Ads Brokerage Configuration Creating',
    SUCCESSFULLY_CREATED_ADS_BROKERAGE: 'Successfully Created Ads Brokerage',
    SUCCESSFULLY_UPDATED_ADS_BROKERAGE: 'Successfully Updated Ads Brokerage',
    SUCCESSFULLY_CREATED_ADS_BROKERAGE_CONFIG:
      'Successfully Created Ads Brokerage Configuration',
    SUCCESSFULLY_UPDATED_ADS_BROKERAGE_CONFIG:
      'Successfully Updated Ads Brokerage Configuration',
    ERROR_PROCESSING_DATA: 'Error Processing Data',
    currentLogos: 'Current Logos',
    logos: 'Logos',
    logoJson: 'Logo JSON',
    userAvatarsJson: 'User Avatars JSON',
    currentUserAvatars: 'Current User Avatars',
    adImagesJson: 'Ad Images JSON',
    areaConfigurationListing: 'Area Configuration Lisiting',
    addNewAreaConfiguration: 'Add New Area Configuration',
    typeOfIndex: 'Type of Index',
    selectTypeOfIndex: 'Select Type of Index',
    currentAdImages: 'Current Ad Images',
    userAvatars: 'User Avatars',
    adImages: 'Ad Images',
    availableVariables: 'Available Variables for dynamic input',
    giftSubscription: 'Gift Subscription',
    searchUser: 'Search User',
    searchByPhone: 'Search by Phone',
    searchByEmail: 'Search by Email',
    giftNoteOptional: 'Gift Note - Optional',
    selectedUser: 'Selected User',
    creditsOnly: 'Credits Only',
    subscriptionOnly: 'Subscription Only',
    packageDetails: 'Package Details',
    giftPackage: 'Gift Package',
    currentThumbnails: 'Current Thumbnails',
    behaviorFilter: 'Behavior Filter',
    lastAd: 'Last Ad',
    expiredNoRenewal: 'Expired No Renewal',
    activeNoAdsUsage: 'Active Ads No Usage',
    freePackageOnly: 'Free Package Only',
    daysWithoutAds: 'Days Without Ads',
    selectOptions: 'Select Options',
    monthsWithoutRenewal: 'Months Without Renewal',
    specialAds: 'Special Ads',
    noUsersFound: 'No Users Found',
    searching: 'Searching...',
    mixPackage: 'Mix Package',
    days: 'Days',
    unknown: 'Unknown',
    NOTE_MAX_500_CHARS: 'Note: Max 500 Characters',
    PLEASE_SELECT_USER: 'Please Select User',
    SUCCESSFULLY_GIFTED_PACKAGE: 'Successfully Gifted Package',
    GIFT_PACKAGE_FAILED: 'Gift Package Failed',
    authorAvatar: 'Author Avatar',
    updateBlogTag: 'Update Blog Tag',
    blogsTagsUpdating: 'Blogs Tags Updating',
    filteredResults: 'Filtered Results',
    invalidateOfficeWarning:
      'This action will remove owner privileges and deactivate related business information.',
    sendWhatsAppNotification:
      'Would you like to send a WhatsApp notification to the office owner?',
    convertOfficeToIndividual: 'Convert Office to Individual',
    areYouSure: 'Are you sure?',
    yesConvert: 'Yes, Convert',
    yesSend: 'Yes, Send',
    isPriceIndex: 'Price Index Availability',
    isVolumeIndex: 'Volume Index Availability',
    indexDateRangeListing: 'Index Date Range Listing',
    startYear: 'Start Year',
    endYear: 'End Year',
    supportedIntervals: 'Supported Intervals',
    selectViewType: 'Select View Type',
    addNewIndexDateRange: 'Add New Index Date Range',
    indexDateRangeCreating: 'Index Date Range Creating',
    createNewIndexDateRange: 'Create New Index Date Range',
    indexDateRangeUpdating: 'Index Date Range Updating',
    updatePriceIndexDateRange: 'Update Index Date Range',
    SUCCESSFULLY_CREATED_INDEX_DATE_RANGE:
      'Successfully Created Index Date Range',
    SUCCESSFULLY_UPDATED_INDEX_DATE_RANGE:
      'Successfully Updated Index Date Range',
    SUPPORTED_INTERVALS_IS_REQUIRED_FIELD:
      'At least one supported interval must be selected',
    START_YEAR_IS_REQUIRED_FIELD: 'Start year is a required field',
    END_YEAR_IS_REQUIRED_FIELD: 'End year is a required field',
    typeId: 'Index Type',
    selectIndexType: 'Select Index Type',
    TYPE_ID_IS_REQUIRED_FIELD: 'Index type is a required field',
    label: 'Label',
    typeName: 'Type Name',
    rangeLabel: 'Range Label',
    LABEL_IS_REQUIRED_FIELD: 'Label is a required field',
    TITLE_AR_IS_REQUIRED_FIELD: 'Title AR is a required field',
    TITLE_EN_IS_REQUIRED_FIELD: 'Title EN is a required field',
    isDefault: 'Is Default',
    methodology: 'Methodology',
    methodologyListing: 'Methodology Listing',
    priceIndexMethodology: 'Price Index Methodology',
    volumeIndexMethodology: 'Volume Index Methodology',
    detailedMethodologyPrice: 'Detailed Methodology - Price Index',
    detailedMethodologyVolume: 'Detailed Methodology - Volume Index',
    methodologyUpdating: 'Methodology Updating',
    updateMethodology: 'Update Methodology',
    updateMethodologyContent: 'Update Methodology Content - Mobile',
    updateMethodologyContentWeb: 'Update Methodology Content - Web',
    methodologyContentUpdating: 'Methodology Content Updating',
    lastUpdated: 'Last Updated',
    SUCCESSFULLY_UPDATED_METHODOLOGY: 'Successfully Updated Methodology',
    SUCCESSFULLY_UPDATED_METHODOLOGY_CONTENT:
      'Successfully Updated Methodology Content',
    FAILED_TO_FETCH_METHODOLOGY: 'Failed to fetch methodology',
    indicesPropertyCategoriesListing: 'Indices Property Categories Listing',
    addNewIndicesPropertyCategory: 'Add New Property Category',
    indicesPropertyCategoryCreating: 'Indices Property Category Creating',
    createNewIndicesPropertyCategory: 'Create New Property Category',
    indicesPropertyCategoryUpdating: 'Indices Property Category Updating',
    updateIndicesPropertyCategory: 'Update Property Category',
    disablePriceAreas: 'Disable Price Areas',
    disablePriceAreasHint: 'Hide price index areas for this category',
    disableVolumeAreas: 'Disable Volume Areas',
    disableVolumeAreasHint: 'Hide volume index areas for this category',
    volumeIndexTicker: 'Volume Index Ticker',
    volumeIndexTickerHint: 'Include this category in the volume index ticker',
    SUCCESSFULLY_CREATED_INDICES_PROPERTY_CATEGORY:
      'Successfully Created Property Category',
    SUCCESSFULLY_UPDATED_INDICES_PROPERTY_CATEGORY:
      'Successfully Updated Property Category',
    appViews: 'App Views',
    appViewsHint: 'Choose which index charts the apps show for this category',
    priceIndexView: 'Price Index View',
    volumeIndexView: 'Volume Index View',
    ppmView: 'Price per Meter View',
    noOfDealsView: 'Number of Deals View',
    indicesPropertyCategoryActiveHint: 'Show this category in the apps',
    indicesPropertyCategorySlugHint:
      'Leave empty to generate it from the English title',
    SUCCESSFULLY_UPDATED_VIEW_FLAG: 'View setting updated',
    'Auto Sync Pipeline': 'Auto Sync Pipeline',
    autoSyncPipeline: 'Auto Sync Pipeline',
    autoSyncPipelineDescription:
      'Runs the auto sync pipeline as a background task. The sync keeps running after the task has started.',
    runSync: 'Run Sync',
    confirmRunAutoSync: 'The auto sync pipeline will start now.',
    autoSyncStarted: 'The auto sync task has started',
    autoSyncLastTask: 'Last started task',
    Notification: 'Notification',
    'Send Notification': 'Send Notification',
    sendNotification: 'Send Notification',
    deeplinkNoPermission: "You don't have permission to send notifications.",
    deeplinkLoadDestinationsFailed: 'Could not load the notification types.',
    deeplinkRetry: 'Retry',
    deeplinkSectionDestination: 'Destination',
    deeplinkType: 'Notification type',
    deeplinkSelectType: 'Select a notification type',
    deeplinkNoParams:
      'This screen has no extra fields. Only the language is needed.',
    deeplinkLang: 'Language',
    deeplinkLangAr: 'Arabic (ar)',
    deeplinkLangEn: 'English (en)',
    deeplinkLink: 'Deep link',
    deeplinkCopy: 'Copy',
    deeplinkCopied: 'Copied',
    deeplinkClear: 'Clear',
    bannerDeeplinkTitle: 'Deep link banner',
    bannerDeeplinkEnable: 'Use a deep link (new way)',
    bannerDeeplinkHint:
      'Optional. When on, tapping the banner opens this in-app screen.',
    bannerDeeplinkScreen: 'Screen to open',
    bannerDeeplinkNoPermission:
      "You don't have permission to set a deep link on banners.",
    deeplinkAdvanced: 'Advanced: paste a link',
    deeplinkPasteLink: 'Paste the full link',
    deeplinkAdvancedHint:
      'The backend validates the pasted link before sending.',
    deeplinkCustomLink: 'Custom link',
    deeplinkSelectPlaceholder: 'Select',
    deeplinkSelectMany: 'Select one or more',
    deeplinkDatePlaceholder: 'Pick a date',
    deeplinkMonthPlaceholder: 'Pick a month',
    deeplinkAuctionPlaceholder: 'Pick an auction or type its ID',
    deeplinkCceHint:
      'Leave empty to open the CCE form. Fill it to open a saved result.',
    deeplinkParam_id: 'ID',
    deeplinkParam_adType: 'Ad type',
    deeplinkParam_area: 'Area',
    deeplinkParam_category: 'Category',
    deeplinkParam_eventId: 'Event ID',
    deeplinkParam_type: 'Type',
    deeplinkParam_dateFrom: 'From date',
    deeplinkParam_dateTo: 'To date',
    deeplinkParam_date: 'Month',
    deeplinkParam_index_date: 'Quarter',
    deeplinkParam_interval: 'Interval',
    deeplinkParam_view: 'View',
    deeplinkParam_packageType: 'Package type',
    deeplinkParam_ads_id: 'Ad ID',
    deeplinkParam_auction_id: 'Auction',
    'deeplinkParam_auction-property_id': 'Property ID',
    deeplinkParam_cce_id: 'Result ID',
    deeplinkParam_ive_id: 'Result hash',
    'deeplinkParam_ive-form_type': 'Property type',
    deeplinkParam_index_type: 'Index type',
    deeplinkParam_broker_id: 'Broker ID',
    deeplinkParam_deals_area: 'Areas',
    deeplinkOpt_land: 'Land',
    deeplinkOpt_building: 'Building',
    deeplinkOpt_monthly: 'Monthly',
    deeplinkOpt_quarterly: 'Quarterly',
    deeplinkOpt_yearly: 'Yearly',
    deeplinkOpt_chart: 'Chart',
    deeplinkOpt_table: 'Table',
    'deeplinkOpt_volume-index': 'Volume index',
    'deeplinkOpt_price-index': 'Price index',
    'deeplinkOpt_total-transactions': 'Total transactions',
    'deeplinkOpt_price-per-meter': 'Price per meter',
    deeplinkOpt_1: 'Q1',
    deeplinkOpt_2: 'Q2',
    deeplinkOpt_3: 'Q3',
    deeplinkOpt_4: 'Q4',
    deeplinkOpt_ive: 'Instant valuation (IVE)',
    deeplinkOpt_ads: 'Ads',
    deeplinkOpt_auctions: 'Auctions',
    deeplinkOpt_trades: 'Trades',
    deeplinkOpt_chatbot: 'Chatbot',
    deeplinkOpt_enterprise: 'Enterprise',
    deeplinkSelectFirst: 'Select {field} first',
    deeplinkSectionMessage: 'Message',
    deeplinkTitleAr: 'Title (AR)',
    deeplinkTitleEn: 'Title (EN)',
    deeplinkBodyAr: 'Body (AR)',
    deeplinkBodyEn: 'Body (EN)',
    deeplinkImageUrl: 'Image URL',
    deeplinkImageHint:
      'Optional. Must start with https://. Leave empty to use the Alhisba logo.',
    deeplinkPreview: 'Preview',
    deeplinkPreviewArabic: 'Arabic',
    deeplinkPreviewEnglish: 'English',
    deeplinkPreviewTitle: 'Notification title',
    deeplinkPreviewBody: 'Notification body',
    deeplinkNow: 'now',
    deeplinkSectionAudience: 'Recipients',
    deeplinkAudienceMembers: 'Selected users',
    deeplinkAudienceAll: 'All users',
    deeplinkSearchUsers: 'Search by name, phone or email',
    deeplinkSearching: 'Searching...',
    deeplinkNoUsersFound: 'No users found',
    deeplinkAdd: 'Add',
    deeplinkAdded: 'Added',
    deeplinkRemove: 'Remove',
    deeplinkClearAll: 'Clear all',
    deeplinkSelectedCount: '{count} of 500 users selected',
    deeplinkMaxUsers: 'You reached the limit of 500 users.',
    deeplinkMembersNote:
      "Users with notifications off or no app installed won't receive it.",
    deeplinkAllWarning: 'This sends to every user with notifications enabled.',
    deeplinkSend: 'Send',
    deeplinkSending: 'Sending...',
    deeplinkReset: 'Reset',
    deeplinkConfirmMembers: 'Send this notification to {count} users?',
    deeplinkConfirmAllTitle: 'Send to all users?',
    deeplinkConfirmScreen: 'Screen',
    deeplinkConfirmTypeSend: 'Type SEND to confirm',
    deeplinkConfirmTypeSendError: 'Type SEND in capital letters to continue.',
    deeplinkResultSent: 'Sent to {sent} of {total} users.',
    deeplinkResultFailed: '{failed} failed.',
    deeplinkResultQueued: 'Sending to {total} users in the background.',
    deeplinkResultNone:
      'No users could receive this. They may have notifications off or no app installed.',
    deeplinkErrorConflict:
      "Another 'All users' send is still running. Try again in a few minutes.",
    deeplinkErrorGeneric: 'Something went wrong. Try again.',
    deeplinkFieldRequired: 'This field is required.',
    deeplinkWholeNumber: 'Enter a whole positive number.',
    deeplinkNoSpaces: 'Enter a value without spaces.',
    deeplinkMaxChars: 'Maximum {max} characters.',
    deeplinkHttpsOnly: 'The image URL must start with https://.',
    deeplinkLinkInvalid: 'Enter a full link that starts with https://.',
    deeplinkPickUser: 'Select at least one user.',
    deeplinkTooManyUsers: 'You can select up to 500 users.',
    deeplinkDateOrder: 'The start date must not be after the end date.',
    'Rejection Reasons': 'Rejection Reasons',
    expertReviewRejectReasonsListing: 'Rejection Reasons',
    addNewExpertReviewRejectReason: 'Add New Rejection Reason',
    expertReviewRejectReasonCreating: 'Rejection Reason Creating',
    createNewExpertReviewRejectReason: 'Create New Rejection Reason',
    expertReviewRejectReasonUpdating: 'Rejection Reason Updating',
    expertReviewRejectReasonLoadFailed:
      'This rejection reason could not be loaded. It may have been removed.',
    updateExpertReviewRejectReason: 'Update Rejection Reason',
    rejectReasonEn: 'Reason EN',
    rejectReasonAr: 'Reason AR',
    REASON_EN_IS_REQUIRED_FIELD: 'Reason EN is a required field',
    REASON_AR_IS_REQUIRED_FIELD: 'Reason AR is a required field',
    SUCCESSFULLY_CREATED_EXPERT_REVIEW_REJECT_REASON:
      'Successfully Created Rejection Reason',
    SUCCESSFULLY_UPDATED_EXPERT_REVIEW_REJECT_REASON:
      'Successfully Updated Rejection Reason',
    'Expert Review': 'Expert Review',
    expertReviewListing: 'Expert Review',
    expertReviewConsole: 'Expert Review Console',
    expertReviewQuarterLabelProvisional: '{quarter} · provisional',
    expertReviewQuarterLabelFinal: '{quarter} · final (grace period passed)',
    expertReviewProgress: '{done} of {total} reviewed',
    expertReviewFilterNeedsReview: 'Needs review',
    expertReviewFilterHighRisk: 'High risk',
    expertReviewFilterApproved: 'Approved',
    expertReviewQuarterRunning: 'Quarter in progress',
    expertReviewQuarterEnded: 'Quarter ended',
    expertReviewFilterAdjusted: 'Adjusted',
    expertReviewFilterRejected: 'Rejected',
    expertReviewFilterAll: 'All',
    expertReviewApproveLowRisk: 'Approve low-risk areas',
    expertReviewEscalationAfter: 'Escalate after',
    expertReviewEscalationSavedToast: 'hours — level 2 is notified after this',
    expertReviewEscalationSaveFailed: 'Could not save the escalation window.',
    expertReviewConfirmBulkApprove:
      'This publishes the new value for every low-risk area still waiting in {quarter}, wherever it sits on the board.',
    expertReviewConfirmApprove:
      'This publishes {value} KD/m² as the live price for {area}.',
    expertReviewShortcutMove: 'move',
    expertReviewShortcutApprove: 'approve',
    expertReviewColArea: 'Area',
    expertReviewColPrice: 'Price KD/m²',
    expertReviewColQoq: 'QoQ',
    expertReviewColYoy: 'YoY',
    expertReviewColDeals: 'Deals',
    expertReviewColEvidence: 'Evidence',
    expertReviewColDecision: 'Decision',
    expertReviewEvidenceOBSERVED: 'OBSERVED',
    expertReviewEvidenceMIXED: 'MIXED',
    expertReviewEvidenceCLUSTER_CARRIED: 'CARRIED',
    expertReviewClusterLabel: 'cluster {cluster}',
    expertReviewNewValue: 'New value',
    expertReviewLastApproved: 'Last approved',
    expertReviewChange: 'Change',
    expertReviewCarriedNote: 'No deals of its own this quarter.',
    expertReviewThinNote:
      'Its cluster has only {count} deals this quarter — below the {threshold}-deal threshold, so the cluster median itself is unstable and one deal can move it sharply.',
    expertReviewPricePath: 'Price path · last 12 quarters',
    expertReviewDealsInArea: 'Deals in {area} this quarter ({count})',
    expertReviewDealsInCluster:
      'Deals across cluster {cluster} this quarter ({count})',
    expertReviewNoOwnDeals:
      'No deals registered in this area this quarter. The value is carried entirely from its cluster — the evidence below is the only evidence there is.',
    expertReviewNoClusterDeals:
      'This area sits in its own single-area cluster, so there is no wider peer evidence. The value carries forward from its last observed quarter.',
    expertReviewClusterFlagNote:
      'Highlighted: highest deal in the cluster this quarter — it sits above the rest of the sample and pulls the cluster median up.',
    expertReviewReading: 'Reading',
    expertReviewEvidenceTag: 'Evidence tag',
    expertReviewQuarterStatus: 'Quarter status',
    expertReviewQuarterStatusFinal: 'FINAL — closed, grace period passed',
    expertReviewQuarterStatusProvisional:
      'PROVISIONAL — {percent}% of quarter elapsed',
    expertReviewYearOnYear: 'Year on year',
    expertReviewIfRejected: 'If rejected',
    expertReviewIfRejectedFinal: 'you enter the value to publish',
    expertReviewIfRejectedProvisional:
      'rolls back to {value} KD/m², or you adjust the value to publish',
    expertReviewNote: 'Note',
    expertReviewNotePlaceholder: 'Tell us what you saw',
    expertReviewYourValue: 'Your value',
    expertReviewAdjustPrice: 'Adjust the price',
    expertReviewPricePerSqmUnit: 'KD/m²',
    expertReviewColType: 'Type',
    expertReviewColSize: 'Size m²',
    expertReviewColPricePerSqm: 'KD/m²',
    expertReviewDealBuilding: 'Building',
    expertReviewDealLand: 'Land',
    expertReviewReject: 'Reject',
    expertReviewClose: 'Close',
    expertReviewApproveAndPublish: 'Approve — publish {value}',
    expertReviewConfirmRejection: 'Confirm rejection',
    expertReviewShortcutReject: 'reject',
    expertReviewShortcutEvidence: 'evidence',
    expertReviewTapForEvidence: 'tap for evidence →',
    expertReviewRejectedAdjustedToast:
      'rejected — your value {value} KD/m² published',
    expertReviewRejectedProvisionalToast:
      'rejected — rolled back to {value} KD/m², shown as "under review"',
    expertReviewThin: 'THIN {count}',
    expertReviewThinTitle: 'Cluster sample is thin',
    expertReviewApprove: 'Approve',
    expertReviewApproved: 'Approved',
    expertReviewPendingDecision: 'Pending review',
    expertReviewDecisionFailed: 'The decision was not saved. Please try again.',
    expertReviewLoadFailed:
      'The list could not be loaded. Showing the previous results.',
    expertReviewEvidenceLoading: 'Loading evidence…',
    expertReviewReasonsLoading: 'Loading rejection reasons…',
    expertReviewReasonsFailed:
      'Rejection reasons could not be loaded, so this area cannot be rejected yet.',
    expertReviewEvidenceFailed:
      'Evidence could not be loaded, so decisions are disabled for this area.',
    expertReviewListStale:
      'The decision was saved, but the list could not be refreshed. Reload to see the latest values.',
    expertReviewAdjusted: 'Adjusted',
    expertReviewRejected: 'Rejected',
    expertReviewEmptyFilter: 'Nothing here. Pick another filter.',
    expertReviewDealsShort: '{count} deals',
    expertReviewYoyShort: 'YoY {value}',
    expertReviewQoqShort: '{value} QoQ',
    expertReviewApprovedToast: 'approved — live at {value} KD/m²',
    expertReviewBulkApprovedToast:
      'low-risk areas approved — high-risk areas still need your eye',
    ADS_DURATION_IS_REQURED_FIELD: 'Ads duration is a required field',
    AD_TYPE_IS_REQUIRED_FIELD: 'Ad type is a required field',
    AGENT_NAME_IS_REQUIRED_FIELD: 'Agent name is a required field',
    ALLOWED_USAGE_IS_REQUIRED_FIELD: 'Allowed usage is a required field',
    ALLOWED_USAGE_REQUIRED: 'Allowed usage is required',
    AR_CONTENT_IS_REQUIRED_FIELD: 'Arabic content is a required field',
    AR_TITLE_IS_REQUIRED: 'Arabic title is required',
    BLOG_UPDATE_SUCCESS: 'Blog updated successfully',
    BROKER_NAME_IS_REQUIRED_FIELD: 'Broker name is a required field',
    COMPONENT_TYPE_IS_REQUIRED_FIELD: 'Component type is a required field',
    CONFIG_IS_REQUIRED_FIELD: 'Configuration is a required field',
    DISCOUNT_PERCENTAGE_IS_REQUIRED_FIELD:
      'Discount percentage is a required field',
    DISCOUNT_PERCENTAGE_REQUIRED: 'Discount percentage is required',
    DURATION_IS_REQUIRED_FIELD: 'Duration is a required field',
    DURATION_REQUIRED: 'Duration is required',
    ENDING_PRICE_IS_REQUIRED_FIELD: 'Ending price is a required field',
    ENDING_PRICE_MUST_BE_GREATER:
      'Ending price must be greater than starting price',
    EN_CONTENT_IS_REQUIRED_FIELD: 'English content is a required field',
    EN_KEY_IS_REQUIRED_FIELD: 'English key is a required field',
    EN_TITLE_IS_REQUIRED: 'English title is required',
    FAILED_TO_FETCH_ORGANIZER: 'Failed to fetch organizer',
    GROUP_LABEL_IS_REQUIRED_FIELD: 'Group label is a required field',
    GROUP_SLUG_IS_REQUIRED_FIELD: 'Group slug is a required field',
    HOME_SERVICE_TYPE_IS_REQUIRED_FIELD:
      'Home service type is a required field',
    INVALID_PHONE_NUMBER: 'Invalid phone number',
    NUMBER_OF_ADS_IS_REQUIRED_FIELD: 'Number of ads is a required field',
    OFFERED_PRICE_IS_REQUIRED_FIELD: 'Offered price is a required field',
    OFFERED_PRICE_REQUIRED: 'Offered price is required',
    PACKAGE_UPDATE_SUCCESS: 'Package updated successfully',
    PRICE_MUST_BE_POSITIVE: 'Price must be a positive number',
    PRICE_REQUIRED: 'Price is required',
    PROMOTION_UPDATE_SUCCESS: 'Promotion updated successfully',
    PROMO_CODE_IS_REQUIRED_FIELD: 'Promo code is a required field',
    PROMO_CODE_REQUIRED: 'Promo code is required',
    SLUG_IS_REQUIRED_FIELD: 'Slug is a required field',
    SPECIAL_ADS_IS_REQUIRED_FIELD: 'Special ads is a required field',
    STATUS_IS_REQUIRED: 'Status is required',
    STATUS_IS_REQUIRED_FIELD: 'Status is a required field',
    SUCCESSFULLY_ADDED_AD_Service: 'Ad service added successfully',
    SUCCESSFULLY_ADDED_SUB_CATEGORIE_OPTIONS:
      'Sub category options added successfully',
    SUCCESSFULLY_CREATED_AD: 'Ad created successfully',
    SUCCESSFULLY_CREATED_AUCTION_PROPERTY_GROUPING:
      'Auction property grouping created successfully',
    SUCCESSFULLY_CREATED_CCE_SUB_CATEGORIE:
      'CCE sub category created successfully',
    SUCCESSFULLY_CREATED_OFFICE: 'Office created successfully',
    SUCCESSFULLY_CREATED_SECTOR: 'Sector created successfully',
    SUCCESSFULLY_CREATED_TESTIMONIAL: 'Testimonial created successfully',
    SUCCESSFULLY_DELETED: 'Deleted successfully',
    SUCCESSFULLY_INVALIDATED_OFFICE: 'Office invalidated successfully',
    SUCCESSFULLY_UPDATED_AUCTION_PROPERTY_GROUPING:
      'Auction property grouping updated successfully',
    SUCCESSFULLY_UPDATED_BLOG: 'Blog updated successfully',
    SUCCESSFULLY_UPDATED_CCE_SUB_CATEGORIE:
      'CCE sub category updated successfully',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_GENERAL_specs:
      'IRE factor general specs updated successfully',
    SUCCESSFULLY_UPDATED_NEWS: 'News updated successfully',
    SUCCESSFULLY_UPDATED_OFFICE: 'Office updated successfully',
    SUCCESSFULLY_UPDATED_SECTOR: 'Sector updated successfully',
    SUCCESSFULLY_UPDATED_STATUS: 'Status updated successfully',
    SUCCESSFULLY_UPDATED_TESTIMONIAL: 'Testimonial updated successfully',
    SUCCESSFULLY_UPDATE_SUB_CATEGORIE_OPTIONS:
      'Sub category options updated successfully',
    TRANSACTION_DATE_IS_REQUIRED_FIELD: 'Transaction date is a required field',
    TRANSACTION_DATE_TIME_IS_REQUIRED_FIELD:
      'Transaction date and time is a required field',
    TYPE_IRE_IS_REQUIRED_FIELD: 'IRE type is a required field',
    TYPE_IS_REQUIRED_FIELD: 'Type is a required field',
    TYPE_OF_INDEX_IS_REQUIRED_FIELD: 'Type of index is a required field',
    UPDATE_FAILED: 'Update failed',
    VALUE_IS_REQUIRED_FIELD: 'Value is a required field',
    VERIFICATION_STATUS_IS_REQUIRED: 'Verification status is required',
    AdPriceFrom: 'Ad Price From',
    AdPriceTo: 'Ad Price To',
    Amount: 'Amount',
    ArabicTitle: 'Arabic Title',
    Available: 'Available',
    BasementRentConfig: 'Basement Rent Config',
    CceCategoryTooltip: 'CCE Category Tooltip',
    CceGroupTooltip: 'CCE Group Tooltip',
    Doc: 'Document',
    Finances: 'Finances',
    From: 'From',
    Government: 'Government',
    ID: 'ID',
    Image: 'Image',
    InstantValueSizePanel: 'Instant Value Size Panel',
    IreInvestmentFactorsPropertySeriveListing:
      'IRE Investment Factors Property Service Listing',
    IreTypes: 'IRE Types',
    Loans: 'Loans',
    LoansFundsUpdating: 'Loans Funds Updating',
    'NumOfData ': 'Number of Data',
    'PACI Number': 'PACI Number',
    PackDuration: 'Package Duration',
    'Property Status': 'Property Status',
    PropertyAgeConfig: 'Property Age Config',
    Reports: 'Reports',
    SelectAreas: 'Select Areas',
    Services: 'Services',
    To: 'To',
    Type: 'Type',
    'Unit Components List': 'Unit Components List',
    Unavailable: 'Unavailable',
    'User Name': 'User Name',
    WebIcon: 'Web Icon',
    Website: 'Website',
    Weight: 'Weight',
    adDoc: 'Ad Document',
    adTypeTooltip: 'Ad Type Tooltip',
    adVideo: 'Ad Video',
    addNewField: 'Add New Field',
    addNewIreStreet: 'Add New IRE Street',
    adsServiceDuration: 'Ads Service Duration',
    all: 'All',
    available: 'Available',
    avatar: 'Avatar',
    back: 'Back',
    badgeIcon: 'Badge Icon',
    badges: 'Badges',
    bank: 'Bank',
    baseSiaze: 'Base Size',
    bathrooms: 'Bathrooms',
    blog: 'Blog',
    blogCategoriesUpdating: 'Blog Categories Updating',
    client: 'Client',
    clone: 'Clone',
    close: 'Close',
    configValue: 'Config Value',
    copy: 'Copy',
    current: 'Current',
    decreasePercentage: 'Decrease Percentage',
    decreasedBathrooms: 'Decreased Bathrooms',
    decreasedMaidRoom: 'Decreased Maid Room',
    decreasedRooms: 'Decreased Rooms',
    direction: 'Direction',
    disabled: 'Disabled',
    duplicateAds: 'Duplicate Ads',
    duplicates: 'Duplicates',
    editPercentages: 'Edit Percentages',
    editValConfig: 'Edit Value Config',
    electricity: 'Electricity',
    'electricity ...': 'Electricity',
    'electricity..': 'Electricity',
    enabled: 'Enabled',
    endDate: 'End Date',
    eventId: 'Event ID',
    export: 'Export',
    'facingOptionNameAr Lang': 'Facing Option Name (Arabic)',
    factorOptionIre: 'Factor Option IRE',
    finalPrice: 'Final Price',
    financesFunds: 'Finances Funds',
    firstDecreasedPercentage: 'First Decreased Percentage',
    floorTypes: 'Floor Types',
    home: 'Home',
    homeAdDurationDay: 'Home Ad Duration (Days)',
    homeAds: 'Home Ads',
    homeAdsDuration: 'Home Ads Duration',
    homepage: 'Homepage',
    icon: 'Icon',
    increasePercentage: 'Increase Percentage',
    increasedBathrooms: 'Increased Bathrooms',
    increasedMaidRoom: 'Increased Maid Room',
    increasedRooms: 'Increased Rooms',
    indices: 'Indices',
    intervals: 'Intervals',
    'ire-commercail': 'IRE Commercial',
    'ire-commercial': 'IRE Commercial',
    'ire-industrial': 'IRE Industrial',
    'ire-investment': 'IRE Investment',
    'ire-literal': 'IRE Literal',
    ireAreaTooltip: 'IRE Area Tooltip',
    ireCommercailFactorsLocationSpecsListing:
      'IRE Commercial Factors Location Specs Listing',
    ireCommercialFactorsLocationSpecsListing:
      'IRE Commercial Factors Location Specs Listing',
    ireFactorsQualityssUpdating: 'IRE Factors Quality Updating',
    ireIndustrailFactorsLocationSpecsListing:
      'IRE Industrial Factors Location Specs Listing',
    ireInvestmentFactorsLocationSpecsListing:
      'IRE Investment Factors Location Specs Listing',
    ireLiteralFactorsLocationSpecsListing:
      'IRE Literal Factors Location Specs Listing',
    ireSizesUpdating: 'IRE Sizes Updating',
    ireV2FloorTypeListing: 'IRE V2 Floor Type Listing',
    ireV2PropertyAgeListing: 'IRE V2 Property Age Listing',
    ireV2PropertyTypeListing: 'IRE V2 Property Type Listing',
    key: 'Key',
    likes: 'Likes',
    'loan Amount': 'Loan Amount',
    loansFunds: 'Loans Funds',
    message: 'Message',
    metadata: 'Metadata',
    newsNameArLang: 'News Name (Arabic)',
    newsNameEnLang: 'News Name (English)',
    next: 'Next',
    noSkip: 'No Skip',
    numberOfAds: 'Number of Ads',
    obligations: 'Obligations',
    of: 'Of',
    offices: 'Offices',
    okays: 'OK',
    oneTime: 'One Time',
    organizerMapLogo: 'Organizer Map Logo',
    organizerVideo: 'Organizer Video',
    otpGenerated: 'OTP Generated',
    packageTitleAr: 'Package Title (Arabic)',
    packageTitleEn: 'Package Title (English)',
    page: 'Page',
    pickaMonth: 'Pick a Month',
    plotSizeOptionsUpdating: 'Plot Size Options Updating',
    preview: 'Preview',
    previous: 'Previous',
    pricepermeter: 'Price Per Meter',
    promotionTitleAr: 'Promotion Title (Arabic)',
    promotionTitleEn: 'Promotion Title (English)',
    properties: 'Properties',
    propertyCategoryTooltip: 'Property Category Tooltip',
    propertyTypeText: 'Property Type',
    publicity: 'Publicity',
    purchaseAt: 'Purchase At',
    query: 'Query',
    'registered-trades': 'Registered Trades',
    registeredTradesScrapingCreating: 'Registered Trades Scraping Creating',
    rejection: 'Rejection',
    remove: 'Remove',
    renew: 'Renew',
    required: 'Required',
    rooms: 'Rooms',
    salary: 'Salary',
    seaFrontOptionNameEnLang: 'Sea Front Option Name (English)',
    search: 'Search',
    section: 'Section',
    sectorsUpdating: 'Sectors Updating',
    selectFloorType: 'Select Floor Type',
    selectIreArea: 'Select IRE Area',
    selectIreType: 'Select IRE Type',
    selectMerchant: 'Select Merchant',
    selectNotes: 'Select Notes',
    selectOption: 'Select Option',
    selectPropertyTypesCategories: 'Select Property Types Categories',
    selectRejectReasons: 'Select Rejection Reasons',
    seo: 'SEO',
    seoSchema: 'SEO Schema',
    service: 'Service',
    shopRentConfig: 'Shop Rent Config',
    source: 'Source',
    specialAdDuration: 'Special Ad Duration',
    storedThumbnailUrls: 'Stored Thumbnail URLs',
    streets: 'Streets',
    streetsIreValuesUpdating: 'Streets IRE Values Updating',
    subscribers: 'Subscribers',
    subscriptionType: 'Subscription Type',
    subscriptionsUpdating: 'Subscriptions Updating',
    system: 'System',
    title: 'Title',
    tryAgain: 'Try Again',
    unverified: 'Unverified',
    updateIreDirection: 'Update IRE Direction',
    updateIreFloorType: 'Update IRE Floor Type',
    updateIreQuality: 'Update IRE Quality',
    updateIreSize: 'Update IRE Size',
    updateIreStreetValue: 'Update IRE Street Value',
    updateIreV2PropertyAge: 'Update IRE V2 Property Age',
    updateIreV2PropertyType: 'Update IRE V2 Property Type',
    updateLoanCalculatorAboutWeb: 'Update Loan Calculator About (Web)',
    user: 'User',
    verified: 'Verified',
    version: 'Version',
    viewTypes: 'View Types',
    web: 'Web',
    weightedScore: 'Weighted Score',
    supportedCategories: 'Supported Categories',
    بلوك: 'Block',
    'صفقة تم تصحيحها': 'Corrected Transaction',
    'صفقة خاطئة': 'Wrong Transaction',
    'صفقة صحيحة': 'Correct Transaction',
    'مشكوك فى صحتها': 'Doubtful Transaction',
  },

  ar: {
    signInTitle: 'تسجيل الدخول للحسبة ادمن',
    signInAppraiser: 'تسجيل دخول المثمنين',
    signInBanks: 'تسجيل دخول البنوك',
    email: 'البريد الإلكتروني',
    emailAddress: 'عنوان البريد الإلكتروني',
    password: 'كلمة المرور',
    continue: 'إستمرار',
    alternativeLocale: 'الحسبة ادمن متوفر ايضا باللغة: {0}',
    alternativeLocaleVal: 'English',
    pleaseWait: 'الرجاء الإنتظار...',
    tryAgainExcl: 'حاول مرة اخرى!',
    searchAdmins: 'بحث الادمن',
    INVALID_EMAIL_PASSWORD: 'إسم المستخدم او كلمة المرور غير صحيحة',
    INVALID_LONGITUDE: 'قيمة خط الطول غير صحيحة',
    INVALID_LATITUDE: 'قيمة خط العرض غير صحيحة',
    EMAIL_NOT_VALID: 'البريد الإلكتروني غير صحيح',
    EMAIL_IS_REQUIRED_FIELD: 'حقل البريد الإلكتروني مطلوب',
    PASSWORD_IS_REQUIRED_FIELD: 'حقل كلمة المرور مطلوب',
    VERIFY_PASSWORD_IS_REQUIRED_FIELD: 'حقل تأكيد كلمة المرور مطلوب',
    FULL_NAME_IS_REQUIRED_FIELD: 'حقل الإسم الكامل مطلوب',
    APPRAISER_NAME_IS_REQUIRED_FIELD: 'حقل اسم المقيم مطلوب',
    BANK_DETAILS_IS_REQUIRED_FIELD: 'حقل تفاصيل الحساب البنكي مطلوب',
    PHONE_IS_REQUIRED_FIELD: 'حقل الهاتف مطلوب',
    STARTING_PRICE_IS_REQUIRED_FIELD: 'حقل السعر المبدئي مطلوب',
    STARTING_PRICE_PER_SM_IS_REQUIRED_FIELD:
      'حقل السعر المبدئي لكل متر مربع مطلوب',
    PHONE_NUMBER_IS_REQUIRED_FIELD: 'حقل رقم الهاتف مطلوب',
    LOGO_IS_REQUIRED_FIELD: 'حقل الشعار مطلوب',
    PERSON_NAME_IS_REQUIRED_FIELD: 'حقل اسم جهة الاتصال مطلوب',
    PERSON_PHONE_IS_REQUIRED_FIELD: 'حقل هاتف جهة الاتصال مطلوب',
    EN_NAME_IS_REQUIRED_FIELD: 'حقل الإسم بالانجليزية مطلوب',
    EN_SIZE_IS_REQUIRED_FIELD: 'حقل المساحة بالانجليزية مطلوب',
    AR_SIZE_IS_REQUIRED_FIELD: 'حقل المساحة بالعربية مطلوب',
    FACTOR_OPTION_IVE_IS_REQUIRED_FIELD: 'حقل قيمة التقييم الفوري مطلوب',
    EN_VENUE_IS_REQUIRED_FIELD: 'حقل المكان بالانجليزية مطلوب',
    AR_NAME_IS_REQUIRED_FIELD: 'حقل الإسم بالعربية مطلوب',
    SCORE_IS_REQUIRED_FIELD: 'حقل محموع النقاط بالعربية مطلوب',
    EN_VALUE_IS_REQUIRED_FIELD: 'حقل القيمة بالانجليزية مطلوب',
    AR_VALUE_IS_REQUIRED_FIELD: 'حقل القيمة بالعربية مطلوب',
    AR_QUESTION_IS_REQUIRED_FIELD: 'حقل السؤال بالعربية مطلوب',
    IMAGE_URL_IS_REQUIRED_FIELD: 'حقل رابط الصورة مطلوب',
    URL_IS_REQUIRED_FIELD: 'حقل الرابط مطلوب',
    AR_ANSWER_IS_REQUIRED_FIELD: 'حقل الاجابة بالعربية مطلوب',
    AR_VENUE_IS_REQUIRED_FIELD: 'حقل المكان بالعربية مطلوب',
    AREA_VALUE_IS_REQUIRED_FIELD: 'حقل قيمة المنطقة مطلوب',
    PRICE_VALUE_IS_REQUIRED_FIELD: 'حقل السعر مطلوب',
    EN_QUESTION_IS_REQUIRED_FIELD: 'حقل السؤال بالانجليزية مطلوب',
    EN_ANSWER_IS_REQUIRED_FIELD: 'حقل الاجابة بالانجليزية مطلوب',
    EN_TITLE_IS_REQUIRED_FIELD: 'حقل العنوان باللغة الانجليزية مطلوب',
    AR_TITLE_IS_REQUIRED_FIELD: 'حقل العنوان باللغة العربية مطلوب',
    ACTIVE_STATUS_IS_REQUIRED_FIELD: 'حقل الحالة مطلوب',
    REJECTION_NOTE_IS_REQUIRED_FIELD: 'حقل مذكرة الرفض مطلوب',
    AUCTION_STATUS_IS_REQUIRED_FIELD: 'حقل حالة المزاد مطلوب',
    REQUEST_STATUS_IS_REQUIRED_FIELD: 'حقل حالة الطلب مطلوب',
    DESCRIPTION_IS_REQUIRED_FIELD: 'حقل الوصف مطلوب',
    ROLE_GROUP_IS_REQUIRED_FIELD: 'حقل مجموعة الدور مطلوب',
    ROLE_IS_REQUIRED_FIELD: 'حقل الدور مطلوب',
    ROLE_NAME_IS_REQUIRED_FIELD: 'حقل اسم الدور مطلوب',
    NON_CLIENT_PERCENTAGE_IS_REQUIRED_FIELD:
      'Non client Percentage is a required field',
    BASE_PRICE_IS_REQUIRED_FIELD: 'Base price is a required field',
    ELECTRICITY_IS_REQUIRED_FIELD: 'electricity is a required field',
    PERCENT_IS_REQUIRED_FIELD: 'حقل النسبة المئوية مطلوب',
    FROM_RANGE_IS_REQUIRED_FIELD: 'حقل من مطلوب',
    TO_RANGE_IS_REQUIRED_FIELD: 'حقل الى مطلوب',
    UPDATE_ORGANIZER_DESCRIPTIONS: 'تحديث وصف المنظم',
    organizerDescriptionsUpdating: 'تحديث وصف المنظم',
    BANNER_TYPE_IS_REQUIRED_FIELD: 'Banner type is a required field',
    SCREEN_BANNER_IS_REQUIRED_FIELD: 'Screen banner is a required field',
    ACTION_BANNER_IS_REQUIRED_FIELD: 'Action banner is a required field',
    EXTERNAL_LINK_IS_REQUIRED_FIELD: 'External link is a required field',
    ENTITY_ID_IS_REQUIRED_FIELD: 'Entity id is a required field',
    MERCHANT_IS_REQUIRED_FIELD: 'Merchant is a required field',
    WEIGHT_IS_REQUIRED_FIELD: 'Weight is a required field',
    GROUP_ID_IS_REQUIRED_FIELD: 'حقل رمز المجموعة مطلوب',
    SORT_IS_REQUIRED_FIELD: 'Sort is a required field',
    PASSWORD_AT_LEAST_ONE_NUMBER:
      'كلمة المرور يجب ان تحتوي على رقم واحد على الاقل',
    PASSWORD_AT_LEAST_ONE_LOWER:
      'كلمة المرور يجب ان تحتوي على حرف صغير واحد على الاقل',
    PASSWORD_AT_LEAST_ONE_UPPER:
      'كلمة المرور يجب ان تحتوي على حرف كبير واحد على الاقل',
    PASSWORD_AT_LEAST_ONE_SPECIAL:
      'كلمة المرور يجب ان تحتوي على رمز خاص واحد على الاقل',
    PASSWORD_MIN_4: 'كلمة المرور يجب ان تحتوي على ٤ احرف على الاقل',
    PASSWORD_MAX_20: 'كلمة المرور يجب ان تحتوي على ٢٠ حرف على الاكثر',
    PASSWORDS_MUST_MATCH: 'كلمة المرور غير متطابقة',
    SUCCESSFULLY_CREATED_ADMIN: 'تم إنشاء ادمن جديد بنجاح!',
    SUCCESSFULLY_CREATED_LOCATION: 'تم إنشاء موقع جديد بنجاح!',
    SUCCESSFULLY_CREATED_APPRAISER: 'تم إنشاء مقيم جديد بنجاح!',
    SUCCESSFULLY_CREATED_AUCTION: 'تم إنشاء مزاد جديد بنجاح!',
    SUCCESSFULLY_CREATED_AD_PACKAGE: 'Successfully created a new ad package!',
    SUCCESSFULLY_CREATED_ADS_SERVICE: 'تم إنشاء إعلان جديد بنجاح',
    SUCCESSFULLY_CREATED_IRE_AREA: 'Successfully created a new Ire area!',
    SUCCESSFULLY_CREATED_IRE_VALUE: 'Successfully created a new Ire Value',
    SUCCESSFULLY_CREATED_GROUP_QUESTION: 'تم إنشاء سؤال مجموعة جديد بنجاح!',
    SUCCESSFULLY_CREATED_GROUP_OPTIONS: 'تم إنشاء خيارات مجموعة جديدة بنجاح!',
    SUCCESSFULLY_UPDATED_QUALITY_GROUP: 'تم تحديث مجموعة الجودة بنجاح!',
    SUCCESSFULLY_UPDATED_APPRAISER: 'تم تحديث المقيم بنجاح!',
    SUCCESSFULLY_UPDATED_AUCTION: 'تم تحديث المزاد بنجاح!',
    SUCCESSFULLY_UPDATED_GROUP_QUESTION: 'تم تحديث سؤال مجموعة بنجاح!',
    SUCCESSFULLY_UPDATED_ADS_PACKAGE: 'Successfully updated ad package',
    SUCCESSFULLY_ADDED_AD_SERVICE: 'Successfully Added a new ad service',
    SUCCESSFULLY_ADDED_AD_PACKAGE_SERVICES:
      'Successfully added ad package services!',
    SUCCESSFULLY_ADDED_APPRAISER_BANKS: 'تم اضافة البنوك للمقيم بنجاح!',
    SUCCESSFULLY_UPLOADED_AUCTION_VIDEO: 'تم رفع فيديو المزاد بنجاح!',
    SUCCESSFULLY_UPLOAD_BANK_RATES: 'Successfully upload bank rates',
    SUCCESSFULLY_UPDATED_APPRAISER_BANKS: 'تم تعديل البنوك للمقيم بنجاح!',
    SUCCESSFULLY_ADDED_APPRAISER_PRICES: 'تم اضافة اسعار المقيم بنجاح!',
    SUCCESSFULLY_CREATED_BANK: 'تم إنشاء بنك جديد بنجاح!',
    SUCCESSFULLY_CREATED_ANSWER: 'تم إنشاء اجابة جديدة بنجاح!',
    SUCCESSFULLY_CREATED_IVE_VALUE: 'تم إنشاء قيمة تقييم فوري بنجاح!',
    SUCCESSFULLY_CREATED_STREET_OPTION: 'تم إنشاء خيار شارع جديد بنجاح!',
    SUCCESSFULLY_CREATED_LOCATION_SPECS_OPTION:
      'تم إنشاء خيار مواصفات موقع جديد بنجاح',
    SUCCESSFULLY_CREATED_LAND_SIZE_OPTION: 'تم انشاء خيار مساحة جديد بنجاح!',
    SUCCESSFULLY_CREATED_PLOT_SPECS_OPTION:
      'تم إنشاء خيار مواصفات قطعة ارض جديد بنجاح!',
    SUCCESSFULLY_CREATED_DIRECTION_OPTION: 'تم إنشاء خيار اتجاه بنجاح!',
    SUCCESSFULLY_CREATED_SABAH_CITY_SPECS_OPTION:
      'تم إنشاء خيار مواصفات مدينة صباح بنجاح!',
    SUCCESSFULLY_CREATED_FACING_OPTION: 'تم إنشاء خيار عقار مقابل بنجاح!',
    SUCCESSFULLY_UPDATED_ORGANIZER_DESCRIPTIONS: 'تم تحديث وصف المنظم بنجاح',
    SUCCESSFULLY_CREATED_ORGANIZER: 'تم إنشاء منظم جديد بنجاح!',
    SUCCESSFULLY_CREATED_BANNER: 'Successfully created a new banner!',
    SUCCESSFULLY_CREATED_ROLE: 'تم إنشاء دور جديد بنجاح!',
    SUCCESSFULLY_CREATED_BANK_RATE: 'تم إنشاء تقييم بنك جديد بنجاح!',
    SUCCESSFULLY_CREATED_AD_TYPE: 'تم إنشاء نوع اعلان جديد بنجاح!',
    SUCCESSFULLY_CREATED_PROPERTY: 'تم إنشاء عقار جديد بنجاح!',
    SUCCESSFULLY_CREATED_AREA: 'تم إنشاء منطقة جديدة بنجاح!',
    SUCCESSFULLY_PULLED_DATA: 'تم سحب البيانات بنجاح!',
    SUCCESSFULLY_CREATED_NEWS: 'تم إنشاء خير جديد بنجاح!',
    SUCCESSFULLY_CREATED_PROPERTY_TYPE: 'تم إنشاء نوع عقار جديد بنجاح!',
    SUCCESSFULLY_CREATED_AUCTION_LOCATION: 'تم إنشاء موقع مزاد جديد بنجاح!',
    SUCCESSFULLY_CREATED_AUCTION_DESCRIPTION: 'تم إنشاء وصف مزاد جديد بنجاح!',
    SUCCESSFULLY_CREATED_LOCATION_OPTION: 'تم إنشاء خيار موقع جديد بنجاح',
    SUCCESSFULLY_CREATED_CURB_OPTION: 'تم إنشاء خيار ارتداد جديد بنجاح!',
    SUCCESSFULLY_CREATED_BUILDING_AGE_OPTION:
      'تم إنشاء خيار عمر بناء جديد بنجاح!',
    SUCCESSFULLY_CREATED_FLOOR_OPTION: 'تم إنشاء خيار طابق جديد بنجاح!',
    SUCCESSFULLY_CREATED_FINISHING_QUALITY_OPTION:
      'تم إنشاء خيار جودة التشطيب بنجاح!',
    SUCCESSFULLY_CREATED_IRE_TYPE: 'Successfully created a new Ire Type',
    SUCCESSFULLY_CREATED_IRE_SIZE: 'Successfully created a new Ire Size',
    SUCCESSFULLY_CREATED_IRE_FACTOR_OPTIONS:
      'Successfully created a new Ire Options',
    SUCCESSFULLY_CREATED_IRE_FACTOR_QUALITY:
      'Successfully created a new Ire Quality',
    SUCCESSFULLY_CREATED_IRE_FACTOR_BATHROOMS:
      'Successfully created a new Ire Bathrooms',
    SUCCESSFULLY_CREATED_IRE_FACTOR_GENERAL_SPECS:
      'Successfully created a new Ire General specs',
    SUCCESSFULLY_CREATED_IRE_FACTOR_LOACATION_SPECS:
      'Successfully created a new Ire Location specs',
    SUCCESSFULLY_CREATED_IRE_FACTOR_PROPERTY_SERVICE:
      'Successfully created a new Ire Property Service',
    SUCCESSFULLY_CREATED_QUALITY_RANGE_OPTION: 'تم إنشاء خيار نطاق جودة بنجاح!',
    SUCCESSFULLY_CREATED_QUALITY_GROUP: 'تم إنشاء مجموعة جودة جديدة بنجاح!',
    SUCCESSFULLY_UPDATED_QUALITY_RANGE_OPTION: 'تم تحديث خيار نطاق جودة بنجاح!',
    SUCCESSFULLY_UPDATED_FLOOR_OPTION: 'تم تحديث خيار الطابق بنجاح!',
    SUCCESSFULLY_UPDATED_SEA_FRONT_OPTION:
      'تم تحديث خيار الواجهة البحرية بنجاح!',
    SUCCESSFULLY_UPDATED_BACK_STREET_OPTION:
      'تم تحديث خيار الشارع الخلفي بنجاح!',
    SUCCESSFULLY_UPDATED_BUILDING_AGE_OPTION: 'تم تحديث خيار عمر بناء بنجاح!',
    SUCCESSFULLY_UPDATED_FINISHING_QUALITY_OPTION:
      'تم تحديث خيار جودة التشطيب بنجاح!!',
    SUCCESSFULLY_UPDATED_LOCATION_OPTION: 'تم تحديث خيار موقع جديد بنجاح',
    SUCCESSFULLY_UPDATED_ADS_PACKAGE_SERVICES:
      'Successfully updated ads package services',
    SUCCESSFULLY_UPDATED_FACING_OPTION: 'تم تحديث خيار عقار مقابل بنجاح!',
    SUCCESSFULLY_UPDATED_SABAH_CITY_SPECS_OPTION:
      'تم تحديث خيار مواصفات مدينة صباح بنجاح!',
    SUCCESSFULLY_UPDATED_STREET_OPTION: 'تم تحديث خيار شارع بنجاح!',
    SUCCESSFULLY_UPDATED_ROLE: 'تم تحديث الدور بنجاح!',
    SUCCESSFULLY_UPDATED_LOCATION_SPECS_OPTION: 'تم تحديث خيار الموقع بنجاح',
    SUCCESSFULLY_UPDATED_AS_DEFAULT: 'Successfully set as default!',
    SUCCESSFULLY_UPDATED_LAND_SIZE_OPTION: 'تم تحديث خيار مساحة الارض بنجاح!',
    SUCCESSFULLY_UPDATED_DIRECTION_OPTION: 'تم تحديث خيار الاتجاه بنجاح!',
    SUCCESSFULLY_UPDATED_ADMIN: 'تم تحديث الادمن بنجاح!',
    SUCCESSFULLY_UPDATED_BANK: 'تم تحديث البنك بنجاح!',
    SUCCESSFULLY_UPDATED_ANSWER: 'تم تحديث الاجابة بنجاح!',
    SUCCESSFULLY_UPDATED_ORGANIZER: 'تم تحديث المنظم بنجاح!',
    SUCCESSFULLY_UPDATED_LOCATION: 'تم تحديث الموقع بنجاح!',
    SUCCESSFULLY_UPDATED_AD_TYPE: 'تم تحديث نوع الاعلان بنجاح!',
    SUCCESSFULLY_UPDATED_PROPERTY: 'تم تحديث العقار بنجاح!',
    SUCCESSFULLY_UPDATED_FAQ: 'تم تحديث السؤال الشائع بنجاح!',
    SUCCESSFULLY_UPDATED_AREA: 'تم تحديث المنطقة بنجاح!',
    SUCCESSFULLY_UPDATED_PROPERTY_TYPE: 'تم تحديث نوع العقار بنجاح!',
    SUCCESSFULLY_UPDATED_ABOUT_US: 'تم تحديث نبذة عنا بنجاح!',
    SUCCESSFULLY_UPDATED_TERMS_AND_CONDITIONS: 'تم تحديث الشروط والحكام بنجاح!',
    SUCCESSFULLY_UPDATED_APPRAISAL_REQUEST: 'تم تحديث طلب التقييم بنجاح!',
    SUCCESSFULLY_UPDATED_PLOT_SPECS_OPTION:
      'تم تحديث مواصفات قطعة الارض بنجاح!',
    SUCCESSFULLY_UPDATED_GROUPS_WEIGHT: 'تم تحديث وزن المجوعات بنجاح!',
    SUCCESSFULLY_UPDATED_QUESTIONS_WEIGHT: 'تم تحديث وزن الاسئلة بنجاح',
    SUCCESSFULLY_UPDATED_CURB_OPTION: 'تم تحديث خيار ارتداد بنجاح!',
    SUCCESSFULLY_UPDATED_IRE_TYPE: 'Successfully updated ire type!',
    SUCCESSFULLY_UPDATED_IRE_SIZE: 'Successfully updated ire size!',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_BATHROOM:
      'Successfully updated ire Bathroom',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_OPTION: 'Successfully updated ire Option',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_QUALITY: 'Successfully updated ire Quality',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_GENERAL_SPECS:
      'Successfully updated ire General specs',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_LOCATION_SPECS:
      'Successfully updated ire Location_SPECS',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_PROPERTY_SERVICES:
      'Successfully updated ire Property Services',
    SUCCESSFULLY_UPDATED_IRE_VALUE: 'Successfully updated ire value!',
    SUCCESSFULLY_UPDATED_BANK_RATE: 'تم تحديث تقييم البنك بنجاح!',
    SUCCESSFULLY_UPDATED_BANK_RATE_SETTINGS:
      'تم تحديث اعدادات تقييم البنك بنجاح!',
    SUCCESSFULLY_SENT_NEWSLETTER: 'تم إرسال النشرة الإخبارية للمشتركين بنجاح',
    SUCCESSFULLY_APPROVED_NEWSLETTER: 'تمت الموافقة على النشرة الإخبارية بنجاح',
    SUCCESSFULLY_UPDATED_METATAGS: 'تم تحديث وسوم الميتا بنجاح',
    SUCCESSFULLY_CREATED_METATAG: 'تم إنشاء وسم الميتا بنجاح',
    SUCCESSFULLY_UPDATED_SUBSCRIPTION: 'تم تحديث الاشتراك بنجاح',
    SUCCESSFULLY_ADDED_PROMOTION: 'تمت إضافة العرض الترويجي بنجاح',
    SUCCESSFULLY_ADDED_PACKAGE: 'تمت إضافة الباقة بنجاح',
    SUCCESSFULLY_UPDATED_SEO_CONFIGURATION:
      'تم تحديث إعدادات تحسين محركات البحث بنجاح',
    SUCCESSFULLY_CLONED_REGISTERED_TRADE_SCRAPING:
      'تم استنساخ عملية سحب بيانات الصفقات المسجلة بنجاح',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE_BLOCK:
      'تم تحديث قسم الصفقات المسجلة بنجاح',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADES_GROUPING:
      'تم تحديث تجميع الصفقات المسجلة بنجاح',
    SUCCESSFULLY_CREATED_REGISTERED_TRADE_GROUPING:
      'تم إنشاء تجميع الصفقات المسجلة بنجاح',
    SUCCESSFULLY_UPDATED_INFLUENCER: 'تم تحديث المؤثر بنجاح',
    SUCCESSFULLY_CREATED_INFLUENCER: 'تم إنشاء المؤثر بنجاح',
    SUCCESSFULLY_CREATED_ADS_PROPERTY_GROUPING:
      'تم إنشاء تجميع العقارات للإعلانات بنجاح',
    SUCCESSFULLY_UPDATED_ADS_PROPERTY_GROUPING:
      'تم تحديث تجميع العقارات للإعلانات بنجاح',
    SUCCESSFULLY_CREATED_BADGE: 'تم إنشاء الشارة بنجاح',
    SUCCESSFULLY_UPDATED_BADGE: 'تم تحديث الشارة بنجاح',
    SUCCESSFULLY_UPDATED_HOME_SERVICE: 'تم تحديث خدمة المنزل بنجاح',
    SUCCESSFULLY_CREATED_NEWSLETTER_SECTION:
      'تم إنشاء قسم النشرة الإخبارية بنجاح',
    SUCCESSFULLY_UPDATED_NEWSLETTER_SECTION:
      'تم تحديث قسم النشرة الإخبارية بنجاح',
    SUCCESSFULLY_CREATED_REGISTRATION_REASON: 'تم إنشاء سبب التسجيل بنجاح',
    SUCCESSFULLY_UPDATED_REGISTRATION_REASON: 'تم تحديث سبب التسجيل بنجاح',
    SUCCESSFULLY_UPDATED_AUCTION_LOCATION: 'تم تحديث موقع المزاد بنجاح!',
    SUCCESSFULLY_CREATED_AUCTION_STATUS: 'تم إنشاء حالة المزاد بنجاح!',
    SUCCESSFULLY_UPDATED_AUCTION_STATUS: 'تم تحديث حالة المزاد بنجاح!',
    SUCCESSFULLY_CREATED_BLOG_CATEGORIE: 'تم إنشاء تصنيف المدونة بنجاح!',
    SUCCESSFULLY_UPDATED_BLOG_CATEGORY: 'تم تحديث تصنيف المدونة بنجاح!',
    SUCCESSFULLY_ADDED_BLOG: 'تمت إضافة المدونة بنجاح!',
    SUCCESSFULLY_CREATED_BLOG_TAG: 'تم إنشاء وسم المدونة بنجاح!',
    SUCCESSFULLY_UPDATED_BLOG_TAG: 'تم تحديث وسم المدونة بنجاح!',
    SUCCESSFULLY_ADDED_SHOP_CONFIG: 'تمت إضافة إعدادات المتجر بنجاح!',
    SUCCESSFULLY_UPDATED_STREET: 'تم تحديث الشارع بنجاح!',
    PLEASE_SAVE_BEFORE_CREATING_CLONES: 'يرجى الحفظ قبل إنشاء النسخ المكررة',
    SESSION_EXPIRED: 'انقضت الجلسة',
    SESSION_EXPIRED_TEXT: 'سيتم تحويلك الى شاشة تسجيل الدخول',
    createdDate: 'تاريخ الانشاء',
    createdBy: 'انشأ من قبل',
    confirm: 'Confirm',
    confirmDelete: 'Confirm delete',
    confirmInActive: 'Are you sure you want to inactivate it?',
    confirmActive: 'Are you sure you want to activate it',
    confirmApproveAll: 'Are you sure you want to approve all items?',
    description: 'الوصف',
    read: 'مشاهدة',
    create: 'انشاء',
    update: 'تحديث',
    delete: 'ازالة',
    shortDescription: 'وصف قصير',
    permission: 'الإذن',
    confirmUserBlock: 'نعم, قم بحظر المستخدم!',
    applicantInfo: 'معلومات مقدم الطلب',
    areYouSureQ: 'هل انت متأكد؟',
    youCantRevert: 'لا يمكن التراجع عن الحذف!',
    selectPermissions: 'اختر الاذونات',
    permissionsCount: 'لغاية {count} مصادر',
    updateAdmin: 'تحديث الادمن',
    updateBank: 'تحديث بنك',
    updateAnswer: 'تحديث اجابة',
    updateStreetOption: 'تحديث خيار شارع',
    updateBuildingAgeOption: 'تحديث خيار عمر البناء',
    updateFinishingQualityOption: 'تحديث خيار جودة التشطيب',
    updateFloorOption: 'تحديث خيار الطابق',
    updateSeaFrontLengthOption: 'تحديث خيار طول الواجهة البحرية',
    updateBackStreetLengthOption: 'تحديث خيار طول الشارع الخلفي',
    updateLocationOption: 'تحديث خيار الموقع',
    updateCurbOption: 'تحديث خيار الارتداد',
    updateOrganizer: 'تحديث منظم',
    updateLocation: 'تحديث موقع',
    updateAdType: 'تحديث نوع الاعلان',
    updateProperty: 'تحديث العقار',
    updateFaq: 'تحديث سؤال شائع',
    updateContact: 'تحديث وسائل التواصل',
    updateArea: 'تحديث المنطقة',
    updateIveAreaValue: 'تحديث المنطقة',
    updatePropertyType: 'تحديث نوع العقار',
    updateAuctionLocation: 'تحديث موقع المزاد',
    updateAboutUs: 'تحديث نبذة عنا',
    updateTermsAndConditions: 'تحديث الشروط والاحكام',
    updateLandSizeOption: 'تحديث خيار مساحة الارض',
    updateLocationSpecsOption: 'تحديث خيار الموقع',
    updateDirectionOption: 'تحديث خيار اتجاه',
    updateSabahCitySpecsOption: 'تحديث خيار مواصفاات مدينة صباح',
    updateFacingOption: 'تحديث خيار عقار مقابل',
    updateQualityRangeOption: 'تحديث خيار نطاق الجودة',
    updateQualityGroup: 'تحديث مجموعة الجودة',
    updatePlotSpecsOption: 'تحديث مواصفات قطعة ارض',
    UpdateloansFundsRequest: 'Update Loans Fund Request',
    updateGroupQuestion: 'تحديث سؤال المجموعة',
    updateGroup: 'تحديث المجموعة',
    updateIreType: 'Update Ire Type',
    updateIreFactorBathroom: 'Update Ire Factor Bathroom',
    updateIreFactorsOptions: 'Update Ire Factor Options',
    updateIreFactorsQualitys: 'Update Ire Factor Quality',
    updateIreLocationSpecs: 'Update Ire Location specs',
    updateIreFactorGeneralspecs: 'Update Ire Factor General specs',
    updateIreFactorsPropertyService: 'Update Ire Factor Property Service',
    updateBankRate: 'تحديث اقييم البنك',
    settingBankRate: 'إعدادات',
    updateQuestionsWeight: 'Update Questions Weight',
    updateGroupsWeight: 'Update Groups Weight',
    updatenews: 'تحديث الاخبار',
    bankRatesOverview: 'نظرة عامة على تقييم البنوك',
    changeAppraisalRequestStatus: 'تغيير حالة طلب التقييم',
    updateRole: 'تحديث الدور',
    addNewAdmin: 'اضافة ادمن جديد',
    addNewAppraiser: 'اضافة مقيم جديد',
    addNewBank: 'اضافة بنك جديد',
    addNewAnswer: 'اضافة اجابة جديدة',
    addNewLandSizeOption: 'اضافة مساحة ارض جديدة',
    addNewDirectionOption: 'اضافة خيار اتجاه جديد',
    addNewSabahCitySpecsOption: 'اضافة خيار مواصفات مدينة صباح جديد',
    addNewLocationSpecsOption: 'اضافة خيار مواصفات موقع جديد',
    addNewPlotSpecsOption: 'اضافة مواصفات قطعة ارض جديدة',
    addNewStreetOption: 'اضافة خيار شارع جديد',
    addNewLocationOption: 'اضافة خيار موقع جديد',
    addNewBuildingAgeOption: 'اضافة خيار عمر بناء جديد',
    addNewFinishingQualityOption: 'اضافة خيار جودة تشطيب جديد',
    addNewFloorsOption: 'اضافة خيار طوابق جديد',
    addNewCurbOption: 'اضافة خيار منعطف جديد',
    addNewOrganizer: 'اضافة منظم جديد',
    addNewLocation: 'اضافة موقع جديد',
    addNewRole: 'اضافة دور جديد',
    addNewQualityRangeOption: 'اضافة خيار نطاق جودة جديد',
    addNewAdType: 'اضافة نوع اعلان جديد',
    addNewProperty: 'اضافة عقار جديد',
    addNewIveValue: 'اضافة قيمة تقييم جديدة',
    updateIreValue: 'Update  Ire Value',
    UpdateExistingValues: 'Update Existing Values',
    officeName: 'Office Name',
    borkerEmail: 'Broker Email',
    borkerPhone: 'Broker Phone',
    basicInfoBorker: 'Basic Info Broker',
    basicInfoUser: 'Basic Info User',
    addNewFaq: 'اضافة سؤال شائع جديد',
    addNewArea: 'اضافة منطقة جديدة',
    addNewIVEAreaValue: 'اضافة منطقة جديدة',
    addNewPropertyTypes: 'اضافة نوع عقار جديد',
    addNewAuctionLocation: 'اضافة موقع مزاد جديد',
    addNewPropertyCategory: 'اضافة فئة عقار جديد',
    addNewFacingOption: 'اضافة عقار مقابل جديد',
    addNewQualityGroup: 'اضافة مجموعة جودة جديدة',
    addNewGroupQuestion: 'اضافة سؤال مجموعة جديد',
    addNewIreArea: 'Add New Ire Area',
    addNewIreType: 'Add New Ire Type',
    addNewIreSize: 'Add New Ire Size',
    addNewIreFactorBathrooms: 'Add New Ire Factor Bathroom',
    addNewIreFactorsOptions: 'Add New Ire Factor Option',
    addNewIreFactorsQualitys: 'Add New Ire Factor Quality',
    addNewIreFactorsLocationSpecs: 'Add New Ire Factor Location Specs',
    addNewIreFactorGeneralspecs: 'Add New Ire Factor General specs',
    addNewIreFactorsPropertyService: 'Add New Ire Factor Propert Service',
    addNewBanner: 'Add New Banner',
    addNewBankRate: 'إنشاء تقييم بنك جديد',
    adminUsersListing: 'قائمة الاعضاء الادمن',
    officesListing: 'قائمة المكاتب',
    auctionsListing: 'قائمة المزادات',
    appraisersUsersListing: 'قائمة الاعضاء المُقيمين',
    appraisersListing: 'قائمة المقيمين',
    usersListing: 'قائمة المستخدمين',
    banksListing: 'قائمة البنوك',
    answersListing: 'قائمة الإجابات',
    bannerList: 'Banner Listing',
    ireAreasListing: 'Ire Areas Listing',
    ireTypesListing: 'Ire Types Listing',
    ireSizesListing: 'Ire Size Listing',
    IreFactorsBathroomsListing: 'Ire Factors Bathroom Listing',
    IreFactorsOptionsListing: 'Ire Factor Options Listing',
    IreFactorsQualitysListing: 'Ire Factor Qualitys Listing',
    IreFactorsGeneralspecsListing: 'Ire Factors General specs Listing',
    ireFactorsLocationSpecsListing: 'Ire Factors Location Specs Listing',
    IreFactorsPropertySeriveListing: 'Ire Factors Property Service Listing',
    streetFactorOptions: 'خيارات عامل الشارع',
    facingFactorOptions: 'خيارات عامل العقار مقابل',
    facingOptionCreating: 'انشاء خيار عقار مقابل',
    facingOptionUpdating: 'تحديث خيار عقار مقابل',
    sabahCityFactorOptions: 'خيارات عامل مدينة صباح',
    sabahCityOptionCreating: 'إنشاء خيار مدينة صباح',
    sabahCityOptionUpdating: 'تحديث خيار مدينة صباح',
    locationFactorOptions: 'خيارات عامل الموقع',
    locationOptionUpdating: 'تحديث خيار الموقع',
    locationOptionCreating: 'إنشاء خيار الموقع',
    curbFactorOptions: 'خيارات عامل الارتداد',
    curbOptionUpdating: 'تحديث خيار الارتداد',
    curbOptionCreating: 'إنشاء خيار الارتداد',
    buildingAgeFactorOptions: 'خيارات عامل عمر البناء',
    buildingAgeOptionUpdating: 'تحديث خيار عمر بناء',
    buildingAgeOptionCreating: 'إنشاء خيار عمر بناء',
    finishingQualityFactorOptions: 'خيارات عامل جودة التشطيب',
    finishingQualityOptionUpdating: 'تحديث خيار جودة التشطيب',
    finishingQualityOptionCreating: 'إنشاء خيار جودة التشطيب',
    floorFactorOptions: 'خيارات عامل الطابق',
    floorOptionsCreating: 'إنشاء خيارات الطابق',
    landingEstimator: 'Land Estimator',
    landingEstimatorClone: 'Land Estimator Clone',
    FactorsBathroomValues: 'Factors Bathroom Values',
    FactorsOptionValues: 'Factors Option Values',
    qualityGroupsLisitng: 'قائمة مجموعات الجودة',
    floorOptionsUpdating: 'تحديث خيارات الطابق',
    seaFrontLenghsFactorOptions: 'خيارات اطوال الواجهة البحرية',
    backStreetLenghsFactorOptions: 'خيارات اطوال الشارع الخلفي',
    seaFrontLengthOptionUpdating: 'تحديث خيار طول الواجهة البحرية',
    streetOptionsUpdating: 'تحديث خيار شارع',
    organizersListing: 'قائمة المنظمين',
    locationsListing: 'قائمة المواقع',
    contactusListing: 'قائمة التواصل  ',
    adTypesListing: 'قائمة الاعلانات',
    propertiesListing: 'قائمة العقارات',
    faqsListing: 'قائمة الاسئلة الشائعة',
    areasListing: 'قائمة المناطق',
    areasIveValuesListing: 'قائمة المناطق',
    areasIveValuesCreating: 'إنشاء منطقة جديدة',
    areasIveValuesUpdating: 'تحديث منطقة',
    finishingqualityEn: 'جودة التشطيب - الانجليزية',
    finishingqualityAr: 'جودة التشطيب - العربية',
    finishingQualityOptionNameArLang: 'خيار جودة التشطيب في اللغة العربية',
    finishingQualityOptionNameEnLang: 'خيار جودة التشطيب في اللغة الانجليزية',
    landSizeFactorOptions: 'خيارات عامل مساحة الارض',
    landSizeOptionsUpdating: 'تحديث خيار مساحة الارض',
    landSizeOptionsCreating: 'انشاء خيار مساحة ارض جديد',
    directionFactorOptions: 'خيارات عامل الاتجاه',
    directionOptionsCreating: 'انشاء خيار اتجاه جديد',
    directionOptionsUpdating: 'تحديث خيار الاتجاه',
    PlotSpecsFactorOptions: 'خيارات عامل قطعة الارض',
    plotSpecsOptionsCreating: 'انشاء موصافات قطعة ارض جديدة',
    rangesFinishingQuality: 'نطاقات جودة التشطيب',
    qualityRangeOptionCreating: 'إنشاء خيار نطاق جودة جديد',
    qualityRangeOptionUpdating: 'تحديث خيار نطاق جودة',
    qualitygroupOptionCreating: 'إنشاء خيار مجموعة جودة',
    GroupsWeightUpdating: 'تحديث وزن المجموعات',
    QuestionsWeightUpdating: 'تحديث وزن الاسئلة',
    aboutUs: 'نبذة عنا',
    about: 'نبذة - (خصوصيه)',
    termsAndConditions: 'الشروط والاحكام',
    propertyTypesListing: 'قائمة انواع العقارات',
    auctionsLocationsListing: 'قائمة مواقع المزادات',
    auctionsDescriptionsListing: 'قائمة وصف المزادات',
    appraisalsRequestsListing: 'قائمة طلبات التقييمات',
    appraisalsRequestsUpdating: 'تحديث طلبات التقييمات',
    adminUsersCreating: 'انشاء ادمن جديد',
    appraisersUsersCreating: 'انشاء مقيم جديد',
    auctionsCreating: 'انشاء مزاد جديد',
    bannerCreating: 'Add Banner Creating',
    auctionsEditing: 'تعديل مزاد',
    appraisersUsersEditing: 'تعديل مقيم',
    banksCreating: 'انشاء بنك جديد',
    answersCreating: 'انشاء اجابة جديدة',
    streetOptionsCreating: 'انشاء خيار شارع جديد',
    organizersCreating: 'انشاء منظم جديد',
    locationsCreating: 'انشاء موقع جديد',
    adTypesCreating: 'انشاء نوع اعلان جديد',
    propertiesCreating: 'انشاء عقار جديد',
    faqsCreating: 'انشاء سؤال شائع جديد',
    faqsUpdating: 'تحديث سؤال شائع',
    propertyTypesCreating: 'انشاء نوع عقار جديد',
    propertyCategoryCreating: 'انشاء فئة عقار جديد',
    propertyTypesUpdating: 'تحديث نوع العقار',
    propertyCategoryUpdating: 'تحديث فئة العقار',
    propertyCategoriesListing: 'قائمة فئات العقارات',
    propertyCategoriesCreating: 'انشاء فئة عقار جديد',
    propertyCategoriesUpdating: 'تحديث فئة العقار',
    locationSpecsFactorOptions: 'خيارات عامل مواصفات الموقع',
    locationSpecsOptionsCreating: 'اضافة خيارات الموقع',
    ireTypesCreating: 'Ire Types Creating',
    ireFactorsbathroomsCreating: 'Ire Factor Bathrooms Creating',
    ireFactorsQualitysCreating: 'Ire Factor Quality Creating ',
    ireFactorsPropertyServiceCreating: 'Ire Factor Property Service Creating',
    locationSpecsOptionsUpdating: 'تعديل خيارات الموقع',
    aboutUsUpdating: 'تحديث نبذة عنا',
    termsAndConditionsUpdating: 'تحديث الشروط والاحكام',
    adminUsersUpdating: 'تحديث الادمن',
    banksUpdating: 'تحديث بنك',
    answersUpdating: 'تحديث اجابة',
    organizersUpdating: 'تحديث منظم',
    locationUpdating: 'تحديث موقع',
    adTypesUpdating: 'تحديث نوع الاعلان',
    areasCreating: 'انشاء منطقة جديدة',
    newsCreating: 'إنشاء خبر جديد',
    newsUpdating: 'تحديث الخبر',
    areasUpdating: 'تحديث منطقة',
    appraisalRequestUpdating: 'تحديث طلب التقييم',
    roleUpdating: 'تحديث الدور',
    rolesListing: 'قائمة الادوار',
    rolesCreating: 'انشاء دور جديد',
    bankRateUpdating: 'تحديث تقييم البنك',
    bankRatesListing: 'قائمة تقييمات البنك',
    bankRateCreating: 'انشاء تقييم بنك',
    bankRatesLogReportsListing: 'bank Rates Log Reports Listing',
    importBankRate: 'Import Bank Rate',
    logReports: 'Log Reports',
    rolesUpdating: 'تحديث الدور',
    propertiesUpdating: 'تحديث العقار',
    ireTypesUpdating: 'Ire Type Updating',
    ireSizesCreating: 'Ire Size Creating',
    ireFactorsOptionsCreating: 'Ire Factors Option Creating',
    ireFactorsGeneralspecsCreating: 'Ire Factors General specs Creating',
    ireFactorsLocationspecsCreating: 'Ire Factors Location specs Creating',
    ireFactorsBathroomCreating: 'Ire Factors Bathroom specs Creating',
    ireSizeUpdating: 'Ire Size Updating',
    ireFactorsbathroomsUpdating: 'Ire Factors Bathrooms Updating',
    ireFactorsPropertyServiceUpdating: 'Ire Factors Property Service Updating',
    ireFactorsOptionssUpdating: 'Ire Factors Options Updating',
    ireFactorGeneralspecsUpdating: 'Ire Factors General specs Updating',
    ireFActorsLocationspecsUpdating: 'Ire Factors Location specs Updating',
    name: 'الاسم',
    roleName: 'إسم الدور',
    roleGroup: 'مجموعة الدور',
    status: 'الحالة',
    actions: 'إجرائات',
    members: 'الاعضاء',
    auctions: 'المزادات',
    appraisals: 'التقييمات',
    ive: 'IVE',
    assets: 'الاصول',
    settings: 'الاعدادات',
    Settings: 'الاعدادات',
    ads: 'الاعلانات',
    active: 'فعال',
    inactive: 'غير فعال',
    mcpAccess: 'MCP',
    confirmEnableMcp:
      'هل تريد السماح لهذا العضو بربط مساعد ذكاء اصطناعي خارجي (MCP)؟',
    confirmDisableMcp: 'هل تريد إلغاء صلاحية MCP لهذا العضو؟',
    MCP_ENABLED: 'تم تفعيل MCP',
    MCP_DISABLED: 'تم إلغاء تفعيل MCP',
    createNewAdmin: 'انشاء ادمن جديد',
    createNewAppraiser: 'انشاء مقيم جديد',
    createNewBank: 'انشاء بنك جديد',
    createNewAnswer: 'انشاء اجابة جديد',
    createNewStreetOption: 'انشاء خيار شارع جديد',
    createNewGroup: 'إنشاء مجموعة جديدة',
    createNewBuildingAgeOption: 'إنشاء خيار عمر بناء جديد',
    createNewFinishingQualityOption: 'إنشاء خيار جودة تشطيب جديد',
    createNewFloorOption: 'إنشاء خيار طابق جديد',
    createNewLandSizeOption: 'انشاء خيار مساحة ارض جديد',
    createNewDirectionOption: 'إنشاء خيار إتجاه جديد',
    createNewSabahCitySpecsOption: 'إنشاء خيار مواصفات مدينة صباح جديد',
    createNewFacingOption: 'إنشاء خيار عقار مقابل جديد',
    createNewPlotSpecsOption: 'انشاء مواصفات قطعة ارض جديدة',
    createNewLocationSpecsOption: 'انشاء خيار موقع جديد',
    createNewOrganizer: 'انشاء منظم جديد',
    createNewLocation: 'انشاء موقع جديد',
    creatNewAdType: 'انشاء نوع اعلان جديد ',
    createNewRole: 'انشاء دور جديد',
    createNewProperty: 'انشاء عقار جديد',
    createNewPropertyCategory: 'انشاء فئة عقار جديدة',
    createNewFaq: 'انشاء سؤال شائع جديد',
    createNewArea: 'انشاء منطقة جديدة',
    createNewIveValue: 'إنشاء منطقة جديدة',
    createNewPropertyType: 'انشاء نوع عقار جديد',
    createNewLocationOption: 'إنشاء خيار موقع جديد',
    createNewCurbOption: 'إنشاء خيار ارتداد جديد',
    createNewQualityRangeOption: 'إنشاء خيار نطاق جودة جديد',
    createNewIreArea: 'Create New Ire Area',
    createNewIreType: 'Create New Ire Type',
    createNewIreSize: 'Create New Ire Size',
    createNewIreFactorBathrooms: 'Create New Ire Factor Bathrooms',
    createNewIreFactorOptions: 'Create New Ire Factor Options',
    createNewIreFactorGeneralspecs: 'Create New Ire Factor General specs',
    createNewIreFactorsLocationspecs: 'Create New Ire Factor Location specs',
    createNewIreFactorsQualitys: 'Create New Ire Factor Quality',
    createNewIreFactorsPropertyService:
      'Create New Ire Factor Property Service',
    createNewBankRate: 'إنشاء تقييم بنك جديد',
    createNewNews: 'إنشاء اخبار جديدة',
    createNewIreStreet: 'انشاء شارع جديد',
    propertyStreet: 'شارع العقار',
    street: 'الشارع',
    fullName: 'الإسم الكامل',
    fullAdminName: 'اسم الادمن الكامل',
    adminEmail: 'البريد الإلكتروني للادمن',
    newPassword: 'كلمة المرور الجديدة',
    verifyPassword: 'تأكيد كلمة المرور',
    discard: 'إلغاء',
    saveChanges: 'حفظ',
    ok: 'موافق',
    yes: 'نعم',
    no: 'لا',
    appraiserName: 'إسم المقيم',
    appraiserEmail: 'البريد الالكترومي لـ المقيم',
    areaName: 'إسم المنطقة',
    price: 'السعر',
    basePrice: 'Base Price',
    attachments: 'المرفقات',
    attachmentsCount: 'يوجد {count} ملف من المرفقات',
    images: 'الصور',
    'Image AR': 'الصوره',
    civilId: 'الهوية المدنية',
    allowedFileTypes: 'Allowed file types: png, jpg, jpeg.',
    documents: 'الوثائق',
    other: 'اخرى',
    appraisalDetails: 'تفاصيل التقييم',
    changeStatus: 'تغيير الحالة',
    applicantName: 'إسم مقدم الطلب',
    applicantEmail: 'البريد الالكتروني لـ مقدم الطلب',
    applicantMobile: 'هاتف مقدم الطلب',
    appraiserMobile: 'هاتف المقيم',
    appraisalPropertyStatus: 'حالة العقار',
    appraisalPropertyTypes: 'نوع العقار',
    remarks: 'ملاحظات',
    additionalDetails: 'تفاصيل اضافية',
    address: 'الموقع',
    bankAppraisal: 'عقار بنكي',
    activeStatus: 'حالة النشاط',
    rejectionNote: 'Rejection Note',
    areaSize: 'المساحة',
    appraisalRequestOverview: 'عرض طلب التقييم',
    selectStatus: 'إختر حالة...',
    selectAuctionStatus: 'Select an Auction Status',
    selectAdsPackage: 'Select an Ads Package',
    selectAdTypes: 'اختر نوع الاعلان',
    SelectScreen: 'اختر الشاشة',
    selectDirection: 'اختر اتجاه',
    selectBannerType: 'select A banner Type',
    selectpropertyStatus: 'Selecte a Property Status',
    selectGroup: 'إختر مجموعة...',
    selectOrganizer: 'إختر منظم...',
    selectPropertyType: 'إختر نوع عقار...',
    selectAuctionLocation: 'إختر موقع المزاد...',
    selectAuctionDescription: 'إختر وصف المزاد...',
    selectRole: 'إختر دور...',
    selectBanks: 'إختر بنوك...',
    selectFactorOptions: 'إختر عامل...',
    selectAreas: 'إختر منطقة...',
    roleGroupTooltip: 'الاذونات المتاحة تختلف من مجموعة الى اخرى',
    clearAll: 'مسح الكل',
    basicInfo: 'معلومات اساسية',
    propertyInfo: 'معلومات الملكية',
    backToList: 'الرجوع الى القائمة',
    appraisalRequestStatus: 'حالة الطلب',
    appraisalStatus0: 'تم استلام الطلب',
    appraisalStatus1: 'قيد المراجعة',
    appraisalStatus2: 'مرفوض من قبل المقيم',
    appraisalStatus3: 'مقبول من مقبل المقيم',
    appraisalStatus4: 'تم تسليم التقرير',
    idColumn: 'S.NO',
    organizerNameAr: 'إسم المنظم - العربية',
    organizerInfo: 'معلومات المنظم',
    bankNameEn: 'إسم البنك - الإنجليزية',
    streetNameEn: 'إسم الشارع - الإنجليزية',
    bankNameAr: 'إسم البنك - العربية',
    streetNameAr: 'إسم الشارع - العربية',
    bankNameEnLang: 'إسم البنك في اللغة الإنجليزية',
    answerEnLang: 'الاجابة في اللغة الإنجليزية',
    streetNameEnLang: 'إسم الشارع في اللغة الإنجليزية',
    venueNameEnLang: 'إسم المكان في اللغة الإنجليزية',
    bankNameArLang: 'إسم البنك في اللغة العربية',
    answerArLang: 'الاجابة في اللغة العربية',
    baseSize: 'Basic Size',
    streetNameArLang: 'إسم الشارع في اللغة العربية',
    organizerNameArLang: 'إسم المنظم في اللغة العربية',
    organizerNameEnLang: 'إسم المنظم في اللغة الإنجليزية',
    venueNameArLang: 'إسم المكان في اللغة العربية',
    adTypeNameEn: 'إسم الاعلان - الإنجليزية',
    adTypeNameAr: 'إسم الاعلان - العربية',
    adTypeNameArLang: 'اسم نوع الاعلان في اللغة العربية',
    adTypeNameEnLang: 'اسم نوع الاعلان في اللغة الانجليزية',
    propertyNameEn: 'إسم العقار - الانجليزية',
    propertyNameAr: 'إسم العقار - العربية',
    propertyTypeNameEn: 'إسم نوع العقار - الانجليزية',
    propertyTypeNameAr: 'إسم نوع العقار - العربية',
    auctionLocationNameEn: 'إسم موقع المزاد - الانجليزية',
    auctionLocationNameAr: 'إسم موقع المزاد - العربية',
    propertCategoryNameEn: 'إسم فئة العقار - الانجليزية',
    propertyCategoryNameAr: 'إسم فئة العقار - العربية',
    propertyNameEnLang: 'إسم العقار في اللغة الانجليزية',
    propertyNameArLang: 'إسم العقار في اللغة العربية',
    landSizeNameEnLang: 'مساحة الارض في اللغة الانجليزية',
    landSizeNameArLang: 'مساحة الارض في اللغة العربية',
    plotSpecsNameEnLang: 'إسم خيار مواصفات قطعة ارض في اللغة الانجليزية',
    plotSpecsNameArLang: 'إسم خيار مواصفات قطعة ارض في اللغة العربية',
    landSizeValue: ' قيمة مساحة الارض',
    plotSpecsNameEn: 'إسم مواصفات قطعة الارض - الانجليزية',
    plotSpecsNameAr: 'إسم مواصفات قطعة الارض - العربية',
    directionNameEn: 'إسم الاتجاه - الانجليزية',
    sabahSeaSpecsNameEn: 'إسم مواصفات مدينة صباح -الانجليزية',
    sabahSeaSpecsNameAr: 'إسم مواصفات مدينة صباح -العربية',
    sabahSeaSpecsNameEnLang: 'إسم مواصفات مدينة صباح في اللغة الانجليزية',
    sabahSeaSpecsNameArLang: 'إسم مواصفات مدينة صباح في اللغة العربية',
    directionCityNameEn: 'إسم الاتجاه - الانجليزية',
    directionNameAr: 'إسم الاتجاه - العربية',
    directionOptionNameArLang: ' اسم خيار الاتجاه في اللغة العربية',
    directionOptionNameEnLang: ' اسم خيار الاتجاه في اللغة الانجليزية',
    buildingAgeValueEn: 'قيمة عمر البناء - الانجليزية',
    buildingAgeValueAr: 'قيمة عمر البناء - العربية',
    buildingAgeOptionValueEnLang: 'قيمة خيار عمر البناء في اللغة الانجليزية',
    quality: 'الجودة',
    buildingAgeOptionValueArLang: 'قيمة خيار عمر البناء في اللغة العربية',
    floorNameEn: 'اسم الطابق - الانجليزية',
    floorNameAr: 'اسم الطابق - العربية',
    floorOptionNameEnLang: 'اسم خيار الطابق في اللغة الانجليزية',
    floorOptionNameArLang: 'اسم خيار الطابق في اللغة العربية',
    seaFrontNameEn: 'إسم الواجهة البحرية - الانجليزية',
    seaFrontNameAr: 'إسم الواجهة البحرية - العربية',
    seaFrontOptionNameArLang: 'إسم خيار الواجهة البحرية في اللغة العربية',
    seaFronOptionNameEnLang: 'إسم خيار الواجهة البحرية في اللغة الانجليزية',
    backStreetNameEn: 'إسم الشارع الخلفي -الانجليزية',
    backStreetNameAr: 'إسم الشارع الخلفي -العربية',
    backStreetOptionNameEnLang: 'إسم خيار الشارع الخلفي في اللغة الانجليزية',
    backStreetOptionNameArLang: 'إسم خيار الشارع الخلفي في اللغة العربية',
    qualityNameEn: 'اسم الجودة - الانجليزية',
    qualityNameAr: 'اسم الجودة - العربية',
    qualityRangeNameOptionArLang: 'اسم خيار نطاق الجودة في اللغة العربية',
    qualityRangeNameOptionEnLang: 'اسم خيار نطاق الجودة في اللغة الانجليزية',
    qualityGroupNameEnLang: 'اسم مجموعة الجودة في اللغة الانجليزية',
    qualityGroupNameArLang: 'اسم المجموعة الجودة في اللغة العربية',
    questionNameEnLang: 'اسم السؤال في اللغة العربية',
    questionNameArLang: 'اسم السؤال في اللغة الانجليزية',
    questionEnLang: 'السؤال في اللغة الانجليزية',
    questionArLang: 'السؤال في اللغة العربية',
    imageUrl: 'رابط الصورة',
    multiplicationFactors: 'Multiplication Factor',
    answerScore: 'نقاط الاجابة',
    locationSpecsNameEn: 'إسم الموقع - الانجليزية',
    locationSpecsNameAr: 'إسم الموقع - العربية',
    locationSpecsOptionNameEnLang:
      'إسم خيار مواصفات الموقع في اللغة الانجليزية',
    locationSpecsOptionNameArLang: 'إسم خيار مواصفات الموقع في اللغة العربية',
    facingNameEn: 'اسم العقار المقابل - الانجليزية',
    facingNameAr: 'اسم العقار المقابل - العربية',
    facingOptionNameEnLang: 'إسم العقار المقابل في اللغة الانجليزية',
    facingOptionNameArLang: 'إسم العقار المقابل في اللغة العربية',
    locationNameEn: 'إسم الموقع - الانجليزية',
    locationNameAr: 'إسم الموقع - العربية',
    locationOptionNameEnLang: 'إسم خيار الموقع في اللغة الانجليزية',
    locationOptionNameArLang: 'إسم خيار الموقع في اللغة العربية',
    curbNameEn: 'إسم الارتداد - الانجليزية',
    curbNameAr: 'إسم الارتداد - العربية',
    curbOptionNameEnLang: 'إسم خيار الارتداد في اللغة الانجليزية',
    curbOptionNameArLang: 'إسم خيار الارتداد في اللغة العربية',
    areaNameEnLang: 'إسم المنطقة في اللغة الإنجليزية',
    areaNameArLang: 'إسم المنطة في اللغة العربية',
    areaNameAr: 'إسم المنطقة - العربية',
    areaNameEn: 'إسم المنطقة - الإنجليزية',
    propertyTypeNameArLang: 'إسم نوع العقار في اللغة العربية',
    propertyTypeNameEnLang: 'إسم نوع العقار في اللغة الانجليزية',
    auctionLocationNameArLang: 'إسم موقع المزاد في اللغة العربية',
    auctionLocationNameEnLang: 'إسم موقع المزاد في اللغة الانجليزية',
    auctionDescriptionNameArLang: 'إسم وصف المزاد في اللغة العربية',
    auctionDescriptionNameEnLang: 'إسم وصف المزاد في اللغة الانجليزية',
    auctionDescription: 'وصف المزاد',
    propertCategoryNameEnLang: 'إسم فئة العقار في اللغة الانجليزية',
    propertCategoryNameArLang: 'إسم فئة العقار في اللغة العربية',
    multiCurb: 'متعدد الارتداد',
    multiSelection: 'اختيار متعدد',
    isSeaView: 'مطل للبحر',
    customUpdatedAt: 'Custom Updated Date',
    pullData: 'Pull Data',
    url: 'URL',
    from: 'من',
    to: 'الى',
    weight: 'Weight',
    arabicName: 'الإسم بالعربية',
    arabicValue: 'القيمة بالعربية',
    englishValue: 'القيمة بالانجليزية',
    arabicSize: 'المساحة بالعربية',
    englishSize: 'المساحة بالانجليزية',
    englishQuestion: 'السؤال بالانجليزية',
    englishAnswer: 'الاجابة بالعربية',
    arabicQuestion: 'السؤال بالعربية',
    arabicAnswer: 'الاجابة بالعربية',
    textInArabic: 'النص بالعربية',
    textInEnglish: 'النص بالانجليزية',
    englishName: 'الإسم بالانجليزية',
    phoneNumber: 'رقم الهاتف',
    ppmNotificationLevel: 'مستوى إشعارات سعر المتر',
    ppmNotificationLevelHint:
      'المستوى الأول يُشعَر فور وجود سعر بانتظار المراجعة. المستوى الثاني يُشعَر فقط إذا بقي بانتظار المراجعة بعد مدة التصعيد.',
    ppmLevelNone: 'غير مُعيّن',
    ppmLevelImmediate: 'المستوى الأول — فوري',
    ppmLevelEscalation: 'المستوى الثاني — تصعيد',
    PHONE_NOT_VALID:
      'رقم الهاتف يجب أن يكون أرقاماً مع رمز الدولة، مثال 96567645991',
    accountType: 'نوع الحساب',
    cancel: 'إلغاء',
    sorting: 'الترتيب',
    role: 'الدور',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    contactPerson: 'اسم جهة الاتصال',
    contactPhone: 'هاتف جهة الاتصال',
    contactPersonName: 'اسم جهة الاتصال',
    contactPersonPhone: 'هاتف جهة الاتصال',
    appraiserPhone: 'هاتف المقيم',
    bankAccountDetails: 'تفاصيل الحساب البنكي',
    appraiserDetails: 'تفاصيل المقيم',
    auctionDetails: 'تفاصيل المزاد',
    appraiserBanks: 'بنوك المقيم',
    appraiserPrices: 'اسعار المقيم',
    auctionProperties: 'عقارات المزاد',
    banks: 'البنوك',
    savingBanksNote: 'حفظ معلومات المقيم مطلوب قبل قيامك باضافة البنوك.',
    savingAuctionAttachmentNote:
      'حفظ معلومات المزاد مطلوب قبل قيامك باضافة الملحقات.',
    savingPricesNote: 'حفظ معلومات المقيم مطلوب قبل قيامك باضافة الاسعار.',
    savingServiceNote:
      'Saving package details is required before proceeding to adding its services.',
    noResultsFound: 'لا يوجد نتائج',
    propertyType: 'نوع العقار',
    auctionLocation: 'موقع المزاد',
    building: 'بناء',
    percentage: 'نسبة مئوية',
    nonCustumerPercentage: 'نسبة غير العملاء',
    land: 'أرض',
    organiserName: 'اسم المنظم',
    date: 'التاريخ',
    time: 'الوقت',
    venue: 'المكان',
    type: 'النوع',
    numberOfProperties: 'عدد الملكيات',
    filterOptions: 'خيارات البحث',
    today: 'اليوم',
    historical: 'تاريخي',
    upcoming: 'القادمة',
    reset: 'إعادة تعيين',
    apply: 'إرسال',
    filter: 'فلتر',
    addNewAuction: 'اضافة مزاد جديد',
    organizer: 'المنظم',
    dateAndTime: 'التاريخ والوقت',
    eventDateAndTime: 'تاريخ ووقت الحدث',
    auctionVideo: 'فيديو للمزاد',
    organizerLogo: 'شعار المنظم',
    logo: 'الشعار',
    location: 'الموقع',
    supplyPercentage: 'نسبة العرض',
    loanRequest: 'طلب قرض',
    certifiedCheckRequest: 'Certified Check Request',
    block: 'الحي',
    size: 'المساحة',
    propertyBlock: 'حي العقار',
    propertyPlot: 'قطعة العقار',
    propertySize: 'مساحة العقار',
    propertyVenue: 'جادة العقار',
    startingPrice: 'سعر مبدئي',
    salePrice: 'سعر البيع',
    salePercentage: 'نسبة البيع',
    additionalInfoEn: 'معلومات اضافية (انجليزية)',
    additionalInfoInEn: 'معلومات اضافية في الانجليزية',
    factorOptionIve: 'قيمة خيار العامل',
    additionalInfoInAr: 'معلومات اضافية في العربية',
    additionalInfoAr: 'معلومات اضافية (انجليزية)',
    startingPricePerSqm: 'السعر المبدئي \\ متر مربع',
    startingPricePerSquareMeter: 'السعر المبدئي لكل متر مربع',
    salePricePerSqm: 'سعر البيع \\ متر مربع',
    salePricePerSquareMeter: 'سعر البيع لكل متر مربع',
    propertyStatus: 'حالة العقار',
    area: 'المنطقة',
    plot: 'قطعة',
    percentagePremiumPaid: 'Premium % Paid',
    propertyAttachments: 'مرفقات العقار',
    auctionAttachments: 'مرفقات المزاد',
    video: 'فيديو',
    updateCceGroup: 'تحديث مجموعة حسبة البناء',
    createNewCceGroup: 'انشاء مجموعة حسبة البناء',
    addNewCceGroup: 'اضافة مجموعة جديد',
    CceGroupsList: 'قائمة مجموعات حسبة تكلفة البناء',
    titleAr: 'العنوان بالعربي',
    titleEn: 'العنوان بالانجليزي',
    cceGroupsUpdating: 'تحديث مجوعات حسبة البناء',
    cce: 'حسبة البناء',
    updateCceCategorie: 'تحديث فئة حسبة البناء',
    createNewCceCategorie: 'انشاء فئة حسبة البناء',
    addNewCceCategorie: 'اضافة فئة جديد',
    CceCategorieList: 'قائمة فئات حسبة تكلفة البناء',
    isDependQuality: ' تعتمد الجودة',
    savingSubCategoryOptionsNote:
      'حفظ معلومات الفئة مطلوب قبل قيامك باضافة التفاصيل.',
    cceCategory: 'فئة حسبة البناء',
    cceCategoryTooltip: 'فئات حسبة البناء',
    selectCceCategory: 'اختر الفئة',
    multiplier: 'المضاعف',
    defaultPrice: 'السعر الافتراضي',
    sort: 'الترتيب',
    subCategoriesOptions: 'الفئات الفرعية',
    CceSubCategoriesList: 'قائمة الفئات الفرعية',
    updateCceSubCategorie: 'تحديث فئة فرعية جديدة',
    addNewCceSubCategorie: 'إضافة فئة فرعية جديدة',
    categoryName: 'اسم الفئة',
    SUCCESSFULLY_CREATED_CCE_GROUP: 'تم إنشاء مجموعة بنجاح',
    cceGroupsCreating: 'انشاء مجموعة جديد',
    SUCCESSFULLY_UPDATED_CCE_GROUP: 'تم تحديث المجموعة بنجاح!',
    cceGroupsListing: 'قائمة مجموعة حسبة البناء',
    cceGroup: 'CCE Group',
    cceGroupTooltip: 'CCE Group Tooltip',
    selectCceGroup: 'Select Cce Group',
    SUCCESSFULLY_CREATED_CCE_CATEGORIE: 'Successfully created a CCE Categorie!',
    cceCategoriesCreating: 'CCE Categories Creating',
    cceCategoriesUpdating: 'CCE Categories Updating',
    SUCCESSFULLY_UPDATED_CCE_CATEGORIE: 'Successfully updated a CCE Categorie!',
    CceCategoriesList: 'CCE Categories List',
    cceCategoriesListing: 'CCE Categories Listing',
    groupName: 'Group Name',
    RegisteredTrades: 'الصفقات المسجلة',
    createNewRegisteredTrades: 'انشاء صفقات المسجلة',
    updateRegisteredTrades: 'تحديث الصفقات المسجلة',
    RegisteredListing: 'قائمة الصفقات المسجلة',
    pricePerM2: 'السعر لكل متر',
    notes: 'ملاحظات',
    noteAr: 'ملاحظة بالعربية',
    noteEn: 'ملاحظة بالانجليزية',
    transactionDate: 'تاريخ الصفقة',
    RegisteredTradesScraping: 'قائمة الصفقات المسجلة (موقع الوزارة)',
    transactionNumber: 'رقم المعاملة',
    areas: 'المناطق',
    RegisteredTradesListing: 'Registered Trades Listing',
    descriptionAr: 'Description Arabic',
    descriptionEn: 'Description English',
    notesAr: 'Notes Arabic',
    notesEn: 'Notes English',
    registeredTradesUpdating: 'Registered Trades Updating',
    TRANSACTION_NUMBER_IS_REQUIRED_FIELD:
      'Transaction number is required field',
    SIZE_IS_REQUIRED_FIELD: 'Size is required field',
    PRICE_IS_REQUIRED_FIELD: 'Price is required field',
    PRICE_PER_M2_IS_REQUIRED_FIELD: 'Price per m2 is required field',
    PROPERTY_TYPE_IS_REQUIRED_FIELD: 'Property type is required field',
    AUCTION_LOCATION_IS_REQUIRED_FIELD: 'Auction location is required field',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE:
      'Successfully updated registered trade',
    SUCCESSFULLY_CREATED_REGISTERED_TRADE:
      'sSuccessfully created registered trade',
    pulleRegisteredTradesScraping: 'Pull Registered Trades Scraping',
    selectDate: 'Select Date',
    SUCCESSFULLY_PULL_REGISTERED_TRADE_SCRAPING:
      'Successfully pull registered trade scraping',
    SUCCESSFULLY_UPDATED_REGISTERED_TRADE_SCRAPING:
      'Successfully updated registered trade scraping',
    SUCCESSFULLY_UPDATED_LOAN_FUNDS_REQUEST:
      'Successfully updated loan fund request',
    SUCCESSFULLY_UPDATED_AD_SERVICE: 'Successfully updated ad service',
    SUCCESSFULLY_UPDATED_HEADER_DESCRIPTION:
      'Successfully updated header description',
    SUCCESSFULLY_UPDATED_DISCLAIMER_DESCRIPTION:
      'Successfully updated disclaimer description',
    SUCCESSFULLY_ACTIVEATED: 'Successfully Activated',
    SUCCESSFULLY_INACTIVATED: 'Successfully Inactivated',
    id: 'S.NO',
    publishName: 'Publish Name',
    publishMobile: 'Publish Mobile',
    adsType: 'Ads Type',
    publishedAt: 'Published At',
    blogPublishedAtHint:
      'يُعبّأ من الرابط إذا كان فيه تاريخ نشر، ويمكنك تعديله. إذا تُرك فارغاً عند الإضافة يُستخدم وقت الحفظ.',
    isPaid: 'Paid',
    attachmentImages: 'Ads Images',
    attachmentVideos: 'Ads Video',
    attachmentVideosAuction: 'Auction Video',
    docAttachment: 'Ads Documents',
    adsDetails: 'Ads Details',
    adOverview: 'Ad Overview',
    changeAdsRequestStatus: 'Change Ads Status',
    adsUpdating: 'Ads Updating',
    SUCCESSFULLY_UPDATED_ADS_REQUEST: 'Successfully Updated Ads Status',
    venueEn: 'إسم المكان - الانجليزية',
    venueAr: 'إسم المكان - العربية',
    coordinates: 'إحداثيات',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    LATITUDE_IS_REQUIRED_FIELD: 'حقل خط العرض بالانجليزية مطلوب',
    LONGITUDE_IS_REQUIRED_FIELD: 'حقل خط الطول بالانجليزية مطلوب',
    organizerPhone: 'رقم هاتف المنظم',
    phone: 'الهاتف',
    createdAt: 'أنشئت في',
    updatedAt: 'تحدثت في',
    LoansFundsRequest: 'Loans Funds Request',
    loanFundsRequestOverview: 'Loans Funds Request Overview',
    propertyValue: 'Property Value',
    loanDuration: 'Loan Duration',
    annualProfit: 'AnnualProfit',
    totalPurchasePrice: 'Total Purchase Price',
    bankProfit: 'Bank Profit',
    downPayment: 'Down Payment',
    gracePeriod: 'فترة السماح',
    loanFundRequestOverview: 'Loan Fund Request Overview',
    loanAmount: 'Loan Amount',
    repaymentPeriod: 'فترة السداد',
    nonBoubyanCustomer: 'عميل لغير بوبيان',
    boubyanCustomer: 'عميل بوبيان',
    priceFrom: 'Price From',
    priceTo: 'Price To',
    residentials: 'خاص',
    commercial: 'تجاري',
    propertySoldStatus: 'Property Sold Status',
    adsServices: 'Ads Services',
    arabicTitle: 'العنوان بالعربية',
    englishTitle: 'العنوان بالانجليزية',
    arabicDescription: 'الوصف بالانجليزية',
    englishDescription: 'الوصف بالانجليزية',
    createNewAdService: 'Create new Ads Service',
    adsDuration: 'Ads Duration',
    adsDurationDay: 'Ads duration (days)',
    adServiceTitleArlang: 'Ads service title-Arabic ',
    adServiceTitleEnlang: 'Ads service title - English',
    adsServiceUpdating: 'Update Ads Service',
    subscriptions: 'Subscriptions',
    adsServiceCreating: 'Ad service Creating',
    adPackageAdsCreating: 'Package Ad Creating',
    adPackagesDetails: 'Package Details',
    adPackageTitleAr: 'Package Title in Arabic Language',
    adPackageTitleEn: 'Package Title in English Language',
    adsPackagesUpdating: 'Update Ads Package',
    bannerUpdating: 'Banner Updating',
    adsPackages: 'Ads Packages',
    newsListing: 'قائمة الاخبار',
    createNewAdPackage: 'Create New Ads Package',
    packageServices: 'Package Services',
    instantValueEstimatorPanel: 'لوحة مقدر القيمة الفورية',
    instantValueCloningPanel: 'لوحة نسخ القيمة الفورية',
    ValueSizePanel: ' Value Size Panel',
    ValueFactorBathroomPanel: ' Value Factor Bathroom Panel',
    ValueFactorOptionPanel: ' Value Factor Option Panel',
    ValueFactorGeneralspecsPanel: ' Value Factor General specs Panel',
    ValueFactorLocationspecsPanel: ' Value Factor Location specs Panel',
    ValueFactorQualityPanel: ' Value Factor Quality Panel',
    convertOfficeToIndividual: 'Convert Office To Individual',
    qualityGroupsPanel: 'لوحة مجموعات الجودة',
    factors: 'عوامل',
    totalValues: 'عدد القيم',
    factorOption: 'خيار العوامل',
    value: 'القيمة',
    note: 'ملاحظة',
    noFactorOptionsLeft: 'لا يوجد خيارات متاحة لهذا العامل ليتم اضافتها',
    addNewValue: 'أضف قيمة جديدة',
    addNewQuestion: 'اضافة سؤال جديد',
    bannerLocation: 'Banner Location',
    bannerAction: 'Banner Action',
    externalLink: 'External Link',
    bannerType: 'Banner Type',
    merchant: 'Merchant',
    entityId: 'Entity ID',
    bannerUrl: 'Banner URL',
    bannerImage: 'Banner Image',
    bannerInfo: 'Banner Info',
    auctionStatus: 'Auction Status',
    PHONE_MIN_8: 'minimum length is 8 Number',
    PHONE_MAX_11: 'maximum length is 11 Number',
    areaCompare: 'مقارنة المناطق',
    areaClone: 'نسخ المنطقة',
    startComparingAreas: 'بدء مقارنة مناطق',
    currentVideoUrl: 'رابط الفيديو الحالي',
    score: 'مجموع النقاط',
    appartmentSize: 'Appartment Size',
    Generalspecs: 'General specs Values',
    Locationspecs: 'Location specs Values',
    propertyService: 'Property Service Values',
    ireSizesValues: 'Ire Sizes Values',
    selected: 'مختارة',
    approveSelected: 'موافقة المختارة',
    freeAd: 'Standard AD',
    paidAd: 'Paid AD',
    adOptions: 'Ad Options',
    anotherCompare: 'Another Compare',
    setAsDefault: 'Set As Default',
    numRooms: 'Number of Room',
    numBathrooms: 'Number of Bathrooms',
    adsPackagesTitle: 'Ad Package',
    additionalInfo: 'Additional Info',
    exportIveArea: 'Export Ive Area',
    approveAllAds: 'Approve All Ads',
    headerDescription: 'Header Description',
    headerDescriptionUpdating: 'Header Description Updating',
    disclaimer: 'Disclaimer',
    disclaimerUpdating: 'Disclaimer Updating',
    adminAccess: 'Admin access',
    actionDescription: 'Action description',
    timeStamp: 'Time stamp',
    exportLogsReports: 'Export Logs Reports',
    bulkUpdate: 'تحديث متعدد',
    deactivate: 'تعطيل',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    success: 'نجاح',
    failed: 'فشل',
    selectAction: 'Select a Action',
    expiryBanner: 'Expiry Banner',
    enableGracePeriod: 'تفعيل فترة السماح',
    disableGracePeriod: 'تعطيل فترة السماح',
    isRegisteredTrades: 'الصفقات المسجلة',
    isAd: 'الاعلانات',
    isAuction: 'المزادات',
    SUCCESSFULLY_UPDATED_PROPERTY_CATEGORY: 'تم تحديث فئة العقار بنجاح',
    SUCCESSFULLY_CREATED_PROPERTY_CATEGORY: 'تم انشاء فئة العقار بنجاح',
    selectPropertyCategory: 'اختر فئة العقار',
    propertyCategory: 'فئة العقار',
    PROPERTY_CATEGORY_IS_REQUIRED_FIELD: 'فئة العقار مطلوب',
    SUCCESSFULLY_ADDED_IRE_SIZE_OPTIONS: 'تم اضافة خيارات ابعاد العقار بنجاح',
    savingIreAvailableSizesNote: 'حفظ ملاحظات ابعاد العقار',
    isBaseSize: 'ابعاد اساسي',
    IrePropertyAge: 'عمر العقار',
    savingIreAvailablePropertyAgeNote: 'حفظ ملاحظات عمر العقار',
    ireAreasCreating: 'انشاء مناطق العقار',
    areasIreValuesUpdating: 'تحديث قيم مناطق العقار',
    updateIreAreaValue: 'تحديث قيمة منطقة العقار',
    IreAvailableSizes: 'ابعاد العقار',
    MUST_ADDED_IRE_BASE_SIZE_OPTIONS: 'يرجى اختيار مساحة اساسية',
    ONE_IRE_BASE_SIZE_OPTIONS: 'يرجى اختيار مساحة اساسية واحدة فقط',
    UserInfo: 'معلومات المستخدم',
    firstIncreasePercentage: 'First Increase Percentage',
    firstIncreasePercentageToolTip:
      'First Increase Percentage For GOOD Quality',
    secondIncreasePercentage: 'Second Increase Percentage',
    secondIncreasePercentageToolTip:
      'Second Increase Percentage For VERY GOOD Quality',
    decreasedPercentage: ' Decreased Percentage',
    SUCCESSFULLY_CREATED: 'Successfully Created',
    SUCCESSFULLY_UPDATED: 'Successfully Updated',
    updateIreQualities: 'Update Ire Qualities',
    ireQualitiesListing: 'Ire Qualities Listing',
    irePropertyTypeListing: 'ire Property Type Listing',
    updateIrePropertyType: 'update Ire Property Type',
    ireInvestmentPropertyAgeListing: 'ire Property Age',
    updateIrePropertyAge: 'update Ire Property Age',
    ireLocationsListing: 'ire Locations Listing',
    updateIreLocations: 'update Ire Locations',
    ireInvestmentConfigListing: 'Ire Investment Config Listing',
    updateIreInvestmentConfig: 'update Ire Investment Config',
    PERCENTAGE_IS_REQUIRED_FIELD: 'Percentage is required',
    NumOfRegisteredTrades: 'Number Of Registered Trades : ',
    askSeller: 'Ask Seller',
    priceNotAvailable: 'Price Not Available',
    adDetails: 'Ad Details',
    addNewAds: 'Create New Ad',
    AdInfo: 'Ad Information',
    AD_TYPE__IS_REQUIRED_FIELD: 'Ad Type Is Required Field',
    PUBLISH_NAME_IS_REQUIRED_FIELD: 'Publish Name Is Required Field',
    PACKAGE_IS_REQUIRED_FIELD: 'Package Is Required Field',
    adImagesAttachments: 'Ad Images',
    savingAdAttachmentNote: 'Saving Ad Attachment After Craete Ad',
    adVideoAttachments: 'Ad Video',
    adDocAttachments: 'Ad Document',
    adsUpdate: 'Ad Service Update',
    SUCCESSFULLY_UPDATED_AD: 'Successfully Updated Ad',
    SUCCESSFULLY_UPLOADED_AD_IMAGES: 'Successfully Upload Ad Images',
    SUCCESSFULLY_UPLOADED_AD_VIDEO: 'Successfully Upload Ad Video',
    SUCCESSFULLY_UPLOADED_AD_DOC: 'Successfully Upload Ad Document',
    SUCCESSFULLY_REMOVE_AD_IMAGE: 'Successfully Remove Ad Image',
    updateAd: 'Update Ad',
    baseValue: 'Base Value',
    thirdDecreasedPercentage: 'Third Decreased Percentage',
    fourthDecreasedPercentage: 'Fourth Decreased Percentage',
    thirdDecreasedPercentageToolTip: 'Third Percent',
    fourthDecreasedPercentageToolTip: 'Fourth Percent',
    selectePropertyCategory: 'اختر فئة العقار',
    FIRST_DESC_IS_REQUIRED_FIELD: 'First Decreased Is Required Field',
    SECOND_DESC_IS_REQUIRED_FIELD: 'Second Decreased Is Required Field',
    THIRD_DESC_IS_REQUIRED_FIELD: 'Third Decreased Is Required Field',
    FOURTH_DESC_IS_REQUIRED_FIELD: 'Fourth Decreased Is Required Field',
    FIRST_BASE_VAL_IS_REQUIRED_FIELD: 'First Base Value Is Required Field',
    SECOND_BASE_VAL_IS_REQUIRED_FIELD: 'Second Base Value Is Required Field',
    THIRD_BASE_VAL_IS_REQUIRED_FIELD: 'Third Base Value Is Required Field',
    FOURTH_BASE_VAL_IS_REQUIRED_FIELD: 'Fourth Base Value Is Required Field',
    firstBaseValue: 'First Base Value',
    secondBaseValue: 'Second Base Value',
    thirdBaseValue: 'Third Base Value',
    fourthBaseValue: 'Fourth Base Value',
    sizeQualityConfig: 'Size Quality Config',
    LeadID: 'Lead Id *From BBYN',
    isSent: 'Sent To BBYN',
    FinanceFundsRequest: 'Finance Funds Requests',
    financesFundsRequest: 'Finance Funds Requests',
    financeFundsRequestOverview: 'finance Funds Request Overview',
    siteUrl: 'Alhisba Site URL',
    resStatus: 'response Status *From BBYN',
    resStatusText: 'response Status Text *From BBYN',
    leadCode: 'lead Code *From BBYN',
    UnSelectAreas: 'المناطق المستثناة',
    areasIncludePrecedenceWarning:
      'عند تحديد المناطق، سيتم تجاهل المناطق المستبعدة',
    registeredTradesTopAreasReports: 'Trades Top Areas Reports',
    registeredTradesReports: 'Registered Trades Reports',
    AdsPerQuarterReports: 'Ads Per Quarter Reports',
    registeredTradesTopsReports: 'Registered Trades Tops Reports',
    NumOfLowestRegisteredTrades: 'Num Of Lowest Trades',
    NumOfTopRegisteredTrades: 'Num Of Top Trades',
    registeredTradesPerQuarterReports: 'Registered Trades Per Quarter Reports',
    RegisteredTradesTotalsReports: 'Registered Trades Gov Totals Reports',
    auctionsReport: 'تقرير المزادات',
    auctionPropertiesReport: 'تقرير عقارات المزادات',
    activeAdsSummaryReport: 'تقرير عدد الإعلانات النشطة',
    minPrice: 'أقل سعر',
    maxPrice: 'أعلى سعر',
    total: 'الإجمالي',
    adType: 'نوع الإعلان',
    selectArea: 'إختر منطقة',
    dateFrom: 'التاريخ من',
    dateTo: 'التاريخ إلى',
    resultsPreview: 'معاينة النتائج',
    resetFilters: 'إعادة تعيين الفلاتر',
    NumOfData: 'عدد النتائج',
    propertyCategories: 'الفئات',
    selectPropertyCategories: 'اختر الفئات',
    organizers: 'المنظمين',
    selectOrganizers: 'اختر المنظمين',
    onlyFullySold: '100% مباع فقط',
    excludeAreas: 'استثناء مناطق',
    selectExcludeAreas: 'اختر مناطق للاستثناء',
    excludeTypes: 'استثناء أنواع العقار',
    selectExcludeTypes: 'اختر أنواع للاستثناء',
    excludeCategories: 'استثناء فئات العقار',
    selectExcludeCategories: 'اختر فئات للاستثناء',
    dateRangeRequired: 'التاريخ من و التاريخ إلى مطلوبين',
    dateToMustBeAfterDateFrom: 'تاريخ النهاية يجب أن يكون بعد تاريخ البداية',
    noDataFound: 'لا توجد بيانات',
    SUCCESSFULLY_GET_REPORTS_DATA: 'تم جلب بيانات التقرير بنجاح',
    pullRegisteredTrades: 'Pull Registered Trades',
    importRegisteredTrades: 'Import Registered Trades',
    SUCCESSFULLY_UPLOAD_REGISTERED_TRADE:
      'Successfully Upload Registered Trades',
    rejectSelected: 'reject Selected',
    accountStatus: 'حالة الحساب',
    verificationStatus: 'حالة التحقق',
    officeType: 'نوع المكتب',
    individualAccount: 'حساب فردي',
    businessAccount: 'حساب تجاري',
    officeOverview: 'نظرة عامة على المكتب',
    officeDetails: 'تفاصيل المكتب',
    statusInfo: 'معلومات الحالة',
    componentType: 'Component Type',
    selectComponentType: 'Select Component Type',
    dropdown: 'Dropdown',
    list: 'List',
    checkbox: 'Checkbox',
    companyName: 'اسم الشركة',
    website: 'الموقع الالكتروني',
    facebook: 'فيسبوك',
    whatsapp: 'واتساب',
    instagram: 'انستغرام',
    twitter: 'تويتر',
    registrationNumber: ' رقم التسجيل',
    registrationExpiryDate: 'تاريخ انتهاء التسجيل',
    mapUrl: 'رابط الخريطة',
    officesCreating: 'إنشاء مكاتب',
    officesUpdating: 'تحديث المكاتب',
    updateOffice: 'تحديث المكتب',
    employees: 'الموظفين',
    noEmployeesFound: 'لا يوجد موظفين',
    mediaInfo: 'معلومات الوسائط',
    registrationReasonsListing: 'Registration Reasons Listing',
    updateRegistrationReasons: 'Update Registration Reasons',
    registrationReasonsCreating: 'Registration Reasons Creating',
    addNewRegistrationReason: 'Add New Registration Reasons',
    createNewRegistrationReason: 'Create New Registration Reason',
    registrationReasonNameArLang: 'Registration Reason Name - Arabic',
    registrationReasonNameEnLang: 'Registration Reason Name - English',
    typeOfIndex: 'Type of Index',
    selectTypeOfIndex: 'Select Type of Index',
    isPriceIndex: 'توفر مؤشر السعر',
    isVolumeIndex: 'توفر مؤشر الحجم',
    priceIndexDateRangeListing: 'قائمة النطاقات الزمنية لمؤشر السعر',
    startYear: 'سنة البداية',
    endYear: 'سنة النهاية',
    supportedIntervals: 'الفترات الزمنية المدعومة',
    selectViewType: 'اختر نوع العرض',
    addNewPriceIndexDateRange: 'إضافة نطاق زمني جديد',
    priceIndexDateRangeCreating: 'إنشاء نطاق زمني لمؤشر السعر',
    createNewPriceIndexDateRange: 'إنشاء نطاق زمني جديد لمؤشر السعر',
    priceIndexDateRangeUpdating: 'تعديل نطاق زمني لمؤشر السعر',
    updatePriceIndexDateRange: 'تعديل النطاق الزمني لمؤشر السعر',
    SUCCESSFULLY_CREATED_PRICE_INDEX_DATE_RANGE:
      'تم إنشاء النطاق الزمني لمؤشر السعر بنجاح',
    SUCCESSFULLY_UPDATED_PRICE_INDEX_DATE_RANGE:
      'تم تعديل النطاق الزمني لمؤشر السعر بنجاح',
    SUPPORTED_INTERVALS_IS_REQUIRED_FIELD:
      'يجب اختيار فترة زمنية واحدة على الأقل',
    START_YEAR_IS_REQUIRED_FIELD: 'حقل سنة البداية مطلوب',
    END_YEAR_IS_REQUIRED_FIELD: 'حقل سنة النهاية مطلوب',
    typeId: 'نوع المؤشر',
    selectIndexType: 'اختر نوع المؤشر',
    TYPE_ID_IS_REQUIRED_FIELD: 'حقل نوع المؤشر مطلوب',
    rangeLabel: 'تسمية النطاق',
    currentYear: 'السنة الحالية',
    LABEL_IS_REQUIRED_FIELD: 'حقل التسمية مطلوب',
    TITLE_AR_IS_REQUIRED_FIELD: 'حقل العنوان بالعربي مطلوب',
    TITLE_EN_IS_REQUIRED_FIELD: 'حقل العنوان بالانجليزي مطلوب',
    isDefault: 'الخيار الرئيسي',
    methodology: 'المنهجية',
    methodologyListing: 'قائمة المنهجية',
    priceIndexMethodology: 'منهجية مؤشر الأسعار',
    volumeIndexMethodology: 'منهجية مؤشر حجم الصفقات',
    detailedMethodologyPrice: 'المنهجية التفصيلية - مؤشر الأسعار',
    detailedMethodologyVolume: 'المنهجية التفصيلية - مؤشر حجم الصفقات',
    methodologyUpdating: 'تحديث المنهجية',
    updateMethodology: 'تحديث المنهجية',
    updateMethodologyContent: 'تحديث محتوى المنهجية - الجوال',
    updateMethodologyContentWeb: 'تحديث محتوى المنهجية - الموقع',
    methodologyContentUpdating: 'تحديث محتوى المنهجية',
    lastUpdated: 'آخر تحديث',
    SUCCESSFULLY_UPDATED_METHODOLOGY: 'تم تحديث المنهجية بنجاح',
    SUCCESSFULLY_UPDATED_METHODOLOGY_CONTENT: 'تم تحديث محتوى المنهجية بنجاح',
    FAILED_TO_FETCH_METHODOLOGY: 'فشل في جلب بيانات المنهجية',
    slug: 'المعرف',
    indicesPropertyCategoriesListing: 'قائمة فئات العقارات للمؤشرات',
    addNewIndicesPropertyCategory: 'إضافة فئة عقار جديدة',
    indicesPropertyCategoryCreating: 'إنشاء فئة عقار للمؤشرات',
    createNewIndicesPropertyCategory: 'إنشاء فئة عقار جديدة',
    indicesPropertyCategoryUpdating: 'تعديل فئة عقار للمؤشرات',
    updateIndicesPropertyCategory: 'تعديل فئة العقار',
    disablePriceAreas: 'تعطيل أحياء مؤشر السعر',
    disablePriceAreasHint: 'إخفاء أحياء مؤشر السعر لهذه الفئة',
    disableVolumeAreas: 'تعطيل أحياء مؤشر الحجم',
    disableVolumeAreasHint: 'إخفاء أحياء مؤشر الحجم لهذه الفئة',
    volumeIndexTicker: 'شريط مؤشر الحجم',
    volumeIndexTickerHint: 'إظهار هذه الفئة في شريط مؤشر الحجم',
    SUCCESSFULLY_CREATED_INDICES_PROPERTY_CATEGORY: 'تم إنشاء فئة العقار بنجاح',
    SUCCESSFULLY_UPDATED_INDICES_PROPERTY_CATEGORY: 'تم تعديل فئة العقار بنجاح',
    appViews: 'عروض التطبيق',
    appViewsHint:
      'اختر الرسوم البيانية للمؤشرات التي تظهر في التطبيق لهذه الفئة',
    priceIndexView: 'عرض مؤشر الأسعار',
    volumeIndexView: 'عرض مؤشر الحجم',
    ppmView: 'عرض سعر المتر',
    noOfDealsView: 'عرض عدد الصفقات',
    isActive: 'فعال',
    indicesPropertyCategoryActiveHint: 'إظهار هذه الفئة في التطبيق',
    indicesPropertyCategorySlugHint:
      'اتركه فارغاً لإنشائه من العنوان الإنجليزي',
    SUCCESSFULLY_UPDATED_VIEW_FLAG: 'تم تحديث إعداد العرض',
    'Auto Sync Pipeline': 'المزامنة التلقائية',
    autoSyncPipeline: 'المزامنة التلقائية',
    autoSyncPipelineDescription:
      'يشغّل المزامنة التلقائية كمهمة في الخلفية، وتستمر المزامنة بعد بدء المهمة.',
    runSync: 'تشغيل المزامنة',
    confirmRunAutoSync: 'سيتم تشغيل المزامنة التلقائية الآن.',
    autoSyncStarted: 'بدأت مهمة المزامنة التلقائية',
    autoSyncLastTask: 'آخر مهمة تم تشغيلها',
    Notification: 'الإشعارات',
    'Send Notification': 'إرسال إشعار',
    sendNotification: 'إرسال إشعار',
    deeplinkNoPermission: 'ليس لديك صلاحية لإرسال الإشعارات.',
    deeplinkLoadDestinationsFailed: 'تعذّر تحميل أنواع الإشعارات.',
    deeplinkRetry: 'إعادة المحاولة',
    deeplinkSectionDestination: 'الوجهة',
    deeplinkType: 'نوع الإشعار',
    deeplinkSelectType: 'اختر نوع الإشعار',
    deeplinkNoParams: 'هذه الشاشة لا تحتاج حقولاً إضافية، فقط اللغة.',
    deeplinkLang: 'اللغة',
    deeplinkLangAr: 'العربية (ar)',
    deeplinkLangEn: 'الإنجليزية (en)',
    deeplinkLink: 'الرابط العميق',
    deeplinkCopy: 'نسخ',
    deeplinkCopied: 'تم النسخ',
    deeplinkClear: 'مسح',
    bannerDeeplinkTitle: 'بانر برابط عميق',
    bannerDeeplinkEnable: 'استخدام رابط عميق (الطريقة الجديدة)',
    bannerDeeplinkHint:
      'اختياري. عند التفعيل، الضغط على البانر يفتح هذه الشاشة في التطبيق.',
    bannerDeeplinkScreen: 'الشاشة المراد فتحها',
    bannerDeeplinkNoPermission: 'ليس لديك صلاحية لإضافة رابط عميق للبانرات.',
    deeplinkAdvanced: 'متقدم: لصق رابط',
    deeplinkPasteLink: 'الصق الرابط كاملاً',
    deeplinkAdvancedHint: 'يتحقق الخادم من الرابط قبل الإرسال.',
    deeplinkCustomLink: 'رابط مخصص',
    deeplinkSelectPlaceholder: 'اختر',
    deeplinkSelectMany: 'اختر واحداً أو أكثر',
    deeplinkDatePlaceholder: 'اختر التاريخ',
    deeplinkMonthPlaceholder: 'اختر الشهر',
    deeplinkAuctionPlaceholder: 'اختر مزاداً أو اكتب رقمه',
    deeplinkCceHint:
      'اتركه فارغاً لفتح نموذج حاسبة تكلفة البناء، أو أدخل الرقم لفتح نتيجة محفوظة.',
    deeplinkParam_id: 'الرقم',
    deeplinkParam_adType: 'نوع الإعلان',
    deeplinkParam_area: 'المنطقة',
    deeplinkParam_category: 'الفئة',
    deeplinkParam_eventId: 'رقم الحدث',
    deeplinkParam_type: 'النوع',
    deeplinkParam_dateFrom: 'من تاريخ',
    deeplinkParam_dateTo: 'إلى تاريخ',
    deeplinkParam_date: 'الشهر',
    deeplinkParam_index_date: 'الربع',
    deeplinkParam_interval: 'الفترة',
    deeplinkParam_view: 'طريقة العرض',
    deeplinkParam_packageType: 'نوع الباقة',
    deeplinkParam_ads_id: 'رقم الإعلان',
    deeplinkParam_auction_id: 'المزاد',
    'deeplinkParam_auction-property_id': 'رقم العقار',
    deeplinkParam_cce_id: 'رقم النتيجة',
    deeplinkParam_ive_id: 'رمز النتيجة',
    'deeplinkParam_ive-form_type': 'نوع العقار',
    deeplinkParam_index_type: 'نوع المؤشر',
    deeplinkParam_broker_id: 'رقم الوسيط',
    deeplinkParam_deals_area: 'المناطق',
    deeplinkOpt_land: 'أرض',
    deeplinkOpt_building: 'مبنى',
    deeplinkOpt_monthly: 'شهري',
    deeplinkOpt_quarterly: 'ربع سنوي',
    deeplinkOpt_yearly: 'سنوي',
    deeplinkOpt_chart: 'رسم بياني',
    deeplinkOpt_table: 'جدول',
    'deeplinkOpt_volume-index': 'مؤشر الحجم',
    'deeplinkOpt_price-index': 'مؤشر الأسعار',
    'deeplinkOpt_total-transactions': 'إجمالي الصفقات',
    'deeplinkOpt_price-per-meter': 'سعر المتر',
    deeplinkOpt_1: 'الربع الأول',
    deeplinkOpt_2: 'الربع الثاني',
    deeplinkOpt_3: 'الربع الثالث',
    deeplinkOpt_4: 'الربع الرابع',
    deeplinkOpt_ive: 'التقييم الفوري',
    deeplinkOpt_ads: 'الإعلانات',
    deeplinkOpt_auctions: 'المزادات',
    deeplinkOpt_trades: 'الصفقات',
    deeplinkOpt_chatbot: 'المساعد الذكي',
    deeplinkOpt_enterprise: 'الشركات',
    deeplinkSelectFirst: 'اختر {field} أولاً',
    deeplinkSectionMessage: 'نص الإشعار',
    deeplinkTitleAr: 'العنوان (عربي)',
    deeplinkTitleEn: 'العنوان (إنجليزي)',
    deeplinkBodyAr: 'النص (عربي)',
    deeplinkBodyEn: 'النص (إنجليزي)',
    deeplinkImageUrl: 'رابط الصورة',
    deeplinkImageHint:
      'اختياري، ويجب أن يبدأ بـ https://. إذا تُرك فارغاً يُستخدم شعار الحسبة.',
    deeplinkPreview: 'المعاينة',
    deeplinkPreviewArabic: 'العربية',
    deeplinkPreviewEnglish: 'الإنجليزية',
    deeplinkPreviewTitle: 'عنوان الإشعار',
    deeplinkPreviewBody: 'نص الإشعار',
    deeplinkNow: 'الآن',
    deeplinkSectionAudience: 'المستلمون',
    deeplinkAudienceMembers: 'مستخدمون محددون',
    deeplinkAudienceAll: 'جميع المستخدمين',
    deeplinkSearchUsers: 'ابحث بالاسم أو الهاتف أو البريد الإلكتروني',
    deeplinkSearching: 'جارٍ البحث...',
    deeplinkNoUsersFound: 'لا يوجد مستخدمون',
    deeplinkAdd: 'إضافة',
    deeplinkAdded: 'مضاف',
    deeplinkRemove: 'إزالة',
    deeplinkClearAll: 'إزالة الكل',
    deeplinkSelectedCount: 'تم اختيار {count} من 500 مستخدم',
    deeplinkMaxUsers: 'وصلت إلى الحد الأقصى وهو 500 مستخدم.',
    deeplinkMembersNote:
      'المستخدمون الذين أوقفوا الإشعارات أو لم يثبّتوا التطبيق لن يستلموا الإشعار.',
    deeplinkAllWarning: 'سيُرسل هذا الإشعار إلى كل مستخدم فعّل الإشعارات.',
    deeplinkSend: 'إرسال',
    deeplinkSending: 'جارٍ الإرسال...',
    deeplinkReset: 'إعادة تعيين',
    deeplinkConfirmMembers: 'هل تريد إرسال هذا الإشعار إلى {count} مستخدم؟',
    deeplinkConfirmAllTitle: 'إرسال إلى جميع المستخدمين؟',
    deeplinkConfirmScreen: 'الشاشة',
    deeplinkConfirmTypeSend: 'اكتب SEND للتأكيد',
    deeplinkConfirmTypeSendError: 'اكتب SEND بأحرف كبيرة للمتابعة.',
    deeplinkResultSent: 'تم الإرسال إلى {sent} من {total} مستخدم.',
    deeplinkResultFailed: 'فشل {failed}.',
    deeplinkResultQueued: 'جارٍ الإرسال إلى {total} مستخدم في الخلفية.',
    deeplinkResultNone:
      'لم يتمكن أي مستخدم من استلام الإشعار. ربما أوقفوا الإشعارات أو لم يثبّتوا التطبيق.',
    deeplinkErrorConflict:
      'هناك إرسال آخر إلى جميع المستخدمين ما زال قيد التنفيذ. حاول مرة أخرى بعد بضع دقائق.',
    deeplinkErrorGeneric: 'حدث خطأ ما. حاول مرة أخرى.',
    deeplinkFieldRequired: 'هذا الحقل مطلوب.',
    deeplinkWholeNumber: 'أدخل رقماً صحيحاً موجباً.',
    deeplinkNoSpaces: 'أدخل قيمة بدون مسافات.',
    deeplinkMaxChars: 'الحد الأقصى {max} حرف.',
    deeplinkHttpsOnly: 'يجب أن يبدأ رابط الصورة بـ https://.',
    deeplinkLinkInvalid: 'أدخل رابطاً كاملاً يبدأ بـ https://.',
    deeplinkPickUser: 'اختر مستخدماً واحداً على الأقل.',
    deeplinkTooManyUsers: 'يمكنك اختيار 500 مستخدم كحد أقصى.',
    deeplinkDateOrder: 'يجب ألا يكون تاريخ البداية بعد تاريخ النهاية.',
    deeplinkScreen_ads: 'إعلان',
    'deeplinkScreen_ads-list': 'قائمة الإعلانات',
    deeplinkScreen_auction: 'مزاد',
    'deeplinkScreen_auction-property': 'عقار في مزاد',
    'deeplinkScreen_auctions-upcoming': 'المزادات القادمة',
    'deeplinkScreen_auctions-historical': 'المزادات السابقة',
    'deeplinkScreen_ive-map': 'خريطة التقييم الفوري',
    'deeplinkScreen_ire-residential': 'تقدير الإيجار السكني',
    'deeplinkScreen_ire-investment': 'تقدير الإيجار الاستثماري',
    'deeplinkScreen_hisba-fund': 'صندوق الحسبة',
    'deeplinkScreen_bbyn-finance': 'تمويل بوبيان',
    deeplinkScreen_cce: 'حاسبة تكلفة البناء',
    'deeplinkScreen_ive-form': 'نموذج التقييم الفوري',
    deeplinkScreen_ive: 'نتيجة التقييم الفوري',
    deeplinkScreen_deals: 'الصفقات',
    deeplinkScreen_index: 'المؤشر',
    deeplinkScreen_broker: 'مكتب وساطة',
    deeplinkScreen_packages: 'الباقات',
    'Rejection Reasons': 'أسباب الرفض',
    expertReviewRejectReasonsListing: 'قائمة أسباب الرفض',
    addNewExpertReviewRejectReason: 'إضافة سبب رفض جديد',
    expertReviewRejectReasonCreating: 'إنشاء سبب رفض',
    createNewExpertReviewRejectReason: 'إنشاء سبب رفض جديد',
    expertReviewRejectReasonUpdating: 'تعديل سبب الرفض',
    expertReviewRejectReasonLoadFailed:
      'تعذر تحميل سبب الرفض هذا. ربما تم حذفه.',
    updateExpertReviewRejectReason: 'تعديل سبب الرفض',
    rejectReasonEn: 'سبب الرفض بالإنجليزي',
    rejectReasonAr: 'سبب الرفض بالعربي',
    REASON_EN_IS_REQUIRED_FIELD: 'حقل سبب الرفض بالإنجليزي مطلوب',
    REASON_AR_IS_REQUIRED_FIELD: 'حقل سبب الرفض بالعربي مطلوب',
    SUCCESSFULLY_CREATED_EXPERT_REVIEW_REJECT_REASON:
      'تم إنشاء سبب الرفض بنجاح',
    SUCCESSFULLY_UPDATED_EXPERT_REVIEW_REJECT_REASON:
      'تم تعديل سبب الرفض بنجاح',
    'Expert Review': 'المراجعة الخبيرة',
    expertReviewListing: 'المراجعة الخبيرة',
    expertReviewConsole: 'وحدة المراجعة الخبيرة',
    expertReviewQuarterLabelProvisional: '{quarter} · مبدئي',
    expertReviewQuarterLabelFinal: '{quarter} · نهائي (انتهت فترة السماح)',
    expertReviewProgress: 'تمت مراجعة {done} من {total}',
    expertReviewFilterNeedsReview: 'بحاجة لمراجعة',
    expertReviewFilterHighRisk: 'خطورة عالية',
    expertReviewFilterApproved: 'معتمدة',
    expertReviewQuarterRunning: 'الربع الجاري',
    expertReviewQuarterEnded: 'الربع المنتهي',
    expertReviewFilterAdjusted: 'معدَّلة',
    expertReviewFilterRejected: 'مرفوضة',
    expertReviewFilterAll: 'الكل',
    expertReviewApproveLowRisk: 'اعتماد المناطق منخفضة الخطورة',
    expertReviewEscalationAfter: 'التصعيد بعد',
    expertReviewEscalationSavedToast: 'ساعة — سيتم إشعار المستوى الثاني بعدها',
    expertReviewEscalationSaveFailed: 'تعذر حفظ مدة التصعيد.',
    expertReviewConfirmBulkApprove:
      'سيتم نشر القيمة الجديدة لكل منطقة منخفضة الخطورة ما زالت قيد المراجعة في {quarter}، أينما كانت في اللوحة.',
    expertReviewConfirmApprove:
      'سيتم نشر {value} د.ك/م² كسعر معتمد لمنطقة {area}.',
    expertReviewShortcutMove: 'تنقل',
    expertReviewShortcutApprove: 'اعتماد',
    expertReviewColArea: 'المنطقة',
    expertReviewColPrice: 'السعر د.ك/م²',
    expertReviewColQoq: 'التغير الربعي',
    expertReviewColYoy: 'التغير السنوي',
    expertReviewColDeals: 'الصفقات',
    expertReviewColEvidence: 'الأدلة',
    expertReviewColDecision: 'القرار',
    expertReviewEvidenceOBSERVED: 'مرصود',
    expertReviewEvidenceMIXED: 'مختلط',
    expertReviewEvidenceCLUSTER_CARRIED: 'محمول',
    expertReviewClusterLabel: 'المجموعة {cluster}',
    expertReviewNewValue: 'القيمة الجديدة',
    expertReviewLastApproved: 'آخر قيمة معتمدة',
    expertReviewChange: 'التغير',
    expertReviewCarriedNote: 'لا توجد صفقات خاصة بهذه المنطقة هذا الربع.',
    expertReviewThinNote:
      'مجموعتها تضم {count} صفقة فقط هذا الربع — أقل من حد {threshold} صفقة، لذا فإن وسيط المجموعة نفسه غير مستقر ويمكن لصفقة واحدة أن تحركه بشدة.',
    expertReviewPricePath: 'مسار السعر · آخر 12 ربعاً',
    expertReviewDealsInArea: 'صفقات {area} هذا الربع ({count})',
    expertReviewDealsInCluster: 'صفقات المجموعة {cluster} هذا الربع ({count})',
    expertReviewNoOwnDeals:
      'لا توجد صفقات مسجلة في هذه المنطقة هذا الربع. القيمة محمولة بالكامل من مجموعتها — والأدلة أدناه هي كل ما هو متاح.',
    expertReviewNoClusterDeals:
      'تقع هذه المنطقة في مجموعة خاصة بها وحدها، لذا لا توجد أدلة من مناطق مماثلة. القيمة محمولة من آخر ربع مرصود.',
    expertReviewClusterFlagNote:
      'المظللة: أعلى صفقة في المجموعة هذا الربع — تفوق بقية العينة وترفع وسيط المجموعة.',
    expertReviewReading: 'القراءة',
    expertReviewEvidenceTag: 'تصنيف الأدلة',
    expertReviewQuarterStatus: 'حالة الربع',
    expertReviewQuarterStatusFinal: 'نهائي — مغلق، انتهت فترة السماح',
    expertReviewQuarterStatusProvisional: 'مبدئي — انقضى {percent}% من الربع',
    expertReviewYearOnYear: 'التغير السنوي',
    expertReviewIfRejected: 'في حال الرفض',
    expertReviewIfRejectedFinal: 'تُدخل القيمة التي سيتم نشرها',
    expertReviewIfRejectedProvisional:
      'يعود إلى {value} د.ك/م²، أو تعدّل القيمة التي سيتم نشرها',
    expertReviewNote: 'ملاحظة',
    expertReviewNotePlaceholder: 'اكتب ما لاحظته',
    expertReviewYourValue: 'قيمتك',
    expertReviewAdjustPrice: 'تعديل السعر',
    expertReviewPricePerSqmUnit: 'د.ك/م²',
    expertReviewColType: 'النوع',
    expertReviewColSize: 'المساحة م²',
    expertReviewColPricePerSqm: 'د.ك/م²',
    expertReviewDealBuilding: 'بناية',
    expertReviewDealLand: 'أرض',
    expertReviewReject: 'رفض',
    expertReviewClose: 'إغلاق',
    expertReviewApproveAndPublish: 'اعتماد — نشر {value}',
    expertReviewConfirmRejection: 'تأكيد الرفض',
    expertReviewShortcutReject: 'رفض',
    expertReviewShortcutEvidence: 'الأدلة',
    expertReviewTapForEvidence: 'اضغط لعرض الأدلة ←',
    expertReviewRejectedAdjustedToast: 'تم رفضه — ونُشرت قيمتك {value} د.ك/م²',
    expertReviewRejectedProvisionalToast:
      'تم رفضه — وأُعيد إلى {value} د.ك/م² ويظهر كـ «قيد المراجعة»',
    expertReviewThin: 'عينة ضعيفة {count}',
    expertReviewThinTitle: 'عينة المجموعة ضعيفة',
    expertReviewApprove: 'اعتماد',
    expertReviewApproved: 'معتمد',
    expertReviewPendingDecision: 'قيد المراجعة',
    expertReviewDecisionFailed: 'لم يتم حفظ القرار. يرجى المحاولة مرة أخرى.',
    expertReviewLoadFailed: 'تعذر تحميل القائمة. يتم عرض النتائج السابقة.',
    expertReviewEvidenceLoading: 'جارٍ تحميل الأدلة…',
    expertReviewReasonsLoading: 'جارٍ تحميل أسباب الرفض…',
    expertReviewReasonsFailed:
      'تعذر تحميل أسباب الرفض، لذا لا يمكن رفض هذه المنطقة حالياً.',
    expertReviewEvidenceFailed:
      'تعذر تحميل الأدلة، لذا تم تعطيل القرارات لهذه المنطقة.',
    expertReviewListStale:
      'تم حفظ القرار، لكن تعذر تحديث القائمة. أعد التحميل لعرض أحدث القيم.',
    expertReviewAdjusted: 'معدَّل',
    expertReviewRejected: 'مرفوض',
    expertReviewEmptyFilter: 'لا يوجد شيء هنا. اختر تصنيفاً آخر.',
    expertReviewDealsShort: '{count} صفقة',
    expertReviewYoyShort: 'سنوي {value}',
    expertReviewQoqShort: '{value} ربعي',
    expertReviewApprovedToast: 'تم اعتماده ونشره عند {value} د.ك/م²',
    expertReviewBulkApprovedToast:
      'منطقة منخفضة الخطورة تم اعتمادها — المناطق عالية الخطورة ما زالت تحتاج مراجعتك',
    ADS_DURATION_IS_REQURED_FIELD: 'مدة الإعلان حقل مطلوب',
    AD_TYPE_IS_REQUIRED_FIELD: 'نوع الإعلان حقل مطلوب',
    AGENT_NAME_IS_REQUIRED_FIELD: 'اسم الوكيل حقل مطلوب',
    ALLOWED_USAGE_IS_REQUIRED_FIELD: 'الاستخدام المسموح به حقل مطلوب',
    ALLOWED_USAGE_REQUIRED: 'الاستخدام المسموح به مطلوب',
    AR_CONTENT_IS_REQUIRED_FIELD: 'المحتوى العربي حقل مطلوب',
    AR_TITLE_IS_REQUIRED: 'العنوان العربي مطلوب',
    BLOG_UPDATE_SUCCESS: 'تم تحديث المدونة بنجاح',
    BROKER_NAME_IS_REQUIRED_FIELD: 'اسم الوسيط حقل مطلوب',
    COMPONENT_TYPE_IS_REQUIRED_FIELD: 'نوع المكون حقل مطلوب',
    CONFIG_IS_REQUIRED_FIELD: 'الإعداد حقل مطلوب',
    DISCOUNT_PERCENTAGE_IS_REQUIRED_FIELD: 'نسبة الخصم حقل مطلوبة',
    DISCOUNT_PERCENTAGE_REQUIRED: 'نسبة الخصم مطلوبة',
    DURATION_IS_REQUIRED_FIELD: 'المدة حقل مطلوب',
    DURATION_REQUIRED: 'المدة مطلوبة',
    ENDING_PRICE_IS_REQUIRED_FIELD: 'سعر النهاية حقل مطلوب',
    ENDING_PRICE_MUST_BE_GREATER: 'يجب أن يكون سعر النهاية أكبر من سعر البداية',
    EN_CONTENT_IS_REQUIRED_FIELD: 'المحتوى الإنجليزي حقل مطلوب',
    EN_KEY_IS_REQUIRED_FIELD: 'المفتاح الإنجليزي حقل مطلوب',
    EN_TITLE_IS_REQUIRED: 'العنوان الإنجليزي مطلوب',
    FAILED_TO_FETCH_ORGANIZER: 'فشل في جلب بيانات المنظم',
    GROUP_LABEL_IS_REQUIRED_FIELD: 'تسمية المجموعة حقل مطلوب',
    GROUP_SLUG_IS_REQUIRED_FIELD: 'معرف المجموعة حقل مطلوب',
    HOME_SERVICE_TYPE_IS_REQUIRED_FIELD: 'نوع خدمة المنزل حقل مطلوب',
    INVALID_PHONE_NUMBER: 'رقم الهاتف غير صالح',
    NUMBER_OF_ADS_IS_REQUIRED_FIELD: 'عدد الإعلانات حقل مطلوب',
    OFFERED_PRICE_IS_REQUIRED_FIELD: 'السعر المعروض حقل مطلوب',
    OFFERED_PRICE_REQUIRED: 'السعر المعروض مطلوب',
    PACKAGE_UPDATE_SUCCESS: 'تم تحديث الباقة بنجاح',
    PRICE_MUST_BE_POSITIVE: 'يجب أن يكون السعر رقمًا إيجابيًا',
    PRICE_REQUIRED: 'السعر مطلوب',
    PROMOTION_UPDATE_SUCCESS: 'تم تحديث العرض الترويجي بنجاح',
    PROMO_CODE_IS_REQUIRED_FIELD: 'رمز الترويج حقل مطلوب',
    PROMO_CODE_REQUIRED: 'رمز الترويج مطلوب',
    SLUG_IS_REQUIRED_FIELD: 'المعرف حقل مطلوب',
    SPECIAL_ADS_IS_REQUIRED_FIELD: 'الإعلانات المميزة حقل مطلوب',
    STATUS_IS_REQUIRED: 'الحالة مطلوبة',
    STATUS_IS_REQUIRED_FIELD: 'الحالة حقل مطلوب',
    SUCCESSFULLY_ADDED_AD_Service: 'تمت إضافة خدمة الإعلان بنجاح',
    SUCCESSFULLY_ADDED_SUB_CATEGORIE_OPTIONS:
      'تمت إضافة خيارات الفئة الفرعية بنجاح',
    SUCCESSFULLY_CREATED_AD: 'تم إنشاء الإعلان بنجاح',
    SUCCESSFULLY_CREATED_AUCTION_PROPERTY_GROUPING:
      'تم إنشاء تجميع عقارات المزاد بنجاح',
    SUCCESSFULLY_CREATED_CCE_SUB_CATEGORIE: 'تم إنشاء الفئة الفرعية بنجاح',
    SUCCESSFULLY_CREATED_OFFICE: 'تم إنشاء المكتب بنجاح',
    SUCCESSFULLY_CREATED_SECTOR: 'تم إنشاء القطاع بنجاح',
    SUCCESSFULLY_CREATED_TESTIMONIAL: 'تمت إضافة الشهادة بنجاح',
    SUCCESSFULLY_DELETED: 'تم الحذف بنجاح',
    SUCCESSFULLY_INVALIDATED_OFFICE: 'تم إلغاء صلاحية المكتب بنجاح',
    SUCCESSFULLY_UPDATED_AUCTION_PROPERTY_GROUPING:
      'تم تحديث تجميع عقارات المزاد بنجاح',
    SUCCESSFULLY_UPDATED_BLOG: 'تم تحديث المدونة بنجاح',
    SUCCESSFULLY_UPDATED_CCE_SUB_CATEGORIE: 'تم تحديث الفئة الفرعية بنجاح',
    SUCCESSFULLY_UPDATED_IRE_FACTOR_GENERAL_specs:
      'تم تحديث المواصفات العامة لعامل IRE بنجاح',
    SUCCESSFULLY_UPDATED_NEWS: 'تم تحديث الأخبار بنجاح',
    SUCCESSFULLY_UPDATED_OFFICE: 'تم تحديث المكتب بنجاح',
    SUCCESSFULLY_UPDATED_SECTOR: 'تم تحديث القطاع بنجاح',
    SUCCESSFULLY_UPDATED_STATUS: 'تم تحديث الحالة بنجاح',
    SUCCESSFULLY_UPDATED_TESTIMONIAL: 'تم تحديث الشهادة بنجاح',
    SUCCESSFULLY_UPDATE_SUB_CATEGORIE_OPTIONS:
      'تم تحديث خيارات الفئة الفرعية بنجاح',
    TRANSACTION_DATE_IS_REQUIRED_FIELD: 'تاريخ الصفقة حقل مطلوب',
    TRANSACTION_DATE_TIME_IS_REQUIRED_FIELD: 'تاريخ ووقت الصفقة حقل مطلوب',
    TYPE_IRE_IS_REQUIRED_FIELD: 'نوع IRE حقل مطلوب',
    TYPE_IS_REQUIRED_FIELD: 'النوع حقل مطلوب',
    TYPE_OF_INDEX_IS_REQUIRED_FIELD: 'نوع الفهرس حقل مطلوب',
    UPDATE_FAILED: 'فشل التحديث',
    VALUE_IS_REQUIRED_FIELD: 'القيمة حقل مطلوبة',
    VERIFICATION_STATUS_IS_REQUIRED: 'حالة التحقق مطلوبة',
    AdPriceFrom: 'سعر الإعلان من',
    AdPriceTo: 'سعر الإعلان إلى',
    Amount: 'المبلغ',
    ArabicTitle: 'العنوان العربي',
    Available: 'متاح',
    BasementRentConfig: 'إعداد إيجار الطابق السفلي',
    CceCategoryTooltip: 'تلميح فئة CCE',
    CceGroupTooltip: 'تلميح مجموعة CCE',
    Doc: 'وثيقة',
    Finances: 'المالية',
    From: 'من',
    Government: 'حكومي',
    ID: 'المعرف',
    Image: 'صورة',
    InstantValueSizePanel: 'لوحة حجم القيمة الفورية',
    IreInvestmentFactorsPropertySeriveListing:
      'قائمة خدمة عقارات عوامل الاستثمار IRE',
    IreTypes: 'أنواع IRE',
    Loans: 'القروض',
    LoansFundsUpdating: 'تحديث صناديق القروض',
    'NumOfData ': 'عدد البيانات',
    'PACI Number': 'رقم PACI',
    PackDuration: 'مدة الباقة',
    'Property Status': 'حالة العقار',
    PropertyAgeConfig: 'إعداد عمر العقار',
    Reports: 'التقارير',
    SelectAreas: 'اختر المناطق',
    Services: 'الخدمات',
    To: 'إلى',
    Type: 'النوع',
    'Unit Components List': 'قائمة مكونات الوحدة',
    Unavailable: 'غير متاح',
    'User Name': 'اسم المستخدم',
    WebIcon: 'أيقونة الويب',
    Website: 'الموقع الإلكتروني',
    Weight: 'الوزن',
    adDoc: 'وثيقة الإعلان',
    adTypeTooltip: 'تلميح نوع الإعلان',
    adVideo: 'فيديو الإعلان',
    addNewField: 'إضافة حقل جديد',
    addNewIreStreet: 'إضافة شارع IRE جديد',
    adsServiceDuration: 'مدة خدمة الإعلانات',
    all: 'الكل',
    available: 'متاح',
    avatar: 'الصورة الشخصية',
    back: 'رجوع',
    badgeIcon: 'أيقونة الشارة',
    badges: 'الشارات',
    bank: 'البنك',
    baseSiaze: 'الحجم الأساسي',
    bathrooms: 'الحمامات',
    blog: 'المدونة',
    blogCategoriesUpdating: 'تحديث فئات المدونة',
    client: 'العميل',
    clone: 'نسخ',
    close: 'إغلاق',
    configValue: 'قيمة الإعداد',
    copy: 'نسخ',
    current: 'الحالي',
    decreasePercentage: 'نسبة الانخفاض',
    decreasedBathrooms: 'حمامات منخفضة',
    decreasedMaidRoom: 'غرفة خادمة منخفضة',
    decreasedRooms: 'غرف منخفضة',
    direction: 'الاتجاه',
    disabled: 'معطل',
    duplicateAds: 'إعلانات مكررة',
    duplicates: 'مكررات',
    editPercentages: 'تعديل النسب المئوية',
    editValConfig: 'تعديل إعداد القيمة',
    electricity: 'الكهرباء',
    'electricity ...': 'الكهرباء',
    'electricity..': 'الكهرباء',
    enabled: 'مفعّل',
    endDate: 'تاريخ الانتهاء',
    eventId: 'معرف الحدث',
    export: 'تصدير',
    'facingOptionNameAr Lang': 'اسم خيار الواجهة (عربي)',
    factorOptionIre: 'خيار عامل IRE',
    finalPrice: 'السعر النهائي',
    financesFunds: 'صناديق التمويل',
    firstDecreasedPercentage: 'نسبة الانخفاض الأولى',
    floorTypes: 'أنواع الطوابق',
    governorate: 'المحافظة',
    home: 'الرئيسية',
    homeAdDurationDay: 'مدة الإعلان الرئيسي (أيام)',
    homeAds: 'إعلانات الرئيسية',
    homeAdsDuration: 'مدة الإعلانات الرئيسية',
    homepage: 'الصفحة الرئيسية',
    icon: 'أيقونة',
    increasePercentage: 'نسبة الزيادة',
    increasedBathrooms: 'حمامات مزيدة',
    increasedMaidRoom: 'غرفة خادمة مزيدة',
    increasedRooms: 'غرف مزيدة',
    indices: 'المؤشرات',
    intervals: 'الفترات',
    'ire-commercail': 'IRE تجاري',
    'ire-commercial': 'IRE تجاري',
    'ire-industrial': 'IRE صناعي',
    'ire-investment': 'IRE استثماري',
    'ire-literal': 'IRE حرفي',
    ireAreaTooltip: 'تلميح منطقة IRE',
    ireCommercailFactorsLocationSpecsListing:
      'قائمة مواصفات الموقع لعوامل IRE التجارية',
    ireCommercialFactorsLocationSpecsListing:
      'قائمة مواصفات الموقع لعوامل IRE التجارية',
    ireFactorsQualityssUpdating: 'تحديث جودة عوامل IRE',
    ireIndustrailFactorsLocationSpecsListing:
      'قائمة مواصفات الموقع لعوامل IRE الصناعية',
    ireInvestmentFactorsLocationSpecsListing:
      'قائمة مواصفات الموقع لعوامل IRE الاستثمارية',
    ireLiteralFactorsLocationSpecsListing:
      'قائمة مواصفات الموقع لعوامل IRE الحرفية',
    ireSizesUpdating: 'تحديث أحجام IRE',
    ireV2FloorTypeListing: 'قائمة أنواع الطوابق IRE V2',
    ireV2PropertyAgeListing: 'قائمة أعمار العقارات IRE V2',
    ireV2PropertyTypeListing: 'قائمة أنواع العقارات IRE V2',
    key: 'المفتاح',
    likes: 'الإعجابات',
    'loan Amount': 'مبلغ القرض',
    loansFunds: 'صناديق القروض',
    message: 'الرسالة',
    metadata: 'البيانات الوصفية',
    newsNameArLang: 'اسم الخبر (عربي)',
    newsNameEnLang: 'اسم الخبر (إنجليزي)',
    next: 'التالي',
    noSkip: 'لا تخطى',
    numberOfAds: 'عدد الإعلانات',
    obligations: 'الالتزامات',
    of: 'من',
    offices: 'المكاتب',
    okays: 'حسنًا',
    oneTime: 'مرة واحدة',
    organizerMapLogo: 'شعار خريطة المنظم',
    organizerVideo: 'فيديو المنظم',
    otpGenerated: 'تم إنشاء OTP',
    packageTitleAr: 'عنوان الباقة (عربي)',
    packageTitleEn: 'عنوان الباقة (إنجليزي)',
    page: 'الصفحة',
    pickaMonth: 'اختر شهرًا',
    plotSizeOptionsUpdating: 'تحديث خيارات حجم الأرض',
    preview: 'معاينة',
    previous: 'السابق',
    pricepermeter: 'السعر للمتر',
    promotionTitleAr: 'عنوان الترويج (عربي)',
    promotionTitleEn: 'عنوان الترويج (إنجليزي)',
    properties: 'العقارات',
    propertyCategoryTooltip: 'تلميح فئة العقار',
    propertyTypeText: 'نوع العقار',
    publicity: 'الدعاية',
    purchaseAt: 'تاريخ الشراء',
    query: 'الاستعلام',
    'registered-trades': 'الصفقات المسجلة',
    registeredTradesScrapingCreating: 'إنشاء استخراج الصفقات المسجلة',
    rejection: 'الرفض',
    remove: 'إزالة',
    renew: 'تجديد',
    required: 'مطلوب',
    rooms: 'الغرف',
    salary: 'الراتب',
    seaFrontOptionNameEnLang: 'اسم خيار الواجهة البحرية (إنجليزي)',
    search: 'بحث',
    section: 'القسم',
    sectorsUpdating: 'تحديث القطاعات',
    selectFloorType: 'اختر نوع الطابق',
    selectIreArea: 'اختر منطقة IRE',
    selectIreType: 'اختر نوع IRE',
    selectMerchant: 'اختر التاجر',
    selectNotes: 'اختر الملاحظات',
    selectOption: 'اختر خيارًا',
    selectPropertyTypesCategories: 'اختر فئات أنواع العقارات',
    selectRejectReasons: 'اختر أسباب الرفض',
    seo: 'تحسين محركات البحث',
    seoSchema: 'مخطط SEO',
    service: 'الخدمة',
    shopRentConfig: 'إعداد إيجار المحل',
    source: 'المصدر',
    specialAdDuration: 'مدة الإعلان المميز',
    storedThumbnailUrls: 'روابط الصور المخزنة',
    streets: 'الشوارع',
    streetsIreValuesUpdating: 'تحديث قيم شوارع IRE',
    subscribers: 'المشتركون',
    subscriptionType: 'نوع الاشتراك',
    subscriptionsUpdating: 'تحديث الاشتراكات',
    system: 'النظام',
    title: 'العنوان',
    tryAgain: 'حاول مرة أخرى',
    unverified: 'غير محقق',
    updateIreDirection: 'تحديث اتجاه IRE',
    updateIreFloorType: 'تحديث نوع طابق IRE',
    updateIreQuality: 'تحديث جودة IRE',
    updateIreSize: 'تحديث حجم IRE',
    updateIreStreetValue: 'تحديث قيمة شارع IRE',
    updateIreV2PropertyAge: 'تحديث عمر عقار IRE V2',
    updateIreV2PropertyType: 'تحديث نوع عقار IRE V2',
    updateLoanCalculatorAboutWeb: 'تحديث حاسبة القرض (ويب)',
    user: 'المستخدم',
    verified: 'محقق',
    version: 'الإصدار',
    web: 'الويب',
    weightedScore: 'النقاط المرجحة',
    بلوك: 'بلوك',
    'صفقة تم تصحيحها': 'صفقة تم تصحيحها',
    'صفقة خاطئة': 'صفقة خاطئة',
    'صفقة صحيحة': 'صفقة صحيحة',
    'مشكوك فى صحتها': 'مشكوك فى صحتها',
    titleFirstLine: 'السطر الأول من العنوان',
    titleSecondLine: 'السطر الثاني من العنوان',
    referenceLink: 'الرابط المرجعي',
    valuationType: 'نوع التقييم',
    heroImageUrl: 'رابط الصورة الرئيسية',
    subtitle: 'العنوان الفرعي',
    paragraph2: 'الفقرة الثانية',
    autoGeneratedNote:
      'ملاحظة: إجمالي الصفقات، نسبة التغيير، اتجاه السوق، والفقرة الأولى — تُولَّد تلقائياً من البيانات. فقط الحقول التالية تحتاج إلى إدخال يدوي.',
    buttonText: 'نص الزر',
    trustText: 'نص الثقة',
    link: 'الرابط',
    ctaBannerContent: 'محتوى بانر الدعوة',
    marketActivityContent: 'محتوى نشاط السوق',
    backgroundImage: 'صورة الخلفية',
  },
};

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  globalInjection: true,
  messages,
});

export default i18n;
